let info;

info = [
    // Petroleum Engineers
    {state:'Alabama', amount:'115,180', profession:'Petroleum Engineers'},
    {state:'Alaska', amount:'161,290', profession:'Petroleum Engineers'},
    {state:'Arizona', amount:'137,830', profession:'Petroleum Engineers'},
    {state:'California', amount:'142,430', profession:'Petroleum Engineers'},
    {state:'Colorado', amount:'153,640', profession:'Petroleum Engineers'},
    {state:'Hawaii', amount:'121,050', profession:'Petroleum Engineers'},
    {state:'Illinois', amount:'131,510', profession:'Petroleum Engineers'},
    {state:'Indiana', amount:'198,590', profession:'Petroleum Engineers'},
    {state:'Kansas', amount:'118,160', profession:'Petroleum Engineers'},
    {state:'Louisiana', amount:'145,880', profession:'Petroleum Engineers'},
    {state:'Montana', amount:'141,530', profession:'Petroleum Engineers'},
    {state:'New Jersey', amount:'194,340', profession:'Petroleum Engineers'},
    {state:'North Dakota', amount:'124,880', profession:'Petroleum Engineers'},
    {state:'Ohio', amount:'94,270', profession:'Petroleum Engineers'},
    {state:'Oklahoma', amount:'146,990', profession:'Petroleum Engineers'},
    {state:'Pennsylvania', amount:'122,510', profession:'Petroleum Engineers'},
    {state:'Texas', amount:'169,010', profession:'Petroleum Engineers'},
    {state:'West Virginia', amount:'111,400', profession:'Petroleum Engineers'},
    {state:'Wyoming', amount:'115,250', profession:'Petroleum Engineers'},
    
    // Elevator Installers and Repairers
    {state:'Alabama', amount:'68,030', profession:'Elevator Installers and Repairers'},
    {state:'Arizona', amount:'74,700', profession:'Elevator Installers and Repairers'},
    {state:'Arkansas', amount:'57,040', profession:'Elevator Installers and Repairers'},
    {state:'California', amount:'87,820', profession:'Elevator Installers and Repairers'},
    {state:'Colorado', amount:'78,140', profession:'Elevator Installers and Repairers'},
    {state:'Connecticut', amount:'90,960', profession:'Elevator Installers and Repairers'},
    {state:'Delaware', amount:'76,470', profession:'Elevator Installers and Repairers'},
    {state:'District of Columbia', amount:'80,690', profession:'Elevator Installers and Repairers'},
    {state:'Florida', amount:'60,230', profession:'Elevator Installers and Repairers'},
    {state:'Georgia', amount:'56,840', profession:'Elevator Installers and Repairers'},
    {state:'Hawaii', amount:'86,620', profession:'Elevator Installers and Repairers'},
    {state:'Idaho', amount:'75,640', profession:'Elevator Installers and Repairers'},
    {state:'Illinois', amount:'93,190', profession:'Elevator Installers and Repairers'},
    {state:'Indiana', amount:'78,740', profession:'Elevator Installers and Repairers'},
    {state:'Iowa', amount:'77,570', profession:'Elevator Installers and Repairers'},
    {state:'Kansas', amount:'82,460', profession:'Elevator Installers and Repairers'},
    {state:'Kentucky', amount:'59,780', profession:'Elevator Installers and Repairers'},
    {state:'Maine', amount:'69,750', profession:'Elevator Installers and Repairers'},
    {state:'Maryland', amount:'82,990', profession:'Elevator Installers and Repairers'},
    {state:'Massachusetts', amount:'103,570', profession:'Elevator Installers and Repairers'},
    {state:'Michigan', amount:'82,860', profession:'Elevator Installers and Repairers'},
    {state:'Minnesota', amount:'87,770', profession:'Elevator Installers and Repairers'},
    {state:'Missouri', amount:'70,400', profession:'Elevator Installers and Repairers'},
    {state:'Montana', amount:'83,500', profession:'Elevator Installers and Repairers'},
    {state:'Nevada', amount:'129,890', profession:'Elevator Installers and Repairers'},
    {state:'New Jersey', amount:'72,980', profession:'Elevator Installers and Repairers'},
    {state:'New Mexico', amount:'73,170', profession:'Elevator Installers and Repairers'},
    {state:'New York', amount:'83,110', profession:'Elevator Installers and Repairers'},
    {state:'North Carolina', amount:'63,700', profession:'Elevator Installers and Repairers'},
    {state:'Ohio', amount:'73,930', profession:'Elevator Installers and Repairers'},
    {state:'Oklahoma', amount:'80,410', profession:'Elevator Installers and Repairers'},
    {state:'Oregon', amount:'97,310', profession:'Elevator Installers and Repairers'},
    {state:'Pennsylvania', amount:'83,050', profession:'Elevator Installers and Repairers'},
    {state:'Rhode Island', amount:'65,860', profession:'Elevator Installers and Repairers'},
    {state:'South Carolina', amount:'65,030', profession:'Elevator Installers and Repairers'},
    {state:'Tennessee', amount:'71,290', profession:'Elevator Installers and Repairers'},
    {state:'Texas', amount:'71,510', profession:'Elevator Installers and Repairers'},
    {state:'Utah', amount:'69,720', profession:'Elevator Installers and Repairers'},
    {state:'Virginia', amount:'65,300', profession:'Elevator Installers and Repairers'},
    {state:'Washington', amount:'107,350', profession:'Elevator Installers and Repairers'},
    {state:'West Virginia', amount:'69,350', profession:'Elevator Installers and Repairers'},
    {state:'Wisconsin', amount:'63,610', profession:'Elevator Installers and Repairers'},
    {state:'Puerto Rico', amount:'31,410', profession:'Elevator Installers and Repairers'},

    // Astronomers
    {state:'Arizona', amount:'104,100', profession:'Astronomers'},
    {state:'California', amount:'113,130', profession:'Astronomers'},
    {state:'District of Columbia', amount:'123,640', profession:'Astronomers'},
    {state:'Hawaii', amount:'126,170', profession:'Astronomers'},
    {state:'New Mexico', amount:'78,910', profession:'Astronomers'},
    {state:'Texas', amount:'107,350', profession:'Astronomers'},

    // Phisycists
    {state:'Alabama', amount:'133,930', profession:'Phisycists'},
    {state:'Arizona', amount:'134,390', profession:'Phisycists'},
    {state:'California', amount:'115,970', profession:'Phisycists'},
    {state:'Colorado', amount:'106,490', profession:'Phisycists'},
    {state:'District of Columbia', amount:'144,300', profession:'Phisycists'},
    {state:'Florida', amount:'143,370', profession:'Phisycists'},
    {state:'Georgia', amount:'122,040', profession:'Phisycists'},
    {state:'Hawaii', amount:'126,480', profession:'Phisycists'},
    {state:'Idaho', amount:'114,230', profession:'Phisycists'},
    {state:'Illinois', amount:'114,320', profession:'Phisycists'},
    {state:'Iowa', amount:'123,140', profession:'Phisycists'},
    {state:'Louisiana', amount:'143,000', profession:'Phisycists'},
    {state:'Maine', amount:'121,650', profession:'Phisycists'},
    {state:'Maryland', amount:'120,450', profession:'Phisycists'},
    {state:'Massachusetts', amount:'150,170', profession:'Phisycists'},
    {state:'Michigan', amount:'106,650', profession:'Phisycists'},
    {state:'Minnesota', amount:'155,140', profession:'Phisycists'},
    {state:'Mississippi', amount:'101,420', profession:'Phisycists'},
    {state:'Missouri', amount:'114,890', profession:'Phisycists'},
    {state:'New Hampshire', amount:'130,150', profession:'Phisycists'},
    {state:'New Jersey', amount:'134,280', profession:'Phisycists'},
    {state:'New Mexico', amount:'149,910', profession:'Phisycists'},
    {state:'New York', amount:'138,920', profession:'Phisycists'},
    {state:'North Carolina', amount:'143,070', profession:'Phisycists'},
    {state:'Ohio', amount:'122,370', profession:'Phisycists'},
    {state:'Oklahoma', amount:'164,190', profession:'Phisycists'},
    {state:'Oregon', amount:'124,410', profession:'Phisycists'},
    {state:'Pennsylvania', amount:'137,060', profession:'Phisycists'},
    {state:'South Carolina', amount:'129,860', profession:'Phisycists'},
    {state:'Tennessee', amount:'124,950', profession:'Phisycists'},
    {state:'Texas', amount:'118,300', profession:'Phisycists'},
    {state:'Utah', amount:'129,480', profession:'Phisycists'},
    {state:'Vermont', amount:'111,080', profession:'Phisycists'},
    {state:'Virginia', amount:'108,440', profession:'Phisycists'},
    {state:'Washington', amount:'110,710', profession:'Phisycists'},
    {state:'Wisconsin', amount:'150,670', profession:'Phisycists'},

    // Family and General Practitioners
    {state:'Alabama', amount:'211,550', profession:'Family and General Practitioners'},
    {state:'Alaska', amount:'227,730', profession:'Family and General Practitioners'},
    {state:'Arizona', amount:'209,810', profession:'Family and General Practitioners'},
    {state:'Arkansas', amount:'228,620', profession:'Family and General Practitioners'},
    {state:'California', amount:'197,860', profession:'Family and General Practitioners'},
    {state:'Colorado', amount:'220,960', profession:'Family and General Practitioners'},
    {state:'Connecticut', amount:'199,890', profession:'Family and General Practitioners'},
    {state:'Delaware', amount:'214,170', profession:'Family and General Practitioners'},
    {state:'District of Columbia', amount:'162,830', profession:'Family and General Practitioners'},
    {state:'Florida', amount:'216,020', profession:'Family and General Practitioners'},
    {state:'Georgia', amount:'190,950', profession:'Family and General Practitioners'},
    {state:'Hawaii', amount:'231,750', profession:'Family and General Practitioners'},
    {state:'Idaho', amount:'234,810', profession:'Family and General Practitioners'},
    {state:'Illinois', amount:'213,340', profession:'Family and General Practitioners'},
    {state:'Indiana', amount:'207,480', profession:'Family and General Practitioners'},
    {state:'Iowa', amount:'246,670', profession:'Family and General Practitioners'},
    {state:'Kansas', amount:'215,450', profession:'Family and General Practitioners'},
    {state:'Kentucky', amount:'211,670', profession:'Family and General Practitioners'},
    {state:'Louisiana', amount:'217,580', profession:'Family and General Practitioners'},
    {state:'Maine', amount:'202,440', profession:'Family and General Practitioners'},
    {state:'Maryland', amount:'199,300', profession:'Family and General Practitioners'},
    {state:'Massachusetts', amount:'218,340', profession:'Family and General Practitioners'},
    {state:'Michigan', amount:'207,110', profession:'Family and General Practitioners'},
    {state:'Minnesota', amount:'221,700', profession:'Family and General Practitioners'},
    {state:'Mississippi', amount:'227,390', profession:'Family and General Practitioners'},
    {state:'Missouri', amount:'191,110', profession:'Family and General Practitioners'},
    {state:'Montana', amount:'214,710', profession:'Family and General Practitioners'},
    {state:'Nebraska', amount:'237,320', profession:'Family and General Practitioners'},
    {state:'Nevada', amount:'202,430', profession:'Family and General Practitioners'},
    {state:'New Hampshire', amount:'264,470', profession:'Family and General Practitioners'},
    {state:'New Jersey', amount:'224,640', profession:'Family and General Practitioners'},
    {state:'New Mexico', amount:'176,120', profession:'Family and General Practitioners'},
    {state:'New York', amount:'192,900', profession:'Family and General Practitioners'},
    {state:'North Carolina', amount:'221,220', profession:'Family and General Practitioners'},
    {state:'Ohio', amount:'193,140', profession:'Family and General Practitioners'},
    {state:'Oklahoma', amount:'225,140', profession:'Family and General Practitioners'},
    {state:'Oregon', amount:'226,030', profession:'Family and General Practitioners'},
    {state:'Pennsylvania', amount:'208,470', profession:'Family and General Practitioners'},
    {state:'Rhode Island', amount:'175,250', profession:'Family and General Practitioners'},
    {state:'South Carolina', amount:'235,790', profession:'Family and General Practitioners'},
    {state:'South Dakota', amount:'214,030', profession:'Family and General Practitioners'},
    {state:'Tennessee', amount:'212,900', profession:'Family and General Practitioners'},
    {state:'Texas', amount:'213,620', profession:'Family and General Practitioners'},
    {state:'Utah', amount:'195,610', profession:'Family and General Practitioners'},
    {state:'Vermont', amount:'219,620', profession:'Family and General Practitioners'},
    {state:'Virginia', amount:'201,120', profession:'Family and General Practitioners'},
    {state:'Washington', amount:'226,600', profession:'Family and General Practitioners'},
    {state:'West Virginia', amount:'214,270', profession:'Family and General Practitioners'},
    {state:'Wisconsin', amount:'249,110', profession:'Family and General Practitioners'},
    {state:'Wyoming', amount:'222,750', profession:'Family and General Practitioners'},
    {state:'Guam', amount:'186,760', profession:'Family and General Practitioners'},
    {state:'Puerto Rico', amount:'86,970', profession:'Family and General Practitioners'},

    //Internists, General
    {state:'Alabama', amount:'236,850', profession:'Internists, General'},
    {state:'Alaska', amount:'226,770', profession:'Internists, General'},
    {state:'Arizona', amount:'217,820', profession:'Internists, General'},
    {state:'Arkansas', amount:'220,010', profession:'Internists, General'},
    {state:'California', amount:'207,050', profession:'Internists, General'},
    {state:'Colorado', amount:'220,070', profession:'Internists, General'},
    {state:'Connecticut', amount:'236,460', profession:'Internists, General'},
    {state:'Delaware', amount:'182,950', profession:'Internists, General'},
    {state:'District of Columbia', amount:'150,430', profession:'Internists, General'},
    {state:'Florida', amount:'204,230', profession:'Internists, General'},
    {state:'Georgia', amount:'111,250', profession:'Internists, General'},
    {state:'Hawaii', amount:'212,360', profession:'Internists, General'},
    {state:'Idaho', amount:'195,330', profession:'Internists, General'},
    {state:'Illinois', amount:'195,610', profession:'Internists, General'},
    {state:'Indiana', amount:'197,370', profession:'Internists, General'},
    {state:'Iowa', amount:'211,250', profession:'Internists, General'},
    {state:'Kansas', amount:'197,440', profession:'Internists, General'},
    {state:'Kentucky', amount:'194,150', profession:'Internists, General'},
    {state:'Louisiana', amount:'194,910', profession:'Internists, General'},
    {state:'Maine', amount:'236,220', profession:'Internists, General'},
    {state:'Maryland', amount:'177,670', profession:'Internists, General'},
    {state:'Massachusetts', amount:'246,240', profession:'Internists, General'},
    {state:'Minnesota', amount:'251,310', profession:'Internists, General'},
    {state:'Mississippi', amount:'240,050', profession:'Internists, General'},
    {state:'Missouri', amount:'230,620', profession:'Internists, General'},
    {state:'Montana', amount:'205,220', profession:'Internists, General'},
    {state:'Nebraska', amount:'259,500', profession:'Internists, General'},
    {state:'Nevada', amount:'260,100', profession:'Internists, General'},
    {state:'New Hampshire', amount:'265,930', profession:'Internists, General'},
    {state:'New Jersey', amount:'249,200', profession:'Internists, General'},
    {state:'New Mexico', amount:'267,630', profession:'Internists, General'},
    {state:'New York', amount:'195,250', profession:'Internists, General'},
    {state:'North Carolina', amount:'260,860', profession:'Internists, General'},
    {state:'North Dakota', amount:'191,700', profession:'Internists, General'},
    {state:'Ohio', amount:'219,910', profession:'Internists, General'},
    {state:'Oklahoma', amount:'216,910', profession:'Internists, General'},
    {state:'Oregon', amount:'251,050', profession:'Internists, General'},
    {state:'Pennsylvania', amount:'208,400', profession:'Internists, General'},
    {state:'Rhode Island', amount:'195,430', profession:'Internists, General'},
    {state:'South Carolina', amount:'223,900', profession:'Internists, General'},
    {state:'South Dakota', amount:'287,890', profession:'Internists, General'},
    {state:'Tennessee', amount:'208,860', profession:'Internists, General'},
    {state:'Texas', amount:'145,230', profession:'Internists, General'},
    {state:'Utah', amount:'229,850', profession:'Internists, General'},
    {state:'Vermont', amount:'221,310', profession:'Internists, General'},
    {state:'Virginia', amount:'224,700', profession:'Internists, General'},
    {state:'Washington', amount:'220,150', profession:'Internists, General'},
    {state:'Wisconsin', amount:'251,480', profession:'Internists, General'},
    {state:'Wyoming', amount:'275,350', profession:'Internists, General'},
    {state:'Puerto Rico', amount:'88,260', profession:'Internists, General'},

    // Architectural and Engineering Managers
    {state:'Alabama', amount:'138,470', profession:'Architectural and Engineering Managers'},
    {state:'Alaska', amount:'151,640', profession:'Architectural and Engineering Managers'},
    {state:'Arizona', amount:'133,860', profession:'Architectural and Engineering Managers'},
    {state:'Arkansas', amount:'121,390', profession:'Architectural and Engineering Managers'},
    {state:'California', amount:'175,010', profession:'Architectural and Engineering Managers'},
    {state:'Colorado', amount:'172,300', profession:'Architectural and Engineering Managers'},
    {state:'Connecticut', amount:'143,920', profession:'Architectural and Engineering Managers'},
    {state:'Delaware', amount:'157,490', profession:'Architectural and Engineering Managers'},
    {state:'District of Columbia', amount:'152,130', profession:'Architectural and Engineering Managers'},
    {state:'Florida', amount:'129,850', profession:'Architectural and Engineering Managers'},
    {state:'Georgia', amount:'142,240', profession:'Architectural and Engineering Managers'},
    {state:'Hawaii', amount:'140,610', profession:'Architectural and Engineering Managers'},
    {state:'Idaho', amount:'117,930', profession:'Architectural and Engineering Managers'},
    {state:'Illinois', amount:'136,270', profession:'Architectural and Engineering Managers'},
    {state:'Indiana', amount:'123,180', profession:'Architectural and Engineering Managers'},
    {state:'Iowa', amount:'119,230', profession:'Architectural and Engineering Managers'},
    {state:'Kansas', amount:'129,220', profession:'Architectural and Engineering Managers'},
    {state:'Kentucky', amount:'117,490', profession:'Architectural and Engineering Managers'},
    {state:'Louisiana', amount:'151,220', profession:'Architectural and Engineering Managers'},
    {state:'Maine', amount:'124,230', profession:'Architectural and Engineering Managers'},
    {state:'Maryland', amount:'145,470', profession:'Architectural and Engineering Managers'},
    {state:'Massachusetts', amount:'156,250', profession:'Architectural and Engineering Managers'},
    {state:'Michigan', amount:'132,810', profession:'Architectural and Engineering Managers'},
    {state:'Minnesota', amount:'143,440', profession:'Architectural and Engineering Managers'},
    {state:'Mississippi', amount:'122,550', profession:'Architectural and Engineering Managers'},
    {state:'Missouri', amount:'138,520', profession:'Architectural and Engineering Managers'},
    {state:'Montana', amount:'125,330', profession:'Architectural and Engineering Managers'},
    {state:'Nebraska', amount:'126,970', profession:'Architectural and Engineering Managers'},
    {state:'Nevada', amount:'141,210', profession:'Architectural and Engineering Managers'},
    {state:'New Hampshire', amount:'158,150', profession:'Architectural and Engineering Managers'},
    {state:'New Jersey', amount:'163,440', profession:'Architectural and Engineering Managers'},
    {state:'New Mexico', amount:'163,260', profession:'Architectural and Engineering Managers'},
    {state:'New York', amount:'161,670', profession:'Architectural and Engineering Managers'},
    {state:'North Carolina', amount:'140,980', profession:'Architectural and Engineering Managers'},
    {state:'North Dakota', amount:'122,500', profession:'Architectural and Engineering Managers'},
    {state:'Ohio', amount:'135,360', profession:'Architectural and Engineering Managers'},
    {state:'Oklahoma', amount:'137,560', profession:'Architectural and Engineering Managers'},
    {state:'Oregon', amount:'133,490', profession:'Architectural and Engineering Managers'},
    {state:'Pennsylvania', amount:'150,400', profession:'Architectural and Engineering Managers'},
    {state:'Rhode Island', amount:'151,670', profession:'Architectural and Engineering Managers'},
    {state:'South Carolina', amount:'132,810', profession:'Architectural and Engineering Managers'},
    {state:'South Dakota', amount:'130,230', profession:'Architectural and Engineering Managers'},
    {state:'Tennessee', amount:'129,320', profession:'Architectural and Engineering Managers'},
    {state:'Texas', amount:'167,280', profession:'Architectural and Engineering Managers'},
    {state:'Utah', amount:'128,980', profession:'Architectural and Engineering Managers'},
    {state:'Vermont', amount:'136,420', profession:'Architectural and Engineering Managers'},
    {state:'Virginia', amount:'164,300', profession:'Architectural and Engineering Managers'},
    {state:'Washington', amount:'154,620', profession:'Architectural and Engineering Managers'},
    {state:'West Virginia', amount:'139,030', profession:'Architectural and Engineering Managers'},
    {state:'Wisconsin', amount:'122,400', profession:'Architectural and Engineering Managers'},
    {state:'Wyoming', amount:'130,590', profession:'Architectural and Engineering Managers'},
    {state:'Guam', amount:'86,980', profession:'Architectural and Engineering Managers'},
    {state:'Puerto Rico', amount:'100,990', profession:'Architectural and Engineering Managers'},

    // Air Traffic Controllers
    {state:'Alabama', amount:'94,370', profession:'Air Traffic Controllers'},
    {state:'Alaska', amount:'112,260', profession:'Air Traffic Controllers'},
    {state:'Arizona', amount:'110,370', profession:'Air Traffic Controllers'},
    {state:'Arkansas', amount:'93,370', profession:'Air Traffic Controllers'},
    {state:'California', amount:'132,300', profession:'Air Traffic Controllers'},
    {state:'Colorado', amount:'128,210', profession:'Air Traffic Controllers'},
    {state:'Connecticut', amount:'88,360', profession:'Air Traffic Controllers'},
    {state:'District of Columbia', amount:'75,670', profession:'Air Traffic Controllers'},
    {state:'Georgia', amount:'136,210', profession:'Air Traffic Controllers'},
    {state:'Hawaii', amount:'110,050', profession:'Air Traffic Controllers'},
    {state:'Idaho', amount:'94,910', profession:'Air Traffic Controllers'},
    {state:'Illinois', amount:'136,390', profession:'Air Traffic Controllers'},
    {state:'Indiana', amount:'122,470', profession:'Air Traffic Controllers'},
    {state:'Iowa', amount:'82,460', profession:'Air Traffic Controllers'},
    {state:'Kansas', amount:'122,510', profession:'Air Traffic Controllers'},
    {state:'Kentucky', amount:'104,890', profession:'Air Traffic Controllers'},
    {state:'Louisiana', amount:'86,070', profession:'Air Traffic Controllers'},
    {state:'Maryland', amount:'117,610', profession:'Air Traffic Controllers'},
    {state:'Massachusetts', amount:'109,430', profession:'Air Traffic Controllers'},
    {state:'Michigan', amount:'111,830', profession:'Air Traffic Controllers'},
    {state:'Minnesota', amount:'131,330', profession:'Air Traffic Controllers'},
    {state:'Mississippi', amount:'84,240', profession:'Air Traffic Controllers'},
    {state:'Missouri', amount:'101,280', profession:'Air Traffic Controllers'},
    {state:'Montana', amount:'77,150', profession:'Air Traffic Controllers'},
    {state:'Nebraska', amount:'92,720', profession:'Air Traffic Controllers'},
    {state:'Nevada', amount:'119,600', profession:'Air Traffic Controllers'},
    {state:'New Hampshire', amount:'147,350', profession:'Air Traffic Controllers'},
    {state:'New Jersey', amount:'118,380', profession:'Air Traffic Controllers'},
    {state:'New Mexico', amount:'114,890', profession:'Air Traffic Controllers'},
    {state:'New York', amount:'130,840', profession:'Air Traffic Controllers'},
    {state:'North Carolina', amount:'109,000', profession:'Air Traffic Controllers'},
    {state:'North Dakota', amount:'85,760', profession:'Air Traffic Controllers'},
    {state:'Ohio', amount:'131,180', profession:'Air Traffic Controllers'},
    {state:'Oklahoma', amount:'109,280', profession:'Air Traffic Controllers'},
    {state:'Oregon', amount:'95,570', profession:'Air Traffic Controllers'},
    {state:'Pennsylvania', amount:'115,040', profession:'Air Traffic Controllers'},
    {state:'South Carolina', amount:'92,070', profession:'Air Traffic Controllers'},
    {state:'South Dakota', amount:'82,580', profession:'Air Traffic Controllers'},
    {state:'Texas', amount:'133,260', profession:'Air Traffic Controllers'},
    {state:'Utah', amount:'118,410', profession:'Air Traffic Controllers'},
    {state:'Vermont', amount:'81,630', profession:'Air Traffic Controllers'},
    {state:'Virginia', amount:'139,520', profession:'Air Traffic Controllers'},
    {state:'West Virginia', amount:'79,710', profession:'Air Traffic Controllers'},
    {state:'Wisconsin', amount:'100,500', profession:'Air Traffic Controllers'},
    {state:'Guam', amount:'93,100', profession:'Air Traffic Controllers'},
    {state:'Puerto Rico', amount:'92,770', profession:'Air Traffic Controllers'},

    // Commercial Pilots
    {state:'Alabama', amount:'91,100', profession:'Commercial Pilots'},
    {state:'Alaska', amount:'91,850', profession:'Commercial Pilots'},
    {state:'Arizona', amount:'80,000', profession:'Commercial Pilots'},
    {state:'Arkansas', amount:'78,310', profession:'Commercial Pilots'},
    {state:'California', amount:'97,720', profession:'Commercial Pilots'},
    {state:'Colorado', amount:'91,930', profession:'Commercial Pilots'},
    {state:'Connecticut', amount:'127,950', profession:'Commercial Pilots'},
    {state:'Delaware', amount:'97,420', profession:'Commercial Pilots'},
    {state:'Florida', amount:'110,540', profession:'Commercial Pilots'},
    {state:'Georgia', amount:'130,760', profession:'Commercial Pilots'},
    {state:'Hawaii', amount:'102,350', profession:'Commercial Pilots'},
    {state:'Idaho', amount:'76,310', profession:'Commercial Pilots'},
    {state:'Illinois', amount:'99,990', profession:'Commercial Pilots'},
    {state:'Indiana', amount:'75,790', profession:'Commercial Pilots'},
    {state:'Iowa', amount:'92,090', profession:'Commercial Pilots'},
    {state:'Kansas', amount:'96,370', profession:'Commercial Pilots'},
    {state:'Kentucky', amount:'106,470', profession:'Commercial Pilots'},
    {state:'Louisiana', amount:'85,440', profession:'Commercial Pilots'},
    {state:'Maine', amount:'58,540', profession:'Commercial Pilots'},
    {state:'Maryland', amount:'110,240', profession:'Commercial Pilots'},
    {state:'Massachusetts', amount:'97,740', profession:'Commercial Pilots'},
    {state:'Michigan', amount:'93,640', profession:'Commercial Pilots'},
    {state:'Minnesota', amount:'106,300', profession:'Commercial Pilots'},
    {state:'Mississippi', amount:'103,000', profession:'Commercial Pilots'},
    {state:'Missouri', amount:'93,420', profession:'Commercial Pilots'},
    {state:'Montana', amount:'82,290', profession:'Commercial Pilots'},
    {state:'Nebraska', amount:'79,700', profession:'Commercial Pilots'},
    {state:'Nevada', amount:'102,590', profession:'Commercial Pilots'},
    {state:'New Hampshire', amount:'66,240', profession:'Commercial Pilots'},
    {state:'New Jersey', amount:'93,440', profession:'Commercial Pilots'},
    {state:'New Mexico', amount:'99,400', profession:'Commercial Pilots'},
    {state:'New York', amount:'127,590', profession:'Commercial Pilots'},
    {state:'North Carolina', amount:'82,060', profession:'Commercial Pilots'},
    {state:'North Dakota', amount:'82,880', profession:'Commercial Pilots'},
    {state:'Ohio', amount:'88,830', profession:'Commercial Pilots'},
    {state:'Oklahoma', amount:'80,300', profession:'Commercial Pilots'},
    {state:'Oregon', amount:'70,900', profession:'Commercial Pilots'},
    {state:'Pennsylvania', amount:'89,030', profession:'Commercial Pilots'},
    {state:'South Carolina', amount:'106,170', profession:'Commercial Pilots'},
    {state:'South Dakota', amount:'63,090', profession:'Commercial Pilots'},
    {state:'Tennessee', amount:'72,300', profession:'Commercial Pilots'},
    {state:'Texas', amount:'104,680', profession:'Commercial Pilots'},
    {state:'Utah', amount:'77,550', profession:'Commercial Pilots'},
    {state:'Vermont', amount:'84,610', profession:'Commercial Pilots'},
    {state:'Washington', amount:'106,360', profession:'Commercial Pilots'},
    {state:'West Virginia', amount:'75,890', profession:'Commercial Pilots'},
    {state:'Wisconsin', amount:'80,520', profession:'Commercial Pilots'},
    {state:'Wyoming', amount:'77,970', profession:'Commercial Pilots'},

    // Airline Pilots, Copilots, and Flight Engineers
    {state:'Alabama', amount:'103,750', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Alaska', amount:'148,820', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Arizona', amount:'132,250', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Arkansas', amount:'96,690', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'California', amount:'205,520', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Colorado', amount:'196,670', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Connecticut', amount:'116,930', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Florida', amount:'188,400', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Illinois', amount:'193,600', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Indiana', amount:'124,270', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Iowa', amount:'118,700', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Kansas', amount:'102,190', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Louisiana', amount:'101,010', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Michigan', amount:'233,550', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Minnesota', amount:'103,930', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Mississippi', amount:'94,760', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Missouri', amount:'123,820', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Nebraska', amount:'106,480', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Nevada', amount:'220,400', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'New Hampshire', amount:'122,810', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'New Mexico', amount:'163,030', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'New York', amount:'108,420', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'North Carolina', amount:'102,660', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'North Dakota', amount:'104,660', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Ohio', amount:'119,320', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Oklahoma', amount:'107,960', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Oregon', amount:'205,660', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Pennsylvania', amount:'151,390', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'South Carolina', amount:'102,990', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Tennessee', amount:'85,550', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Texas', amount:'200,320', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Utah', amount:'104,230', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Washington', amount:'237,150', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'West Virginia', amount:'85,490', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Wisconsin', amount:'106,240', profession:'Airline Pilots, Copilots, and Flight Engineers'},
    {state:'Puerto Rico', amount:'78,590', profession:'Airline Pilots, Copilots, and Flight Engineers'},

    // Captains, Mates, and Pilots of Water Vessel
    {state:'Alabama', amount:'79,750', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Alaska', amount:'72,570', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'California', amount:'70,840', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Delaware', amount:'74,790', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Florida', amount:'78,880', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Georgia', amount:'73,410', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Hawaii', amount:'52,830', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Illinois', amount:'67,020', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Iowa', amount:'75,600', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Kentucky', amount:'79,130', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Louisiana', amount:'93,010', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Maine', amount:'61,410', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Maryland', amount:'86,460', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Massachusetts', amount:'57,700', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Michigan', amount:'83,040', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Minnesota', amount:'73,910', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'New Hampshire', amount:'51,490', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'New Jersey', amount:'75,170', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'New York', amount:'95,370', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'North Carolina', amount:'55,710', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Ohio', amount:'47,810', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Oregon', amount:'100,150', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Pennsylvania', amount:'74,780', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'South Carolina', amount:'67,090', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Tennessee', amount:'54,480', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Texas', amount:'103,950', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Virginia', amount:'77,370', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Washington', amount:'90,890', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Wisconsin', amount:'48,190', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Puerto Rico', amount:'45,990', profession:'Captains, Mates, and Pilots of Water Vessel'},
    {state:'Virgin Islands', amount:'47,060', profession:'Captains, Mates, and Pilots of Water Vessel'},

    // Surgical Technologists
    {state:'Alabama', amount:'36,630', profession:'Surgical Technologists'},
    {state:'Alaska', amount:'63,930', profession:'Surgical Technologists'},
    {state:'Arizona', amount:'50,680', profession:'Surgical Technologists'},
    {state:'Arkansas', amount:'42,720', profession:'Surgical Technologists'},
    {state:'California', amount:'60,940', profession:'Surgical Technologists'},
    {state:'Colorado', amount:'53,620', profession:'Surgical Technologists'},
    {state:'Connecticut', amount:'56,750', profession:'Surgical Technologists'},
    {state:'Delaware', amount:'47,250', profession:'Surgical Technologists'},
    {state:'District of Columbia', amount:'59,280', profession:'Surgical Technologists'},
    {state:'Florida', amount:'44,030', profession:'Surgical Technologists'},
    {state:'Georgia', amount:'44,830', profession:'Surgical Technologists'},
    {state:'Hawaii', amount:'54,240', profession:'Surgical Technologists'},
    {state:'Idaho', amount:'51,330', profession:'Surgical Technologists'},
    {state:'Illinois', amount:'49,730', profession:'Surgical Technologists'},
    {state:'Indiana', amount:'45,640', profession:'Surgical Technologists'},
    {state:'Iowa', amount:'41,080', profession:'Surgical Technologists'},
    {state:'Kansas', amount:'42,290', profession:'Surgical Technologists'},
    {state:'Kentucky', amount:'45,520', profession:'Surgical Technologists'},
    {state:'Louisiana', amount:'39,990', profession:'Surgical Technologists'},
    {state:'Maine', amount:'46,450', profession:'Surgical Technologists'},
    {state:'Maryland', amount:'56,130', profession:'Surgical Technologists'},
    {state:'Massachusetts', amount:'55,440', profession:'Surgical Technologists'},
    {state:'Michigan', amount:'43,280', profession:'Surgical Technologists'},
    {state:'Minnesota', amount:'58,630', profession:'Surgical Technologists'},
    {state:'Mississippi', amount:'39,700', profession:'Surgical Technologists'},
    {state:'Missouri', amount:'43,070', profession:'Surgical Technologists'},
    {state:'Montana', amount:'49,440', profession:'Surgical Technologists'},
    {state:'Nebraska', amount:'45,280', profession:'Surgical Technologists'},
    {state:'Nevada', amount:'59,040', profession:'Surgical Technologists'},
    {state:'New Hampshire', amount:'50,660', profession:'Surgical Technologists'},
    {state:'New Jersey', amount:'53,740', profession:'Surgical Technologists'},
    {state:'New Mexico', amount:'44,110', profession:'Surgical Technologists'},
    {state:'New York', amount:'55,310', profession:'Surgical Technologists'},
    {state:'North Carolina', amount:'43,940', profession:'Surgical Technologists'},
    {state:'North Dakota', amount:'45,000', profession:'Surgical Technologists'},
    {state:'Ohio', amount:'47,400', profession:'Surgical Technologists'},
    {state:'Oklahoma', amount:'41,800', profession:'Surgical Technologists'},
    {state:'Oregon', amount:'54,280', profession:'Surgical Technologists'},
    {state:'Pennsylvania', amount:'44,940', profession:'Surgical Technologists'},
    {state:'Rhode Island', amount:'50,700', profession:'Surgical Technologists'},
    {state:'South Carolina', amount:'39,970', profession:'Surgical Technologists'},
    {state:'South Dakota', amount:'40,970', profession:'Surgical Technologists'},
    {state:'Tennessee', amount:'43,860', profession:'Surgical Technologists'},
    {state:'Texas', amount:'49,410', profession:'Surgical Technologists'},
    {state:'Utah', amount:'44,300', profession:'Surgical Technologists'},
    {state:'Vermont', amount:'43,880', profession:'Surgical Technologists'},
    {state:'Virginia', amount:'50,790', profession:'Surgical Technologists'},
    {state:'Washington', amount:'58,320', profession:'Surgical Technologists'},
    {state:'West Virginia', amount:'37,390', profession:'Surgical Technologists'},
    {state:'Wisconsin', amount:'53,870', profession:'Surgical Technologists'},
    {state:'Wyoming', amount:'43,430', profession:'Surgical Technologists'},
    {state:'Puerto Rico', amount:'21,490', profession:'Surgical Technologists'},

    // Radiation Therapists
    {state:'Alabama', amount:'86,020', profession:'Radiation Therapists'},
    {state:'Arizona', amount:'84,990', profession:'Radiation Therapists'},
    {state:'Arkansas', amount:'70,940', profession:'Radiation Therapists'},
    {state:'California', amount:'114,280', profession:'Radiation Therapists'},
    {state:'Colorado', amount:'92,670', profession:'Radiation Therapists'},
    {state:'Connecticut', amount:'105,570', profession:'Radiation Therapists'},
    {state:'Delaware', amount:'96,610', profession:'Radiation Therapists'},
    {state:'District of Columbia', amount:'78,610', profession:'Radiation Therapists'},
    {state:'Florida', amount:'86,420', profession:'Radiation Therapists'},
    {state:'Georgia', amount:'86,510', profession:'Radiation Therapists'},
    {state:'Idaho', amount:'86,830', profession:'Radiation Therapists'},
    {state:'Illinois', amount:'86,200', profession:'Radiation Therapists'},
    {state:'Indiana', amount:'82,920', profession:'Radiation Therapists'},
    {state:'Iowa', amount:'78,260', profession:'Radiation Therapists'},
    {state:'Kansas', amount:'66,310', profession:'Radiation Therapists'},
    {state:'Kentucky', amount:'83,950', profession:'Radiation Therapists'},
    {state:'Louisiana', amount:'69,340', profession:'Radiation Therapists'},
    {state:'Maine', amount:'87,000', profession:'Radiation Therapists'},
    {state:'Maryland', amount:'89,120', profession:'Radiation Therapists'},
    {state:'Massachusetts', amount:'93,540', profession:'Radiation Therapists'},
    {state:'Michigan', amount:'79,720', profession:'Radiation Therapists'},
    {state:'Minnesota', amount:'83,270', profession:'Radiation Therapists'},
    {state:'Mississippi', amount:'83,130', profession:'Radiation Therapists'},
    {state:'Missouri', amount:'75,340', profession:'Radiation Therapists'},
    {state:'Montana', amount:'81,580', profession:'Radiation Therapists'},
    {state:'Nebraska', amount:'83,260', profession:'Radiation Therapists'},
    {state:'Nevada', amount:'87,940', profession:'Radiation Therapists'},
    {state:'New Hampshire', amount:'92,770', profession:'Radiation Therapists'},
    {state:'New Jersey', amount:'107,850', profession:'Radiation Therapists'},
    {state:'New Mexico', amount:'89,230', profession:'Radiation Therapists'},
    {state:'New York', amount:'99,710', profession:'Radiation Therapists'},
    {state:'North Carolina', amount:'76,000', profession:'Radiation Therapists'},
    {state:'Ohio', amount:'81,420', profession:'Radiation Therapists'},
    {state:'Oklahoma', amount:'75,080', profession:'Radiation Therapists'},
    {state:'Oregon', amount:'105,970', profession:'Radiation Therapists'},
    {state:'Pennsylvania', amount:'82,660', profession:'Radiation Therapists'},
    {state:'Rhode Island', amount:'94,110', profession:'Radiation Therapists'},
    {state:'South Carolina', amount:'88,850', profession:'Radiation Therapists'},
    {state:'South Dakota', amount:'83,790', profession:'Radiation Therapists'},
    {state:'Tennessee', amount:'73,490', profession:'Radiation Therapists'},
    {state:'Texas', amount:'84,460', profession:'Radiation Therapists'},
    {state:'Utah', amount:'85,760', profession:'Radiation Therapists'},
    {state:'Vermont', amount:'91,440', profession:'Radiation Therapists'},
    {state:'Virginia', amount:'81,550', profession:'Radiation Therapists'},
    {state:'Washington', amount:'101,830', profession:'Radiation Therapists'},
    {state:'West Virginia', amount:'61,230', profession:'Radiation Therapists'},
    {state:'Wisconsin', amount:'75,850', profession:'Radiation Therapists'},
    {state:'Puerto Rico', amount:'31,150', profession:'Radiation Therapists'},

    // Interpreters and Translators
    {state:'Alabama', amount:'40,510', profession:'Interpreters and Translators'},
    {state:'Alaska', amount:'52,990', profession:'Interpreters and Translators'},
    {state:'Arizona', amount:'46,100', profession:'Interpreters and Translators'},
    {state:'Arkansas', amount:'34,260', profession:'Interpreters and Translators'},
    {state:'California', amount:'58,180', profession:'Interpreters and Translators'},
    {state:'Colorado', amount:'70,050', profession:'Interpreters and Translators'},
    {state:'Connecticut', amount:'47,560', profession:'Interpreters and Translators'},
    {state:'Delaware', amount:'53,860', profession:'Interpreters and Translators'},
    {state:'District of Columbia', amount:'93,730', profession:'Interpreters and Translators'},
    {state:'Florida', amount:'49,300', profession:'Interpreters and Translators'},
    {state:'Georgia', amount:'55,670', profession:'Interpreters and Translators'},
    {state:'Hawaii', amount:'45,580', profession:'Interpreters and Translators'},
    {state:'Idaho', amount:'37,650', profession:'Interpreters and Translators'},
    {state:'Illinois', amount:'46,320', profession:'Interpreters and Translators'},
    {state:'Indiana', amount:'41,700', profession:'Interpreters and Translators'},
    {state:'Iowa', amount:'37,840', profession:'Interpreters and Translators'},
    {state:'Kansas', amount:'40,190', profession:'Interpreters and Translators'},
    {state:'Kentucky', amount:'49,690', profession:'Interpreters and Translators'},
    {state:'Louisiana', amount:'40,440', profession:'Interpreters and Translators'},
    {state:'Maine', amount:'63,210', profession:'Interpreters and Translators'},
    {state:'Maryland', amount:'70,530', profession:'Interpreters and Translators'},
    {state:'Massachusetts', amount:'55,600', profession:'Interpreters and Translators'},
    {state:'Michigan', amount:'41,450', profession:'Interpreters and Translators'},
    {state:'Minnesota', amount:'52,730', profession:'Interpreters and Translators'},
    {state:'Mississippi', amount:'52,110', profession:'Interpreters and Translators'},
    {state:'Missouri', amount:'62,610', profession:'Interpreters and Translators'},
    {state:'Montana', amount:'37,910', profession:'Interpreters and Translators'},
    {state:'Nebraska', amount:'43,760', profession:'Interpreters and Translators'},
    {state:'Nevada', amount:'52,150', profession:'Interpreters and Translators'},
    {state:'New Hampshire', amount:'49,970', profession:'Interpreters and Translators'},
    {state:'New Jersey', amount:'74,750', profession:'Interpreters and Translators'},
    {state:'New Mexico', amount:'58,700', profession:'Interpreters and Translators'},
    {state:'New York', amount:'68,940', profession:'Interpreters and Translators'},
    {state:'North Carolina', amount:'59,310', profession:'Interpreters and Translators'},
    {state:'North Dakota', amount:'35,250', profession:'Interpreters and Translators'},
    {state:'Ohio', amount:'58,380', profession:'Interpreters and Translators'},
    {state:'Oklahoma', amount:'35,240', profession:'Interpreters and Translators'},
    {state:'Oregon', amount:'50,090', profession:'Interpreters and Translators'},
    {state:'Pennsylvania', amount:'50,100', profession:'Interpreters and Translators'},
    {state:'Rhode Island', amount:'50,380', profession:'Interpreters and Translators'},
    {state:'South Carolina', amount:'44,950', profession:'Interpreters and Translators'},
    {state:'South Dakota', amount:'37,650', profession:'Interpreters and Translators'},
    {state:'Tennessee', amount:'43,550', profession:'Interpreters and Translators'},
    {state:'Texas', amount:'58,650', profession:'Interpreters and Translators'},
    {state:'Utah', amount:'43,830', profession:'Interpreters and Translators'},
    {state:'Vermont', amount:'46,270', profession:'Interpreters and Translators'},
    {state:'Virginia', amount:'70,770', profession:'Interpreters and Translators'},
    {state:'Washington', amount:'48,560', profession:'Interpreters and Translators'},
    {state:'West Virginia', amount:'38,590', profession:'Interpreters and Translators'},
    {state:'Wisconsin', amount:'50,750', profession:'Interpreters and Translators'},
    {state:'Wyoming', amount:'48,750', profession:'Interpreters and Translators'},
    {state:'Puerto Rico', amount:'45,130', profession:'Interpreters and Translators'},

    // Maintenance and Repair Workers, General
    {state:'Alabama', amount:'37,520', profession:'Maintenance and Repair Workers, General'},
    {state:'Alaska', amount:'50,610', profession:'Maintenance and Repair Workers, General'},
    {state:'Arizona', amount:'37,710', profession:'Maintenance and Repair Workers, General'},
    {state:'Arkansas', amount:'33,030', profession:'Maintenance and Repair Workers, General'},
    {state:'California', amount:'45,800', profession:'Maintenance and Repair Workers, General'},
    {state:'Colorado', amount:'41,500', profession:'Maintenance and Repair Workers, General'},
    {state:'Connecticut', amount:'47,990', profession:'Maintenance and Repair Workers, General'},
    {state:'Delaware', amount:'41,430', profession:'Maintenance and Repair Workers, General'},
    {state:'District of Columbia', amount:'52,570', profession:'Maintenance and Repair Workers, General'},
    {state:'Florida', amount:'35,670', profession:'Maintenance and Repair Workers, General'},
    {state:'Georgia', amount:'37,070', profession:'Maintenance and Repair Workers, General'},
    {state:'Hawaii', amount:'47,310', profession:'Maintenance and Repair Workers, General'},
    {state:'Idaho', amount:'36,920', profession:'Maintenance and Repair Workers, General'},
    {state:'Illinois', amount:'44,420', profession:'Maintenance and Repair Workers, General'},
    {state:'Indiana', amount:'40,340', profession:'Maintenance and Repair Workers, General'},
    {state:'Iowa', amount:'41,520', profession:'Maintenance and Repair Workers, General'},
    {state:'Kansas', amount:'37,480', profession:'Maintenance and Repair Workers, General'},
    {state:'Kentucky', amount:'39,360', profession:'Maintenance and Repair Workers, General'},
    {state:'Louisiana', amount:'36,760', profession:'Maintenance and Repair Workers, General'},
    {state:'Maine', amount:'39,840', profession:'Maintenance and Repair Workers, General'},
    {state:'Maryland', amount:'43,940', profession:'Maintenance and Repair Workers, General'},
    {state:'Massachusetts', amount:'47,460', profession:'Maintenance and Repair Workers, General'},
    {state:'Michigan', amount:'37,770', profession:'Maintenance and Repair Workers, General'},
    {state:'Minnesota', amount:'44,490', profession:'Maintenance and Repair Workers, General'},
    {state:'Mississippi', amount:'33,130', profession:'Maintenance and Repair Workers, General'},
    {state:'Missouri', amount:'38,200', profession:'Maintenance and Repair Workers, General'},
    {state:'Montana', amount:'37,720', profession:'Maintenance and Repair Workers, General'},
    {state:'Nebraska', amount:'39,660', profession:'Maintenance and Repair Workers, General'},
    {state:'Nevada', amount:'45,880', profession:'Maintenance and Repair Workers, General'},
    {state:'New Hampshire', amount:'42,720', profession:'Maintenance and Repair Workers, General'},
    {state:'New Jersey', amount:'45,540', profession:'Maintenance and Repair Workers, General'},
    {state:'New Mexico', amount:'36,270', profession:'Maintenance and Repair Workers, General'},
    {state:'New York', amount:'46,030', profession:'Maintenance and Repair Workers, General'},
    {state:'North Carolina', amount:'39,620', profession:'Maintenance and Repair Workers, General'},
    {state:'North Dakota', amount:'39,990', profession:'Maintenance and Repair Workers, General'},
    {state:'Ohio', amount:'41,270', profession:'Maintenance and Repair Workers, General'},
    {state:'Oklahoma', amount:'34,700', profession:'Maintenance and Repair Workers, General'},
    {state:'Oregon', amount:'39,620', profession:'Maintenance and Repair Workers, General'},
    {state:'Pennsylvania', amount:'40,130', profession:'Maintenance and Repair Workers, General'},
    {state:'Rhode Island', amount:'45,130', profession:'Maintenance and Repair Workers, General'},
    {state:'South Carolina', amount:'36,850', profession:'Maintenance and Repair Workers, General'},
    {state:'South Dakota', amount:'37,410', profession:'Maintenance and Repair Workers, General'},
    {state:'Tennessee', amount:'38,800', profession:'Maintenance and Repair Workers, General'},
    {state:'Texas', amount:'37,970', profession:'Maintenance and Repair Workers, General'},
    {state:'Utah', amount:'39,360', profession:'Maintenance and Repair Workers, General'},
    {state:'Vermont', amount:'41,150', profession:'Maintenance and Repair Workers, General'},
    {state:'Virginia', amount:'41,560', profession:'Maintenance and Repair Workers, General'},
    {state:'Washington', amount:'44,940', profession:'Maintenance and Repair Workers, General'},
    {state:'West Virginia', amount:'34,290', profession:'Maintenance and Repair Workers, General'},
    {state:'Wisconsin', amount:'41,840', profession:'Maintenance and Repair Workers, General'},
    {state:'Wyoming', amount:'41,020', profession:'Maintenance and Repair Workers, General'},
    {state:'Guam', amount:'26,080', profession:'Maintenance and Repair Workers, General'},
    {state:'Puerto Rico', amount:'21,220', profession:'Maintenance and Repair Workers, General'},
    {state:'Virgin Islands', amount:'31,930', profession:'Maintenance and Repair Workers, General'},

    // Fundraisers
    {state:'Alabama', amount:'52,650', profession:'Fundraisers'},
    {state:'Alaska', amount:'50,730', profession:'Fundraisers'},
    {state:'Arizona', amount:'49,920', profession:'Fundraisers'},
    {state:'Arkansas', amount:'43,610', profession:'Fundraisers'},
    {state:'California', amount:'69,940', profession:'Fundraisers'},
    {state:'Colorado', amount:'58,390', profession:'Fundraisers'},
    {state:'Connecticut', amount:'68,770', profession:'Fundraisers'},
    {state:'Delaware', amount:'59,240', profession:'Fundraisers'},
    {state:'District of Columbia', amount:'80,960', profession:'Fundraisers'},
    {state:'Florida', amount:'58,650', profession:'Fundraisers'},
    {state:'Georgia', amount:'48,910', profession:'Fundraisers'},
    {state:'Hawaii', amount:'58,310', profession:'Fundraisers'},
    {state:'Idaho', amount:'50,340', profession:'Fundraisers'},
    {state:'Illinois', amount:'59,570', profession:'Fundraisers'},
    {state:'Indiana', amount:'51,720', profession:'Fundraisers'},
    {state:'Iowa', amount:'51,080', profession:'Fundraisers'},
    {state:'Kansas', amount:'59,140', profession:'Fundraisers'},
    {state:'Kentucky', amount:'47,370', profession:'Fundraisers'},
    {state:'Louisiana', amount:'49,170', profession:'Fundraisers'},
    {state:'Maine', amount:'53,960', profession:'Fundraisers'},
    {state:'Maryland', amount:'66,610', profession:'Fundraisers'},
    {state:'Massachusetts', amount:'67,470', profession:'Fundraisers'},
    {state:'Michigan', amount:'62,090', profession:'Fundraisers'},
    {state:'Minnesota', amount:'61,210', profession:'Fundraisers'},
    {state:'Mississippi', amount:'52,820', profession:'Fundraisers'},
    {state:'Missouri', amount:'51,040', profession:'Fundraisers'},
    {state:'Montana', amount:'54,890', profession:'Fundraisers'},
    {state:'Nebraska', amount:'53,740', profession:'Fundraisers'},
    {state:'Nevada', amount:'60,510', profession:'Fundraisers'},
    {state:'New Hampshire', amount:'55,620', profession:'Fundraisers'},
    {state:'New Jersey', amount:'65,910', profession:'Fundraisers'},
    {state:'New Mexico', amount:'52,590', profession:'Fundraisers'},
    {state:'New York', amount:'68,460', profession:'Fundraisers'},
    {state:'North Carolina', amount:'58,630', profession:'Fundraisers'},
    {state:'North Dakota', amount:'59,490', profession:'Fundraisers'},
    {state:'Ohio', amount:'56,150', profession:'Fundraisers'},
    {state:'Oklahoma', amount:'57,370', profession:'Fundraisers'},
    {state:'Oregon', amount:'53,160', profession:'Fundraisers'},
    {state:'Pennsylvania', amount:'62,170', profession:'Fundraisers'},
    {state:'Rhode Island', amount:'68,860', profession:'Fundraisers'},
    {state:'South Carolina', amount:'50,690', profession:'Fundraisers'},
    {state:'South Dakota', amount:'54,020', profession:'Fundraisers'},
    {state:'Tennessee', amount:'57,150', profession:'Fundraisers'},
    {state:'Texas', amount:'58,050', profession:'Fundraisers'},
    {state:'Utah', amount:'51,920', profession:'Fundraisers'},
    {state:'Vermont', amount:'54,730', profession:'Fundraisers'},
    {state:'Virginia', amount:'63,610', profession:'Fundraisers'},
    {state:'Washington', amount:'61,310', profession:'Fundraisers'},
    {state:'West Virginia', amount:'52,540', profession:'Fundraisers'},
    {state:'Wisconsin', amount:'55,230', profession:'Fundraisers'},
    {state:'Wyoming', amount:'60,950', profession:'Fundraisers'},

    // Technical Writers
    {state:'Alabama', amount:'69,970', profession:'Technical Writers'},
    {state:'Alaska', amount:'72,250', profession:'Technical Writers'},
    {state:'Arizona', amount:'69,580', profession:'Technical Writers'},
    {state:'Arkansas', amount:'61,030', profession:'Technical Writers'},
    {state:'California', amount:'91,310', profession:'Technical Writers'},
    {state:'Colorado', amount:'80,250', profession:'Technical Writers'},
    {state:'Connecticut', amount:'81,290', profession:'Technical Writers'},
    {state:'Delaware', amount:'77,010', profession:'Technical Writers'},
    {state:'District of Columbia', amount:'86,120', profession:'Technical Writers'},
    {state:'Florida', amount:'62,710', profession:'Technical Writers'},
    {state:'Georgia', amount:'75,170', profession:'Technical Writers'},
    {state:'Hawaii', amount:'62,070', profession:'Technical Writers'},
    {state:'Idaho', amount:'61,710', profession:'Technical Writers'},
    {state:'Illinois', amount:'69,320', profession:'Technical Writers'},
    {state:'Indiana', amount:'65,130', profession:'Technical Writers'},
    {state:'Iowa', amount:'57,060', profession:'Technical Writers'},
    {state:'Kansas', amount:'62,020', profession:'Technical Writers'},
    {state:'Kentucky', amount:'71,610', profession:'Technical Writers'},
    {state:'Louisiana', amount:'68,120', profession:'Technical Writers'},
    {state:'Maine', amount:'65,030', profession:'Technical Writers'},
    {state:'Maryland', amount:'80,130', profession:'Technical Writers'},
    {state:'Massachusetts', amount:'89,630', profession:'Technical Writers'},
    {state:'Michigan', amount:'68,580', profession:'Technical Writers'},
    {state:'Minnesota', amount:'66,970', profession:'Technical Writers'},
    {state:'Mississippi', amount:'67,680', profession:'Technical Writers'},
    {state:'Missouri', amount:'58,840', profession:'Technical Writers'},
    {state:'Montana', amount:'55,700', profession:'Technical Writers'},
    {state:'Nebraska', amount:'60,580', profession:'Technical Writers'},
    {state:'Nevada', amount:'66,040', profession:'Technical Writers'},
    {state:'New Hampshire', amount:'76,020', profession:'Technical Writers'},
    {state:'New Jersey', amount:'84,280', profession:'Technical Writers'},
    {state:'New Mexico', amount:'76,640', profession:'Technical Writers'},
    {state:'New York', amount:'76,380', profession:'Technical Writers'},
    {state:'North Carolina', amount:'76,070', profession:'Technical Writers'},
    {state:'North Dakota', amount:'56,140', profession:'Technical Writers'},
    {state:'Ohio', amount:'63,340', profession:'Technical Writers'},
    {state:'Oklahoma', amount:'57,450', profession:'Technical Writers'},
    {state:'Oregon', amount:'68,320', profession:'Technical Writers'},
    {state:'Pennsylvania', amount:'70,060', profession:'Technical Writers'},
    {state:'Rhode Island', amount:'67,200', profession:'Technical Writers'},
    {state:'South Carolina', amount:'67,000', profession:'Technical Writers'},
    {state:'South Dakota', amount:'50,320', profession:'Technical Writers'},
    {state:'Tennessee', amount:'66,080', profession:'Technical Writers'},
    {state:'Texas', amount:'75,000', profession:'Technical Writers'},
    {state:'Utah', amount:'66,940', profession:'Technical Writers'},
    {state:'Vermont', amount:'74,730', profession:'Technical Writers'},
    {state:'Virginia', amount:'85,450', profession:'Technical Writers'},
    {state:'Washington', amount:'86,470', profession:'Technical Writers'},
    {state:'West Virginia', amount:'40,210', profession:'Technical Writers'},
    {state:'Wisconsin', amount:'59,480', profession:'Technical Writers'},
    {state:'Wyoming', amount:'64,010', profession:'Technical Writers'},
    {state:'Puerto Rico', amount:'44,610', profession:'Technical Writers'},

    // Physical Therapist Aides
    {state:'Alabama', amount:'26,190', profession:'Physical Therapist Aides'},
    {state:'Alaska', amount:'46,230', profession:'Physical Therapist Aides'},
    {state:'Arizona', amount:'28,360', profession:'Physical Therapist Aides'},
    {state:'Arkansas', amount:'25,650', profession:'Physical Therapist Aides'},
    {state:'California', amount:'31,090', profession:'Physical Therapist Aides'},
    {state:'Colorado', amount:'32,240', profession:'Physical Therapist Aides'},
    {state:'Connecticut', amount:'30,980', profession:'Physical Therapist Aides'},
    {state:'Delaware', amount:'26,050', profession:'Physical Therapist Aides'},
    {state:'District of Columbia', amount:'30,520', profession:'Physical Therapist Aides'},
    {state:'Florida', amount:'27,160', profession:'Physical Therapist Aides'},
    {state:'Georgia', amount:'27,270', profession:'Physical Therapist Aides'},
    {state:'Hawaii', amount:'30,050', profession:'Physical Therapist Aides'},
    {state:'Idaho', amount:'39,120', profession:'Physical Therapist Aides'},
    {state:'Illinois', amount:'31,100', profession:'Physical Therapist Aides'},
    {state:'Indiana', amount:'29,450', profession:'Physical Therapist Aides'},
    {state:'Iowa', amount:'27,580', profession:'Physical Therapist Aides'},
    {state:'Kansas', amount:'27,490', profession:'Physical Therapist Aides'},
    {state:'Kentucky', amount:'26,320', profession:'Physical Therapist Aides'},
    {state:'Louisiana', amount:'27,620', profession:'Physical Therapist Aides'},
    {state:'Maine', amount:'30,690', profession:'Physical Therapist Aides'},
    {state:'Maryland', amount:'25,980', profession:'Physical Therapist Aides'},
    {state:'Massachusetts', amount:'33,740', profession:'Physical Therapist Aides'},
    {state:'Michigan', amount:'27,810', profession:'Physical Therapist Aides'},
    {state:'Minnesota', amount:'37,230', profession:'Physical Therapist Aides'},
    {state:'Mississippi', amount:'22,870', profession:'Physical Therapist Aides'},
    {state:'Missouri', amount:'28,940', profession:'Physical Therapist Aides'},
    {state:'Montana', amount:'28,320', profession:'Physical Therapist Aides'},
    {state:'Nebraska', amount:'28,000', profession:'Physical Therapist Aides'},
    {state:'Nevada', amount:'26,000', profession:'Physical Therapist Aides'},
    {state:'New Hampshire', amount:'32,820', profession:'Physical Therapist Aides'},
    {state:'New Jersey', amount:'27,480', profession:'Physical Therapist Aides'},
    {state:'New Mexico', amount:'28,210', profession:'Physical Therapist Aides'},
    {state:'New York', amount:'30,230', profession:'Physical Therapist Aides'},
    {state:'North Carolina', amount:'27,780', profession:'Physical Therapist Aides'},
    {state:'North Dakota', amount:'33,350', profession:'Physical Therapist Aides'},
    {state:'Ohio', amount:'28,210', profession:'Physical Therapist Aides'},
    {state:'Oklahoma', amount:'21,610', profession:'Physical Therapist Aides'},
    {state:'Oregon', amount:'30,200', profession:'Physical Therapist Aides'},
    {state:'Pennsylvania', amount:'29,450', profession:'Physical Therapist Aides'},
    {state:'Rhode Island', amount:'33,960', profession:'Physical Therapist Aides'},
    {state:'South Carolina', amount:'30,440', profession:'Physical Therapist Aides'},
    {state:'South Dakota', amount:'28,810', profession:'Physical Therapist Aides'},
    {state:'Tennessee', amount:'25,740', profession:'Physical Therapist Aides'},
    {state:'Texas', amount:'26,810', profession:'Physical Therapist Aides'},
    {state:'Utah', amount:'22,860', profession:'Physical Therapist Aides'},
    {state:'Vermont', amount:'33,900', profession:'Physical Therapist Aides'},
    {state:'Virginia', amount:'28,110', profession:'Physical Therapist Aides'},
    {state:'Washington', amount:'29,870', profession:'Physical Therapist Aides'},
    {state:'West Virginia', amount:'25,620', profession:'Physical Therapist Aides'},
    {state:'Wisconsin', amount:'30,460', profession:'Physical Therapist Aides'},
    {state:'Wyoming', amount:'26,080', profession:'Physical Therapist Aides'},
    {state:'Puerto Rico', amount:'24,820', profession:'Physical Therapist Aides'},

    // Biomedical Engineers
    {state:'Arizona', amount:'103,650', profession:'Biomedical Engineers'},
    {state:'Arkansas', amount:'66,840', profession:'Biomedical Engineers'},
    {state:'California', amount:'101,210', profession:'Biomedical Engineers'},
    {state:'Colorado', amount:'96,880', profession:'Biomedical Engineers'},
    {state:'Connecticut', amount:'102,970', profession:'Biomedical Engineers'},
    {state:'District of Columbia', amount:'80,320', profession:'Biomedical Engineers'},
    {state:'Florida', amount:'78,670', profession:'Biomedical Engineers'},
    {state:'Georgia', amount:'81,870', profession:'Biomedical Engineers'},
    {state:'Illinois', amount:'98,420', profession:'Biomedical Engineers'},
    {state:'Indiana', amount:'85,310', profession:'Biomedical Engineers'},
    {state:'Iowa', amount:'68,260', profession:'Biomedical Engineers'},
    {state:'Kansas', amount:'77,150', profession:'Biomedical Engineers'},
    {state:'Maryland', amount:'100,200', profession:'Biomedical Engineers'},
    {state:'Massachusetts', amount:'105,580', profession:'Biomedical Engineers'},
    {state:'Michigan', amount:'79,650', profession:'Biomedical Engineers'},
    {state:'Minnesota', amount:'114,380', profession:'Biomedical Engineers'},
    {state:'Missouri', amount:'75,150', profession:'Biomedical Engineers'},
    {state:'Nebraska', amount:'82,540', profession:'Biomedical Engineers'},
    {state:'Nevada', amount:'96,100', profession:'Biomedical Engineers'},
    {state:'New Jersey', amount:'113,140', profession:'Biomedical Engineers'},
    {state:'New York', amount:'101,460', profession:'Biomedical Engineers'},
    {state:'North Carolina', amount:'93,450', profession:'Biomedical Engineers'},
    {state:'Ohio', amount:'84,700', profession:'Biomedical Engineers'},
    {state:'Oklahoma', amount:'67,300', profession:'Biomedical Engineers'},
    {state:'Oregon', amount:'94,440', profession:'Biomedical Engineers'},
    {state:'Pennsylvania', amount:'78,840', profession:'Biomedical Engineers'},
    {state:'South Carolina', amount:'64,460', profession:'Biomedical Engineers'},
    {state:'Tennessee', amount:'77,920', profession:'Biomedical Engineers'},
    {state:'Texas', amount:'100,680', profession:'Biomedical Engineers'},
    {state:'Utah', amount:'70,980', profession:'Biomedical Engineers'},
    {state:'Vermont', amount:'95,280', profession:'Biomedical Engineers'},
    {state:'Virginia', amount:'97,400', profession:'Biomedical Engineers'},
    {state:'Washington', amount:'94,850', profession:'Biomedical Engineers'},
    {state:'West Virginia', amount:'85,280', profession:'Biomedical Engineers'},
    {state:'Wisconsin', amount:'71,750', profession:'Biomedical Engineers'},

    // Pharmacy Technicians
    {state:'Alabama', amount:'30,040', profession:'Pharmacy Technicians'},
    {state:'Alaska', amount:'43,150', profession:'Pharmacy Technicians'},
    {state:'Arizona', amount:'35,090', profession:'Pharmacy Technicians'},
    {state:'Arkansas', amount:'29,640', profession:'Pharmacy Technicians'},
    {state:'California', amount:'42,610', profession:'Pharmacy Technicians'},
    {state:'Colorado', amount:'36,880', profession:'Pharmacy Technicians'},
    {state:'Connecticut', amount:'34,530', profession:'Pharmacy Technicians'},
    {state:'Delaware', amount:'34,470', profession:'Pharmacy Technicians'},
    {state:'District of Columbia', amount:'39,980', profession:'Pharmacy Technicians'},
    {state:'Florida', amount:'32,090', profession:'Pharmacy Technicians'},
    {state:'Georgia', amount:'30,240', profession:'Pharmacy Technicians'},
    {state:'Hawaii', amount:'38,720', profession:'Pharmacy Technicians'},
    {state:'Idaho', amount:'35,920', profession:'Pharmacy Technicians'},
    {state:'Illinois', amount:'33,140', profession:'Pharmacy Technicians'},
    {state:'Indiana', amount:'31,160', profession:'Pharmacy Technicians'},
    {state:'Iowa', amount:'32,560', profession:'Pharmacy Technicians'},
    {state:'Kansas', amount:'32,940', profession:'Pharmacy Technicians'},
    {state:'Kentucky', amount:'29,270', profession:'Pharmacy Technicians'},
    {state:'Louisiana', amount:'32,700', profession:'Pharmacy Technicians'},
    {state:'Maine', amount:'31,690', profession:'Pharmacy Technicians'},
    {state:'Maryland', amount:'33,880', profession:'Pharmacy Technicians'},
    {state:'Massachusetts', amount:'37,110', profession:'Pharmacy Technicians'},
    {state:'Michigan', amount:'32,660', profession:'Pharmacy Technicians'},
    {state:'Minnesota', amount:'37,670', profession:'Pharmacy Technicians'},
    {state:'Mississippi', amount:'31,440', profession:'Pharmacy Technicians'},
    {state:'Missouri', amount:'32,090', profession:'Pharmacy Technicians'},
    {state:'Montana', amount:'34,780', profession:'Pharmacy Technicians'},
    {state:'Nebraska', amount:'33,270', profession:'Pharmacy Technicians'},
    {state:'Nevada', amount:'37,620', profession:'Pharmacy Technicians'},
    {state:'New Hampshire', amount:'32,370', profession:'Pharmacy Technicians'},
    {state:'New Jersey', amount:'33,070', profession:'Pharmacy Technicians'},
    {state:'New Mexico', amount:'33,710', profession:'Pharmacy Technicians'},
    {state:'New York', amount:'34,640', profession:'Pharmacy Technicians'},
    {state:'North Carolina', amount:'30,890', profession:'Pharmacy Technicians'},
    {state:'North Dakota', amount:'39,770', profession:'Pharmacy Technicians'},
    {state:'Ohio', amount:'30,500', profession:'Pharmacy Technicians'},
    {state:'Oklahoma', amount:'30,790', profession:'Pharmacy Technicians'},
    {state:'Oregon', amount:'40,920', profession:'Pharmacy Technicians'},
    {state:'Pennsylvania', amount:'30,000', profession:'Pharmacy Technicians'},
    {state:'Rhode Island', amount:'37,410', profession:'Pharmacy Technicians'},
    {state:'South Carolina', amount:'31,530', profession:'Pharmacy Technicians'},
    {state:'South Dakota', amount:'32,720', profession:'Pharmacy Technicians'},
    {state:'Tennessee', amount:'32,980', profession:'Pharmacy Technicians'},
    {state:'Texas', amount:'34,290', profession:'Pharmacy Technicians'},
    {state:'Utah', amount:'37,190', profession:'Pharmacy Technicians'},
    {state:'Vermont', amount:'34,070', profession:'Pharmacy Technicians'},
    {state:'Virginia', amount:'32,370', profession:'Pharmacy Technicians'},
    {state:'Washington', amount:'42,470', profession:'Pharmacy Technicians'},
    {state:'West Virginia', amount:'28,650', profession:'Pharmacy Technicians'},
    {state:'Wisconsin', amount:'32,750', profession:'Pharmacy Technicians'},
    {state:'Wyoming', amount:'37,460', profession:'Pharmacy Technicians'},
    {state:'Guam', amount:'28,230', profession:'Pharmacy Technicians'},
    {state:'Puerto Rico', amount:'21,880', profession:'Pharmacy Technicians'},
    {state:'Virgin Islands', amount:'32,950', profession:'Pharmacy Technicians'},

    // Phlebotomists
    {state:'Alabama', amount:'31,420', profession:'Phlebotomists'},
    {state:'Alaska', amount:'42,290', profession:'Phlebotomists'},
    {state:'Arizona', amount:'32,810', profession:'Phlebotomists'},
    {state:'Arkansas', amount:'28,690', profession:'Phlebotomists'},
    {state:'California', amount:'45,030', profession:'Phlebotomists'},
    {state:'Colorado', amount:'35,800', profession:'Phlebotomists'},
    {state:'Connecticut', amount:'39,310', profession:'Phlebotomists'},
    {state:'Delaware', amount:'39,120', profession:'Phlebotomists'},
    {state:'District of Columbia', amount:'41,600', profession:'Phlebotomists'},
    {state:'Florida', amount:'32,280', profession:'Phlebotomists'},
    {state:'Georgia', amount:'32,190', profession:'Phlebotomists'},
    {state:'Idaho', amount:'31,920', profession:'Phlebotomists'},
    {state:'Illinois', amount:'36,090', profession:'Phlebotomists'},
    {state:'Indiana', amount:'34,290', profession:'Phlebotomists'},
    {state:'Iowa', amount:'30,760', profession:'Phlebotomists'},
    {state:'Kansas', amount:'32,890', profession:'Phlebotomists'},
    {state:'Kentucky', amount:'31,130', profession:'Phlebotomists'},
    {state:'Louisiana', amount:'29,970', profession:'Phlebotomists'},
    {state:'Maine', amount:'31,190', profession:'Phlebotomists'},
    {state:'Maryland', amount:'39,760', profession:'Phlebotomists'},
    {state:'Massachusetts', amount:'39,970', profession:'Phlebotomists'},
    {state:'Michigan', amount:'32,450', profession:'Phlebotomists'},
    {state:'Minnesota', amount:'38,630', profession:'Phlebotomists'},
    {state:'Mississippi', amount:'29,460', profession:'Phlebotomists'},
    {state:'Missouri', amount:'31,320', profession:'Phlebotomists'},
    {state:'Montana', amount:'32,240', profession:'Phlebotomists'},
    {state:'Nebraska', amount:'32,000', profession:'Phlebotomists'},
    {state:'Nevada', amount:'38,320', profession:'Phlebotomists'},
    {state:'New Hampshire', amount:'39,870', profession:'Phlebotomists'},
    {state:'New Jersey', amount:'38,090', profession:'Phlebotomists'},
    {state:'New Mexico', amount:'29,700', profession:'Phlebotomists'},
    {state:'New York', amount:'40,630', profession:'Phlebotomists'},
    {state:'North Carolina', amount:'32,070', profession:'Phlebotomists'},
    {state:'North Dakota', amount:'33,340', profession:'Phlebotomists'},
    {state:'Ohio', amount:'34,230', profession:'Phlebotomists'},
    {state:'Oklahoma', amount:'31,570', profession:'Phlebotomists'},
    {state:'Oregon', amount:'39,150', profession:'Phlebotomists'},
    {state:'Pennsylvania', amount:'34,370', profession:'Phlebotomists'},
    {state:'Rhode Island', amount:'39,930', profession:'Phlebotomists'},
    {state:'South Carolina', amount:'31,180', profession:'Phlebotomists'},
    {state:'South Dakota', amount:'27,670', profession:'Phlebotomists'},
    {state:'Tennessee', amount:'30,090', profession:'Phlebotomists'},
    {state:'Texas', amount:'33,000', profession:'Phlebotomists'},
    {state:'Utah', amount:'31,290', profession:'Phlebotomists'},
    {state:'Vermont', amount:'35,740', profession:'Phlebotomists'},
    {state:'Virginia', amount:'35,960', profession:'Phlebotomists'},
    {state:'Washington', amount:'39,410', profession:'Phlebotomists'},
    {state:'West Virginia', amount:'30,200', profession:'Phlebotomists'},
    {state:'Wisconsin', amount:'35,530', profession:'Phlebotomists'},
    {state:'Wyoming', amount:'32,160', profession:'Phlebotomists'},
    {state:'Puerto Rico', amount:'24,620', profession:'Phlebotomists'},

    // Environmental Engineering Technicians
    {state:'Alabama', amount:'50,550', profession:'Environmental Engineering Technicians'},
    {state:'Alaska', amount:'58,490', profession:'Environmental Engineering Technicians'},
    {state:'Arizona', amount:'48,190', profession:'Environmental Engineering Technicians'},
    {state:'California', amount:'59,600', profession:'Environmental Engineering Technicians'},
    {state:'Colorado', amount:'60,350', profession:'Environmental Engineering Technicians'},
    {state:'Connecticut', amount:'55,150', profession:'Environmental Engineering Technicians'},
    {state:'Delaware', amount:'57,780', profession:'Environmental Engineering Technicians'},
    {state:'Florida', amount:'46,540', profession:'Environmental Engineering Technicians'},
    {state:'Georgia', amount:'45,610', profession:'Environmental Engineering Technicians'},
    {state:'Hawaii', amount:'56,180', profession:'Environmental Engineering Technicians'},
    {state:'Idaho', amount:'52,730', profession:'Environmental Engineering Technicians'},
    {state:'Illinois', amount:'53,270', profession:'Environmental Engineering Technicians'},
    {state:'Indiana', amount:'43,940', profession:'Environmental Engineering Technicians'},
    {state:'Iowa', amount:'50,980', profession:'Environmental Engineering Technicians'},
    {state:'Kansas', amount:'50,880', profession:'Environmental Engineering Technicians'},
    {state:'Kentucky', amount:'47,240', profession:'Environmental Engineering Technicians'},
    {state:'Louisiana', amount:'51,740', profession:'Environmental Engineering Technicians'},
    {state:'Maine', amount:'55,450', profession:'Environmental Engineering Technicians'},
    {state:'Maryland', amount:'60,150', profession:'Environmental Engineering Technicians'},
    {state:'Massachusetts', amount:'59,120', profession:'Environmental Engineering Technicians'},
    {state:'Michigan', amount:'47,640', profession:'Environmental Engineering Technicians'},
    {state:'Mississippi', amount:'50,180', profession:'Environmental Engineering Technicians'},
    {state:'Missouri', amount:'43,890', profession:'Environmental Engineering Technicians'},
    {state:'Montana', amount:'43,790', profession:'Environmental Engineering Technicians'},
    {state:'Nebraska', amount:'53,200', profession:'Environmental Engineering Technicians'},
    {state:'Nevada', amount:'58,970', profession:'Environmental Engineering Technicians'},
    {state:'New Hampshire', amount:'55,700', profession:'Environmental Engineering Technicians'},
    {state:'New Jersey', amount:'46,630', profession:'Environmental Engineering Technicians'},
    {state:'New Mexico', amount:'49,970', profession:'Environmental Engineering Technicians'},
    {state:'New York', amount:'58,010', profession:'Environmental Engineering Technicians'},
    {state:'North Carolina', amount:'44,410', profession:'Environmental Engineering Technicians'},
    {state:'North Dakota', amount:'55,680', profession:'Environmental Engineering Technicians'},
    {state:'Ohio', amount:'48,200', profession:'Environmental Engineering Technicians'},
    {state:'Oklahoma', amount:'49,330', profession:'Environmental Engineering Technicians'},
    {state:'Oregon', amount:'59,270', profession:'Environmental Engineering Technicians'},
    {state:'Pennsylvania', amount:'48,450', profession:'Environmental Engineering Technicians'},
    {state:'Tennessee', amount:'56,500', profession:'Environmental Engineering Technicians'},
    {state:'Texas', amount:'54,190', profession:'Environmental Engineering Technicians'},
    {state:'Utah', amount:'43,600', profession:'Environmental Engineering Technicians'},
    {state:'Vermont', amount:'49,630', profession:'Environmental Engineering Technicians'},
    {state:'Virginia', amount:'47,060', profession:'Environmental Engineering Technicians'},
    {state:'Washington', amount:'70,190', profession:'Environmental Engineering Technicians'},
    {state:'West Virginia', amount:'54,490', profession:'Environmental Engineering Technicians'},
    {state:'Wisconsin', amount:'54,480', profession:'Environmental Engineering Technicians'},
    {state:'Wyoming', amount:'58,980', profession:'Environmental Engineering Technicians'},
    {state:'Puerto Rico', amount:'37,990', profession:'Environmental Engineering Technicians'},

    // Magnetic Resonance Imaging Technologists
    {state:'Alabama', amount:'59,420', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Alaska', amount:'85,730', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Arizona', amount:'79,120', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Arkansas', amount:'58,240', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'California', amount:'90,890', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Colorado', amount:'79,100', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Connecticut', amount:'78,840', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Delaware', amount:'75,080', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'District of Columbia', amount:'84,800', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Florida', amount:'63,190', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Georgia', amount:'68,090', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Hawaii', amount:'88,620', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Idaho', amount:'70,320', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Illinois', amount:'74,010', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Indiana', amount:'64,710', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Iowa', amount:'60,280', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Kansas', amount:'64,960', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Kentucky', amount:'67,980', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Louisiana', amount:'60,520', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Maine', amount:'72,750', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Maryland', amount:'71,620', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Massachusetts', amount:'84,880', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Michigan', amount:'62,300', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Minnesota', amount:'78,740', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Mississippi', amount:'59,960', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Missouri', amount:'63,400', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Montana', amount:'69,940', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Nebraska', amount:'67,210', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Nevada', amount:'87,960', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'New Hampshire', amount:'73,400', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'New Jersey', amount:'81,650', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'New Mexico', amount:'71,850', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'New York', amount:'81,010', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'North Carolina', amount:'67,260', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'North Dakota', amount:'62,900', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Ohio', amount:'65,100', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Oklahoma', amount:'63,330', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Oregon', amount:'87,480', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Pennsylvania', amount:'65,460', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Rhode Island', amount:'77,060', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'South Carolina', amount:'60,700', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'South Dakota', amount:'60,000', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Tennessee', amount:'59,860', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Texas', amount:'70,510', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Utah', amount:'66,420', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Vermont', amount:'81,030', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Virginia', amount:'70,370', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Washington', amount:'91,290', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'West Virginia', amount:'66,430', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Wisconsin', amount:'68,080', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Wyoming', amount:'64,430', profession:'Magnetic Resonance Imaging Technologists'},
    {state:'Puerto Rico', amount:'32,890', profession:'Magnetic Resonance Imaging Technologists'},

    // Massage Therapists
    {state:'Alabama', amount:'34,890', profession:'Massage Therapists'},
    {state:'Alaska', amount:'82,280', profession:'Massage Therapists'},
    {state:'Arizona', amount:'42,340', profession:'Massage Therapists'},
    {state:'Arkansas', amount:'41,890', profession:'Massage Therapists'},
    {state:'California', amount:'41,460', profession:'Massage Therapists'},
    {state:'Colorado', amount:'46,190', profession:'Massage Therapists'},
    {state:'Connecticut', amount:'43,170', profession:'Massage Therapists'},
    {state:'District of Columbia', amount:'40,890', profession:'Massage Therapists'},
    {state:'Florida', amount:'46,240', profession:'Massage Therapists'},
    {state:'Georgia', amount:'37,210', profession:'Massage Therapists'},
    {state:'Hawaii', amount:'61,750', profession:'Massage Therapists'},
    {state:'Idaho', amount:'50,560', profession:'Massage Therapists'},
    {state:'Illinois', amount:'46,340', profession:'Massage Therapists'},
    {state:'Indiana', amount:'48,650', profession:'Massage Therapists'},
    {state:'Iowa', amount:'40,030', profession:'Massage Therapists'},
    {state:'Kansas', amount:'29,370', profession:'Massage Therapists'},
    {state:'Kentucky', amount:'52,960', profession:'Massage Therapists'},
    {state:'Louisiana', amount:'30,060', profession:'Massage Therapists'},
    {state:'Maine', amount:'43,450', profession:'Massage Therapists'},
    {state:'Maryland', amount:'42,430', profession:'Massage Therapists'},
    {state:'Massachusetts', amount:'53,750', profession:'Massage Therapists'},
    {state:'Michigan', amount:'42,710', profession:'Massage Therapists'},
    {state:'Minnesota', amount:'52,910', profession:'Massage Therapists'},
    {state:'Mississippi', amount:'29,080', profession:'Massage Therapists'},
    {state:'Missouri', amount:'37,100', profession:'Massage Therapists'},
    {state:'Montana', amount:'46,500', profession:'Massage Therapists'},
    {state:'Nebraska', amount:'45,340', profession:'Massage Therapists'},
    {state:'Nevada', amount:'29,620', profession:'Massage Therapists'},
    {state:'New Hampshire', amount:'47,360', profession:'Massage Therapists'},
    {state:'New Jersey', amount:'44,610', profession:'Massage Therapists'},
    {state:'New Mexico', amount:'42,260', profession:'Massage Therapists'},
    {state:'New York', amount:'52,830', profession:'Massage Therapists'},
    {state:'North Carolina', amount:'41,560', profession:'Massage Therapists'},
    {state:'North Dakota', amount:'39,640', profession:'Massage Therapists'},
    {state:'Ohio', amount:'39,370', profession:'Massage Therapists'},
    {state:'Oklahoma', amount:'41,770', profession:'Massage Therapists'},
    {state:'Oregon', amount:'64,360', profession:'Massage Therapists'},
    {state:'Pennsylvania', amount:'42,730', profession:'Massage Therapists'},
    {state:'Rhode Island', amount:'40,970', profession:'Massage Therapists'},
    {state:'South Carolina', amount:'41,440', profession:'Massage Therapists'},
    {state:'South Dakota', amount:'34,350', profession:'Massage Therapists'},
    {state:'Tennessee', amount:'44,190', profession:'Massage Therapists'},
    {state:'Texas', amount:'49,100', profession:'Massage Therapists'},
    {state:'Utah', amount:'40,880', profession:'Massage Therapists'},
    {state:'Vermont', amount:'44,580', profession:'Massage Therapists'},
    {state:'Virginia', amount:'38,990', profession:'Massage Therapists'},
    {state:'Washington', amount:'62,520', profession:'Massage Therapists'},
    {state:'West Virginia', amount:'34,750', profession:'Massage Therapists'},
    {state:'Wisconsin', amount:'42,440', profession:'Massage Therapists'},
    {state:'Wyoming', amount:'43,060', profession:'Massage Therapists'},
    {state:'Guam', amount:'24,760', profession:'Massage Therapists'},
    {state:'Puerto Rico', amount:'25,840', profession:'Massage Therapists'},

    // Environmental Engineers
    {state:'Alabama', amount:'82,020', profession:'Environmental Engineers'},
    {state:'Alaska', amount:'116,680', profession:'Environmental Engineers'},
    {state:'Arizona', amount:'80,330', profession:'Environmental Engineers'},
    {state:'Arkansas', amount:'89,540', profession:'Environmental Engineers'},
    {state:'California', amount:'105,480', profession:'Environmental Engineers'},
    {state:'Colorado', amount:'98,350', profession:'Environmental Engineers'},
    {state:'Connecticut', amount:'88,810', profession:'Environmental Engineers'},
    {state:'Delaware', amount:'84,480', profession:'Environmental Engineers'},
    {state:'District of Columbia', amount:'100,060', profession:'Environmental Engineers'},
    {state:'Florida', amount:'80,540', profession:'Environmental Engineers'},
    {state:'Georgia', amount:'79,700', profession:'Environmental Engineers'},
    {state:'Hawaii', amount:'91,270', profession:'Environmental Engineers'},
    {state:'Idaho', amount:'96,870', profession:'Environmental Engineers'},
    {state:'Illinois', amount:'92,200', profession:'Environmental Engineers'},
    {state:'Indiana', amount:'82,180', profession:'Environmental Engineers'},
    {state:'Iowa', amount:'79,210', profession:'Environmental Engineers'},
    {state:'Kansas', amount:'85,400', profession:'Environmental Engineers'},
    {state:'Kentucky', amount:'80,900', profession:'Environmental Engineers'},
    {state:'Louisiana', amount:'108,980', profession:'Environmental Engineers'},
    {state:'Maine', amount:'75,440', profession:'Environmental Engineers'},
    {state:'Maryland', amount:'102,650', profession:'Environmental Engineers'},
    {state:'Massachusetts', amount:'90,070', profession:'Environmental Engineers'},
    {state:'Michigan', amount:'93,770', profession:'Environmental Engineers'},
    {state:'Mississippi', amount:'72,400', profession:'Environmental Engineers'},
    {state:'Missouri', amount:'72,290', profession:'Environmental Engineers'},
    {state:'Montana', amount:'84,960', profession:'Environmental Engineers'},
    {state:'Nebraska', amount:'90,320', profession:'Environmental Engineers'},
    {state:'Nevada', amount:'92,810', profession:'Environmental Engineers'},
    {state:'New Hampshire', amount:'99,840', profession:'Environmental Engineers'},
    {state:'New Jersey', amount:'88,360', profession:'Environmental Engineers'},
    {state:'New Mexico', amount:'95,720', profession:'Environmental Engineers'},
    {state:'New York', amount:'90,470', profession:'Environmental Engineers'},
    {state:'North Carolina', amount:'82,110', profession:'Environmental Engineers'},
    {state:'North Dakota', amount:'76,770', profession:'Environmental Engineers'},
    {state:'Ohio', amount:'85,970', profession:'Environmental Engineers'},
    {state:'Oklahoma', amount:'79,590', profession:'Environmental Engineers'},
    {state:'Oregon', amount:'97,440', profession:'Environmental Engineers'},
    {state:'Pennsylvania', amount:'89,410', profession:'Environmental Engineers'},
    {state:'Rhode Island', amount:'91,940', profession:'Environmental Engineers'},
    {state:'South Carolina', amount:'76,970', profession:'Environmental Engineers'},
    {state:'South Dakota', amount:'99,760', profession:'Environmental Engineers'},
    {state:'Tennessee', amount:'93,620', profession:'Environmental Engineers'},
    {state:'Texas', amount:'102,660', profession:'Environmental Engineers'},
    {state:'Utah', amount:'76,530', profession:'Environmental Engineers'},
    {state:'Vermont', amount:'82,430', profession:'Environmental Engineers'},
    {state:'Virginia', amount:'86,330', profession:'Environmental Engineers'},
    {state:'Washington', amount:'99,750', profession:'Environmental Engineers'},
    {state:'West Virginia', amount:'69,800', profession:'Environmental Engineers'},
    {state:'Wisconsin', amount:'81,860', profession:'Environmental Engineers'},
    {state:'Wyoming', amount:'93,680', profession:'Environmental Engineers'},
    {state:'Puerto Rico', amount:'65,490', profession:'Environmental Engineers'},

    // Dietitians and Nutritionists
    {state:'Alabama', amount:'55,580', profession:'Dietitians and Nutritionists'},
    {state:'Alaska', amount:'71,210', profession:'Dietitians and Nutritionists'},
    {state:'Arizona', amount:'55,060', profession:'Dietitians and Nutritionists'},
    {state:'Arkansas', amount:'58,390', profession:'Dietitians and Nutritionists'},
    {state:'California', amount:'74,060', profession:'Dietitians and Nutritionists'},
    {state:'Colorado', amount:'60,500', profession:'Dietitians and Nutritionists'},
    {state:'Connecticut', amount:'69,610', profession:'Dietitians and Nutritionists'},
    {state:'Delaware', amount:'64,590', profession:'Dietitians and Nutritionists'},
    {state:'District of Columbia', amount:'65,490', profession:'Dietitians and Nutritionists'},
    {state:'Florida', amount:'61,710', profession:'Dietitians and Nutritionists'},
    {state:'Georgia', amount:'54,550', profession:'Dietitians and Nutritionists'},
    {state:'Hawaii', amount:'69,050', profession:'Dietitians and Nutritionists'},
    {state:'Idaho', amount:'53,420', profession:'Dietitians and Nutritionists'},
    {state:'Illinois', amount:'58,020', profession:'Dietitians and Nutritionists'},
    {state:'Indiana', amount:'56,620', profession:'Dietitians and Nutritionists'},
    {state:'Iowa', amount:'47,580', profession:'Dietitians and Nutritionists'},
    {state:'Kansas', amount:'57,300', profession:'Dietitians and Nutritionists'},
    {state:'Kentucky', amount:'57,980', profession:'Dietitians and Nutritionists'},
    {state:'Louisiana', amount:'56,440', profession:'Dietitians and Nutritionists'},
    {state:'Maine', amount:'58,310', profession:'Dietitians and Nutritionists'},
    {state:'Maryland', amount:'68,760', profession:'Dietitians and Nutritionists'},
    {state:'Massachusetts', amount:'64,860', profession:'Dietitians and Nutritionists'},
    {state:'Michigan', amount:'57,000', profession:'Dietitians and Nutritionists'},
    {state:'Minnesota', amount:'61,820', profession:'Dietitians and Nutritionists'},
    {state:'Mississippi', amount:'51,690', profession:'Dietitians and Nutritionists'},
    {state:'Missouri', amount:'54,030', profession:'Dietitians and Nutritionists'},
    {state:'Montana', amount:'50,650', profession:'Dietitians and Nutritionists'},
    {state:'Nebraska', amount:'55,900', profession:'Dietitians and Nutritionists'},
    {state:'Nevada', amount:'65,710', profession:'Dietitians and Nutritionists'},
    {state:'New Hampshire', amount:'60,900', profession:'Dietitians and Nutritionists'},
    {state:'New Jersey', amount:'68,810', profession:'Dietitians and Nutritionists'},
    {state:'New Mexico', amount:'54,300', profession:'Dietitians and Nutritionists'},
    {state:'New York', amount:'68,050', profession:'Dietitians and Nutritionists'},
    {state:'North Carolina', amount:'54,810', profession:'Dietitians and Nutritionists'},
    {state:'North Dakota', amount:'56,240', profession:'Dietitians and Nutritionists'},
    {state:'Ohio', amount:'57,500', profession:'Dietitians and Nutritionists'},
    {state:'Oklahoma', amount:'56,100', profession:'Dietitians and Nutritionists'},
    {state:'Oregon', amount:'68,590', profession:'Dietitians and Nutritionists'},
    {state:'Pennsylvania', amount:'56,440', profession:'Dietitians and Nutritionists'},
    {state:'Rhode Island', amount:'61,870', profession:'Dietitians and Nutritionists'},
    {state:'South Carolina', amount:'53,690', profession:'Dietitians and Nutritionists'},
    {state:'South Dakota', amount:'55,680', profession:'Dietitians and Nutritionists'},
    {state:'Tennessee', amount:'55,120', profession:'Dietitians and Nutritionists'},
    {state:'Texas', amount:'56,550', profession:'Dietitians and Nutritionists'},
    {state:'Utah', amount:'56,390', profession:'Dietitians and Nutritionists'},
    {state:'Vermont', amount:'57,640', profession:'Dietitians and Nutritionists'},
    {state:'Virginia', amount:'61,550', profession:'Dietitians and Nutritionists'},
    {state:'Washington', amount:'65,110', profession:'Dietitians and Nutritionists'},
    {state:'West Virginia', amount:'55,180', profession:'Dietitians and Nutritionists'},
    {state:'Wisconsin', amount:'55,760', profession:'Dietitians and Nutritionists'},
    {state:'Wyoming', amount:'63,120', profession:'Dietitians and Nutritionists'},
    {state:'Guam', amount:'53,360', profession:'Dietitians and Nutritionists'},
    {state:'Puerto Rico', amount:'41,350', profession:'Dietitians and Nutritionists'},

    // Logisticians
    {state:'Alabama', amount:'87,600', profession:'Logisticians'},
    {state:'Alaska', amount:'86,860', profession:'Logisticians'},
    {state:'Arizona', amount:'74,780', profession:'Logisticians'},
    {state:'Arkansas', amount:'70,320', profession:'Logisticians'},
    {state:'California', amount:'84,260', profession:'Logisticians'},
    {state:'Colorado', amount:'75,700', profession:'Logisticians'},
    {state:'Connecticut', amount:'77,940', profession:'Logisticians'},
    {state:'District of Columbia', amount:'95,000', profession:'Logisticians'},
    {state:'Florida', amount:'69,100', profession:'Logisticians'},
    {state:'Georgia', amount:'70,900', profession:'Logisticians'},
    {state:'Hawaii', amount:'84,540', profession:'Logisticians'},
    {state:'Idaho', amount:'74,700', profession:'Logisticians'},
    {state:'Illinois', amount:'67,490', profession:'Logisticians'},
    {state:'Indiana', amount:'70,830', profession:'Logisticians'},
    {state:'Iowa', amount:'63,560', profession:'Logisticians'},
    {state:'Kansas', amount:'72,990', profession:'Logisticians'},
    {state:'Kentucky', amount:'73,610', profession:'Logisticians'},
    {state:'Louisiana', amount:'79,010', profession:'Logisticians'},
    {state:'Maine', amount:'70,620', profession:'Logisticians'},
    {state:'Maryland', amount:'91,710', profession:'Logisticians'},
    {state:'Massachusetts', amount:'78,910', profession:'Logisticians'},
    {state:'Michigan', amount:'80,150', profession:'Logisticians'},
    {state:'Minnesota', amount:'75,250', profession:'Logisticians'},
    {state:'Mississippi', amount:'75,200', profession:'Logisticians'},
    {state:'Missouri', amount:'76,540', profession:'Logisticians'},
    {state:'Montana', amount:'71,800', profession:'Logisticians'},
    {state:'Nebraska', amount:'58,920', profession:'Logisticians'},
    {state:'Nevada', amount:'72,790', profession:'Logisticians'},
    {state:'New Hampshire', amount:'71,930', profession:'Logisticians'},
    {state:'New Jersey', amount:'84,240', profession:'Logisticians'},
    {state:'New Mexico', amount:'80,400', profession:'Logisticians'},
    {state:'New York', amount:'76,240', profession:'Logisticians'},
    {state:'North Carolina', amount:'76,600', profession:'Logisticians'},
    {state:'North Dakota', amount:'64,300', profession:'Logisticians'},
    {state:'Ohio', amount:'76,090', profession:'Logisticians'},
    {state:'Oklahoma', amount:'75,160', profession:'Logisticians'},
    {state:'Oregon', amount:'75,260', profession:'Logisticians'},
    {state:'Pennsylvania', amount:'80,370', profession:'Logisticians'},
    {state:'Rhode Island', amount:'105,730', profession:'Logisticians'},
    {state:'South Carolina', amount:'68,280', profession:'Logisticians'},
    {state:'South Dakota', amount:'73,940', profession:'Logisticians'},
    {state:'Tennessee', amount:'61,940', profession:'Logisticians'},
    {state:'Texas', amount:'86,500', profession:'Logisticians'},
    {state:'Utah', amount:'73,860', profession:'Logisticians'},
    {state:'Vermont', amount:'70,590', profession:'Logisticians'},
    {state:'Virginia', amount:'86,230', profession:'Logisticians'},
    {state:'Washington', amount:'90,240', profession:'Logisticians'},
    {state:'West Virginia', amount:'69,620', profession:'Logisticians'},
    {state:'Wisconsin', amount:'62,690', profession:'Logisticians'},
    {state:'Wyoming', amount:'79,020', profession:'Logisticians'},
    {state:'Guam', amount:'68,610', profession:'Logisticians'},
    {state:'Puerto Rico', amount:'46,020', profession:'Logisticians'},

    // Management Analysts
    {state:'Alabama', amount:'94,020', profession:'Management Analysts'},
    {state:'Alaska', amount:'94,680', profession:'Management Analysts'},
    {state:'Arizona', amount:'85,890', profession:'Management Analysts'},
    {state:'Arkansas', amount:'63,410', profession:'Management Analysts'},
    {state:'California', amount:'95,310', profession:'Management Analysts'},
    {state:'Colorado', amount:'94,100', profession:'Management Analysts'},
    {state:'Connecticut', amount:'103,780', profession:'Management Analysts'},
    {state:'Delaware', amount:'85,130', profession:'Management Analysts'},
    {state:'District of Columbia', amount:'106,210', profession:'Management Analysts'},
    {state:'Florida', amount:'79,630', profession:'Management Analysts'},
    {state:'Georgia', amount:'93,530', profession:'Management Analysts'},
    {state:'Hawaii', amount:'81,300', profession:'Management Analysts'},
    {state:'Idaho', amount:'79,680', profession:'Management Analysts'},
    {state:'Illinois', amount:'95,110', profession:'Management Analysts'},
    {state:'Indiana', amount:'83,000', profession:'Management Analysts'},
    {state:'Iowa', amount:'79,380', profession:'Management Analysts'},
    {state:'Kansas', amount:'77,690', profession:'Management Analysts'},
    {state:'Kentucky', amount:'72,850', profession:'Management Analysts'},
    {state:'Louisiana', amount:'80,370', profession:'Management Analysts'},
    {state:'Maine', amount:'72,630', profession:'Management Analysts'},
    {state:'Maryland', amount:'98,260', profession:'Management Analysts'},
    {state:'Massachusetts', amount:'110,150', profession:'Management Analysts'},
    {state:'Michigan', amount:'92,130', profession:'Management Analysts'},
    {state:'Minnesota', amount:'87,150', profession:'Management Analysts'},
    {state:'Mississippi', amount:'73,520', profession:'Management Analysts'},
    {state:'Missouri', amount:'81,300', profession:'Management Analysts'},
    {state:'Montana', amount:'72,860', profession:'Management Analysts'},
    {state:'Nebraska', amount:'80,060', profession:'Management Analysts'},
    {state:'Nevada', amount:'89,070', profession:'Management Analysts'},
    {state:'New Hampshire', amount:'101,990', profession:'Management Analysts'},
    {state:'New Jersey', amount:'105,680', profession:'Management Analysts'},
    {state:'New Mexico', amount:'81,240', profession:'Management Analysts'},
    {state:'New York', amount:'111,040', profession:'Management Analysts'},
    {state:'North Carolina', amount:'98,730', profession:'Management Analysts'},
    {state:'North Dakota', amount:'79,130', profession:'Management Analysts'},
    {state:'Ohio', amount:'90,730', profession:'Management Analysts'},
    {state:'Oklahoma', amount:'79,340', profession:'Management Analysts'},
    {state:'Oregon', amount:'86,660', profession:'Management Analysts'},
    {state:'Pennsylvania', amount:'90,670', profession:'Management Analysts'},
    {state:'Rhode Island', amount:'87,610', profession:'Management Analysts'},
    {state:'South Carolina', amount:'75,230', profession:'Management Analysts'},
    {state:'South Dakota', amount:'78,140', profession:'Management Analysts'},
    {state:'Tennessee', amount:'80,870', profession:'Management Analysts'},
    {state:'Texas', amount:'97,080', profession:'Management Analysts'},
    {state:'Utah', amount:'77,920', profession:'Management Analysts'},
    {state:'Vermont', amount:'91,340', profession:'Management Analysts'},
    {state:'Virginia', amount:'105,700', profession:'Management Analysts'},
    {state:'Washington', amount:'104,290', profession:'Management Analysts'},
    {state:'West Virginia', amount:'75,980', profession:'Management Analysts'},
    {state:'Wisconsin', amount:'80,220', profession:'Management Analysts'},
    {state:'Wyoming', amount:'98,780', profession:'Management Analysts'},
    {state:'Guam', amount:'61,160', profession:'Management Analysts'},
    {state:'Puerto Rico', amount:'61,300', profession:'Management Analysts'},
    {state:'Virgin Islands', amount:'71,660', profession:'Management Analysts'},

    // Social Workers, All Other
    {state:'Alabama', amount:'59,860', profession:'Social Workers, All Other'},
    {state:'Alaska', amount:'70,540', profession:'Social Workers, All Other'},
    {state:'Arizona', amount:'61,130', profession:'Social Workers, All Other'},
    {state:'Arkansas', amount:'49,680', profession:'Social Workers, All Other'},
    {state:'California', amount:'72,200', profession:'Social Workers, All Other'},
    {state:'Colorado', amount:'54,600', profession:'Social Workers, All Other'},
    {state:'Connecticut', amount:'65,230', profession:'Social Workers, All Other'},
    {state:'Delaware', amount:'60,780', profession:'Social Workers, All Other'},
    {state:'District of Columbia', amount:'82,900', profession:'Social Workers, All Other'},
    {state:'Florida', amount:'64,810', profession:'Social Workers, All Other'},
    {state:'Georgia', amount:'67,630', profession:'Social Workers, All Other'},
    {state:'Hawaii', amount:'81,790', profession:'Social Workers, All Other'},
    {state:'Idaho', amount:'70,610', profession:'Social Workers, All Other'},
    {state:'Illinois', amount:'61,640', profession:'Social Workers, All Other'},
    {state:'Indiana', amount:'65,010', profession:'Social Workers, All Other'},
    {state:'Iowa', amount:'61,460', profession:'Social Workers, All Other'},
    {state:'Kansas', amount:'55,610', profession:'Social Workers, All Other'},
    {state:'Kentucky', amount:'58,050', profession:'Social Workers, All Other'},
    {state:'Louisiana', amount:'57,380', profession:'Social Workers, All Other'},
    {state:'Maine', amount:'52,360', profession:'Social Workers, All Other'},
    {state:'Maryland', amount:'67,810', profession:'Social Workers, All Other'},
    {state:'Massachusetts', amount:'75,340', profession:'Social Workers, All Other'},
    {state:'Michigan', amount:'60,120', profession:'Social Workers, All Other'},
    {state:'Minnesota', amount:'64,300', profession:'Social Workers, All Other'},
    {state:'Mississippi', amount:'55,420', profession:'Social Workers, All Other'},
    {state:'Missouri', amount:'59,730', profession:'Social Workers, All Other'},
    {state:'Montana', amount:'43,980', profession:'Social Workers, All Other'},
    {state:'Nebraska', amount:'61,120', profession:'Social Workers, All Other'},
    {state:'Nevada', amount:'75,020', profession:'Social Workers, All Other'},
    {state:'New Hampshire', amount:'70,920', profession:'Social Workers, All Other'},
    {state:'New Jersey', amount:'68,630', profession:'Social Workers, All Other'},
    {state:'New Mexico', amount:'58,430', profession:'Social Workers, All Other'},
    {state:'New York', amount:'67,120', profession:'Social Workers, All Other'},
    {state:'North Carolina', amount:'57,310', profession:'Social Workers, All Other'},
    {state:'North Dakota', amount:'59,510', profession:'Social Workers, All Other'},
    {state:'Ohio', amount:'51,490', profession:'Social Workers, All Other'},
    {state:'Oklahoma', amount:'59,250', profession:'Social Workers, All Other'},
    {state:'Oregon', amount:'52,750', profession:'Social Workers, All Other'},
    {state:'Pennsylvania', amount:'64,260', profession:'Social Workers, All Other'},
    {state:'Rhode Island', amount:'75,710', profession:'Social Workers, All Other'},
    {state:'South Carolina', amount:'45,610', profession:'Social Workers, All Other'},
    {state:'South Dakota', amount:'71,330', profession:'Social Workers, All Other'},
    {state:'Tennessee', amount:'52,540', profession:'Social Workers, All Other'},
    {state:'Texas', amount:'69,070', profession:'Social Workers, All Other'},
    {state:'Utah', amount:'50,900', profession:'Social Workers, All Other'},
    {state:'Vermont', amount:'66,180', profession:'Social Workers, All Other'},
    {state:'Virginia', amount:'69,650', profession:'Social Workers, All Other'},
    {state:'Washington', amount:'73,180', profession:'Social Workers, All Other'},
    {state:'West Virginia', amount:'69,700', profession:'Social Workers, All Other'},
    {state:'Wisconsin', amount:'55,950', profession:'Social Workers, All Other'},
    {state:'Wyoming', amount:'56,620', profession:'Social Workers, All Other'},
    {state:'Guam', amount:'48,190', profession:'Social Workers, All Other'},
    {state:'Puerto Rico', amount:'33,350', profession:'Social Workers, All Other'},

    // Substance Abuse, Behavioral Disorder, and Mental Health Counselors
    {state:'Alabama', amount:'42,640', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Alaska', amount:'62,920', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Arizona', amount:'42,310', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Arkansas', amount:'52,110', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'California', amount:'50,950', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Colorado', amount:'48,490', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Connecticut', amount:'52,070', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Delaware', amount:'44,660', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'District of Columbia', amount:'59,850', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Florida', amount:'44,140', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Georgia', amount:'45,150', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Hawaii', amount:'54,550', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Idaho', amount:'46,920', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Illinois', amount:'44,250', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Indiana', amount:'44,550', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Iowa', amount:'47,600', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Kansas', amount:'41,330', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Kentucky', amount:'42,240', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Louisiana', amount:'40,380', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Maine', amount:'50,600', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Maryland', amount:'46,350', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Massachusetts', amount:'47,880', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Michigan', amount:'48,440', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Minnesota', amount:'49,280', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Mississippi', amount:'39,710', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Missouri', amount:'38,150', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Montana', amount:'45,160', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Nebraska', amount:'49,850', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Nevada', amount:'51,130', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New Hampshire', amount:'43,600', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New Jersey', amount:'58,410', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New Mexico', amount:'47,040', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New York', amount:'51,380', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'North Carolina', amount:'48,900', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'North Dakota', amount:'55,220', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Ohio', amount:'47,040', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Oklahoma', amount:'48,670', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Oregon', amount:'59,390', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Pennsylvania', amount:'45,740', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'South Carolina', amount:'38,410', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'South Dakota', amount:'41,790', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Tennessee', amount:'38,030', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Texas', amount:'47,010', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Utah', amount:'66,330', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Vermont', amount:'46,950', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Virginia', amount:'49,860', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Washington', amount:'48,430', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'West Virginia', amount:'39,950', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Wisconsin', amount:'42,650', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Wyoming', amount:'56,690', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Puerto Rico', amount:'26,610', profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},

    // Chiropractors
    {state:'Alabama', amount:'86,910', profession:'Chiropractors'},
    {state:'Alaska', amount:'93,160', profession:'Chiropractors'},
    {state:'Arizona', amount:'67,460', profession:'Chiropractors'},
    {state:'California', amount:'80,550', profession:'Chiropractors'},
    {state:'Colorado', amount:'87,290', profession:'Chiropractors'},
    {state:'Connecticut', amount:'99,530', profession:'Chiropractors'},
    {state:'Delaware', amount:'97,060', profession:'Chiropractors'},
    {state:'Florida', amount:'95,310', profession:'Chiropractors'},
    {state:'Georgia', amount:'69,160', profession:'Chiropractors'},
    {state:'Hawaii', amount:'86,590', profession:'Chiropractors'},
    {state:'Idaho', amount:'84,270', profession:'Chiropractors'},
    {state:'Illinois', amount:'90,620', profession:'Chiropractors'},
    {state:'Indiana', amount:'100,920', profession:'Chiropractors'},
    {state:'Iowa', amount:'81,670', profession:'Chiropractors'},
    {state:'Kansas', amount:'62,500', profession:'Chiropractors'},
    {state:'Kentucky', amount:'71,270', profession:'Chiropractors'},
    {state:'Louisiana', amount:'76,730', profession:'Chiropractors'},
    {state:'Maine', amount:'88,170', profession:'Chiropractors'},
    {state:'Maryland', amount:'95,070', profession:'Chiropractors'},
    {state:'Massachusetts', amount:'98,840', profession:'Chiropractors'},
    {state:'Michigan', amount:'66,410', profession:'Chiropractors'},
    {state:'Minnesota', amount:'89,400', profession:'Chiropractors'},
    {state:'Mississippi', amount:'89,290', profession:'Chiropractors'},
    {state:'Missouri', amount:'104,330', profession:'Chiropractors'},
    {state:'Montana', amount:'60,390', profession:'Chiropractors'},
    {state:'Nebraska', amount:'71,230', profession:'Chiropractors'},
    {state:'Nevada', amount:'95,330', profession:'Chiropractors'},
    {state:'New Hampshire', amount:'85,900', profession:'Chiropractors'},
    {state:'New Jersey', amount:'114,010', profession:'Chiropractors'},
    {state:'New Mexico', amount:'67,890', profession:'Chiropractors'},
    {state:'New York', amount:'83,800', profession:'Chiropractors'},
    {state:'North Carolina', amount:'100,320', profession:'Chiropractors'},
    {state:'North Dakota', amount:'77,630', profession:'Chiropractors'},
    {state:'Ohio', amount:'103,310', profession:'Chiropractors'},
    {state:'Oklahoma', amount:'67,500', profession:'Chiropractors'},
    {state:'Oregon', amount:'73,030', profession:'Chiropractors'},
    {state:'Pennsylvania', amount:'75,450', profession:'Chiropractors'},
    {state:'Rhode Island', amount:'115,350', profession:'Chiropractors'},
    {state:'South Carolina', amount:'91,910', profession:'Chiropractors'},
    {state:'South Dakota', amount:'85,630', profession:'Chiropractors'},
    {state:'Tennessee', amount:'114,630', profession:'Chiropractors'},
    {state:'Texas', amount:'83,730', profession:'Chiropractors'},
    {state:'Utah', amount:'54,220', profession:'Chiropractors'},
    {state:'Virginia', amount:'71,150', profession:'Chiropractors'},
    {state:'Washington', amount:'111,100', profession:'Chiropractors'},
    {state:'West Virginia', amount:'75,320', profession:'Chiropractors'},
    {state:'Wisconsin', amount:'89,020', profession:'Chiropractors'},
    {state:'Wyoming', amount:'71,740', profession:'Chiropractors'},
    {state:'Puerto Rico', amount:'40,460', profession:'Chiropractors'},

    // Emergency Medical Technicians and Paramedics
    {state:'Alabama', amount:'30,260', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Alaska', amount:'47,780', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Arizona', amount:'38,260', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Arkansas', amount:'31,800', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'California', amount:'39,350', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Colorado', amount:'42,320', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Connecticut', amount:'46,890', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Delaware', amount:'40,730', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'District of Columbia', amount:'57,270', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Florida', amount:'35,790', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Georgia', amount:'33,950', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Hawaii', amount:'54,370', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Idaho', amount:'37,960', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Illinois', amount:'41,940', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Indiana', amount:'34,040', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Iowa', amount:'35,760', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Kansas', amount:'30,520', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Kentucky', amount:'31,430', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Louisiana', amount:'36,930', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Maine', amount:'34,170', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Maryland', amount:'49,490', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Massachusetts', amount:'41,570', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Michigan', amount:'33,720', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Minnesota', amount:'42,460', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Mississippi', amount:'33,310', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Missouri', amount:'34,560', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Montana', amount:'33,020', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Nebraska', amount:'33,130', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Nevada', amount:'36,240', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'New Hampshire', amount:'38,390', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'New Jersey', amount:'37,460', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'New Mexico', amount:'35,660', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'New York', amount:'44,120', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'North Carolina', amount:'36,200', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'North Dakota', amount:'32,680', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Ohio', amount:'32,200', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Oklahoma', amount:'33,020', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Oregon', amount:'42,470', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Pennsylvania', amount:'33,980', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Rhode Island', amount:'40,070', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'South Carolina', amount:'34,570', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'South Dakota', amount:'32,360', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Tennessee', amount:'36,600', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Texas', amount:'36,620', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Utah', amount:'33,870', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Vermont', amount:'34,290', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Virginia', amount:'35,310', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Washington', amount:'67,600', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'West Virginia', amount:'30,690', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Wisconsin', amount:'34,780', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Wyoming', amount:'34,120', profession:'Emergency Medical Technicians and Paramedics'},
    {state:'Puerto Rico', amount:'22,030', profession:'Emergency Medical Technicians and Paramedics'},

    // Financial Analysts
    {state:'Alabama', amount:'88,350', profession:'Financial Analysts'},
    {state:'Alaska', amount:'101,720', profession:'Financial Analysts'},
    {state:'Arizona', amount:'78,650', profession:'Financial Analysts'},
    {state:'Arkansas', amount:'78,050', profession:'Financial Analysts'},
    {state:'California', amount:'109,640', profession:'Financial Analysts'},
    {state:'Colorado', amount:'109,120', profession:'Financial Analysts'},
    {state:'Connecticut', amount:'105,950', profession:'Financial Analysts'},
    {state:'Delaware', amount:'93,740', profession:'Financial Analysts'},
    {state:'District of Columbia', amount:'102,510', profession:'Financial Analysts'},
    {state:'Florida', amount:'78,280', profession:'Financial Analysts'},
    {state:'Georgia', amount:'84,350', profession:'Financial Analysts'},
    {state:'Hawaii', amount:'78,800', profession:'Financial Analysts'},
    {state:'Idaho', amount:'75,280', profession:'Financial Analysts'},
    {state:'Illinois', amount:'88,760', profession:'Financial Analysts'},
    {state:'Indiana', amount:'78,290', profession:'Financial Analysts'},
    {state:'Iowa', amount:'83,230', profession:'Financial Analysts'},
    {state:'Kansas', amount:'77,130', profession:'Financial Analysts'},
    {state:'Kentucky', amount:'69,830', profession:'Financial Analysts'},
    {state:'Louisiana', amount:'75,630', profession:'Financial Analysts'},
    {state:'Maine', amount:'79,610', profession:'Financial Analysts'},
    {state:'Maryland', amount:'92,800', profession:'Financial Analysts'},
    {state:'Massachusetts', amount:'105,540', profession:'Financial Analysts'},
    {state:'Michigan', amount:'84,410', profession:'Financial Analysts'},
    {state:'Minnesota', amount:'93,160', profession:'Financial Analysts'},
    {state:'Mississippi', amount:'74,230', profession:'Financial Analysts'},
    {state:'Missouri', amount:'91,800', profession:'Financial Analysts'},
    {state:'Montana', amount:'99,630', profession:'Financial Analysts'},
    {state:'Nebraska', amount:'70,740', profession:'Financial Analysts'},
    {state:'Nevada', amount:'83,370', profession:'Financial Analysts'},
    {state:'New Hampshire', amount:'94,680', profession:'Financial Analysts'},
    {state:'New Jersey', amount:'106,100', profession:'Financial Analysts'},
    {state:'New Mexico', amount:'103,040', profession:'Financial Analysts'},
    {state:'New York', amount:'137,270', profession:'Financial Analysts'},
    {state:'North Carolina', amount:'89,020', profession:'Financial Analysts'},
    {state:'North Dakota', amount:'82,770', profession:'Financial Analysts'},
    {state:'Ohio', amount:'80,060', profession:'Financial Analysts'},
    {state:'Oklahoma', amount:'70,300', profession:'Financial Analysts'},
    {state:'Oregon', amount:'92,640', profession:'Financial Analysts'},
    {state:'Pennsylvania', amount:'93,870', profession:'Financial Analysts'},
    {state:'Rhode Island', amount:'80,650', profession:'Financial Analysts'},
    {state:'South Carolina', amount:'80,690', profession:'Financial Analysts'},
    {state:'South Dakota', amount:'73,870', profession:'Financial Analysts'},
    {state:'Tennessee', amount:'74,870', profession:'Financial Analysts'},
    {state:'Texas', amount:'94,980', profession:'Financial Analysts'},
    {state:'Utah', amount:'78,510', profession:'Financial Analysts'},
    {state:'Vermont', amount:'84,300', profession:'Financial Analysts'},
    {state:'Virginia', amount:'97,990', profession:'Financial Analysts'},
    {state:'Washington', amount:'87,590', profession:'Financial Analysts'},
    {state:'West Virginia', amount:'75,290', profession:'Financial Analysts'},
    {state:'Wisconsin', amount:'81,000', profession:'Financial Analysts'},
    {state:'Wyoming', amount:'139,660', profession:'Financial Analysts'},
    {state:'Puerto Rico', amount:'55,000', profession:'Financial Analysts'},
    {state:'Virgin Islands', amount:'58,930', profession:'Financial Analysts'},

    // Child, Family, and School Social Workers
    {state:'Alabama', amount:'40,710', profession:'Child, Family, and School Social Workers'},
    {state:'Alaska', amount:'48,970', profession:'Child, Family, and School Social Workers'},
    {state:'Arizona', amount:'39,020', profession:'Child, Family, and School Social Workers'},
    {state:'Arkansas', amount:'38,270', profession:'Child, Family, and School Social Workers'},
    {state:'California', amount:'59,500', profession:'Child, Family, and School Social Workers'},
    {state:'Colorado', amount:'51,060', profession:'Child, Family, and School Social Workers'},
    {state:'Connecticut', amount:'69,520', profession:'Child, Family, and School Social Workers'},
    {state:'Delaware', amount:'40,380', profession:'Child, Family, and School Social Workers'},
    {state:'District of Columbia', amount:'70,270', profession:'Child, Family, and School Social Workers'},
    {state:'Florida', amount:'42,640', profession:'Child, Family, and School Social Workers'},
    {state:'Georgia', amount:'41,040', profession:'Child, Family, and School Social Workers'},
    {state:'Hawaii', amount:'56,030', profession:'Child, Family, and School Social Workers'},
    {state:'Idaho', amount:'52,110', profession:'Child, Family, and School Social Workers'},
    {state:'Illinois', amount:'56,100', profession:'Child, Family, and School Social Workers'},
    {state:'Indiana', amount:'40,090', profession:'Child, Family, and School Social Workers'},
    {state:'Iowa', amount:'44,720', profession:'Child, Family, and School Social Workers'},
    {state:'Kansas', amount:'42,510', profession:'Child, Family, and School Social Workers'},
    {state:'Kentucky', amount:'40,950', profession:'Child, Family, and School Social Workers'},
    {state:'Louisiana', amount:'50,690', profession:'Child, Family, and School Social Workers'},
    {state:'Maine', amount:'52,130', profession:'Child, Family, and School Social Workers'},
    {state:'Maryland', amount:'59,280', profession:'Child, Family, and School Social Workers'},
    {state:'Massachusetts', amount:'48,670', profession:'Child, Family, and School Social Workers'},
    {state:'Michigan', amount:'50,620', profession:'Child, Family, and School Social Workers'},
    {state:'Minnesota', amount:'55,560', profession:'Child, Family, and School Social Workers'},
    {state:'Mississippi', amount:'35,100', profession:'Child, Family, and School Social Workers'},
    {state:'Missouri', amount:'37,680', profession:'Child, Family, and School Social Workers'},
    {state:'Montana', amount:'38,210', profession:'Child, Family, and School Social Workers'},
    {state:'Nebraska', amount:'41,560', profession:'Child, Family, and School Social Workers'},
    {state:'Nevada', amount:'52,410', profession:'Child, Family, and School Social Workers'},
    {state:'New Hampshire', amount:'52,920', profession:'Child, Family, and School Social Workers'},
    {state:'New Jersey', amount:'67,700', profession:'Child, Family, and School Social Workers'},
    {state:'New Mexico', amount:'41,460', profession:'Child, Family, and School Social Workers'},
    {state:'New York', amount:'58,050', profession:'Child, Family, and School Social Workers'},
    {state:'North Carolina', amount:'46,990', profession:'Child, Family, and School Social Workers'},
    {state:'North Dakota', amount:'54,870', profession:'Child, Family, and School Social Workers'},
    {state:'Ohio', amount:'45,030', profession:'Child, Family, and School Social Workers'},
    {state:'Oklahoma', amount:'36,470', profession:'Child, Family, and School Social Workers'},
    {state:'Oregon', amount:'51,510', profession:'Child, Family, and School Social Workers'},
    {state:'Pennsylvania', amount:'43,680', profession:'Child, Family, and School Social Workers'},
    {state:'Rhode Island', amount:'61,440', profession:'Child, Family, and School Social Workers'},
    {state:'South Carolina', amount:'38,930', profession:'Child, Family, and School Social Workers'},
    {state:'South Dakota', amount:'40,030', profession:'Child, Family, and School Social Workers'},
    {state:'Tennessee', amount:'41,830', profession:'Child, Family, and School Social Workers'},
    {state:'Texas', amount:'48,920', profession:'Child, Family, and School Social Workers'},
    {state:'Utah', amount:'44,160', profession:'Child, Family, and School Social Workers'},
    {state:'Vermont', amount:'50,270', profession:'Child, Family, and School Social Workers'},
    {state:'Virginia', amount:'51,880', profession:'Child, Family, and School Social Workers'},
    {state:'Washington', amount:'51,990', profession:'Child, Family, and School Social Workers'},
    {state:'West Virginia', amount:'36,430', profession:'Child, Family, and School Social Workers'},
    {state:'Wisconsin', amount:'48,440', profession:'Child, Family, and School Social Workers'},
    {state:'Wyoming', amount:'50,200', profession:'Child, Family, and School Social Workers'},
    {state:'Guam', amount:'38,230', profession:'Child, Family, and School Social Workers'},
    {state:'Puerto Rico', amount:'31,500', profession:'Child, Family, and School Social Workers'},

    // Genetic Counselors
    {state:'Alabama', amount:'48,800', profession:'Genetic Counselors'},
    {state:'Arizona', amount:'80,160', profession:'Genetic Counselors'},
    {state:'California', amount:'89,530', profession:'Genetic Counselors'},
    {state:'Colorado', amount:'87,290', profession:'Genetic Counselors'},
    {state:'District of Columbia', amount:'79,300', profession:'Genetic Counselors'},
    {state:'Florida', amount:'54,730', profession:'Genetic Counselors'},
    {state:'Georgia', amount:'82,370', profession:'Genetic Counselors'},
    {state:'Illinois', amount:'83,580', profession:'Genetic Counselors'},
    {state:'Indiana', amount:'74,950', profession:'Genetic Counselors'},
    {state:'Maryland', amount:'68,370', profession:'Genetic Counselors'},
    {state:'Massachusetts', amount:'83,540', profession:'Genetic Counselors'},
    {state:'Michigan', amount:'71,710', profession:'Genetic Counselors'},
    {state:'Minnesota', amount:'78,550', profession:'Genetic Counselors'},
    {state:'Missouri', amount:'72,780', profession:'Genetic Counselors'},
    {state:'Nevada', amount:'95,830', profession:'Genetic Counselors'},
    {state:'New Jersey', amount:'85,420', profession:'Genetic Counselors'},
    {state:'New York', amount:'86,810', profession:'Genetic Counselors'},
    {state:'North Carolina', amount:'71,600', profession:'Genetic Counselors'},
    {state:'Ohio', amount:'77,110', profession:'Genetic Counselors'},
    {state:'Oregon', amount:'80,870', profession:'Genetic Counselors'},
    {state:'Pennsylvania', amount:'73,410', profession:'Genetic Counselors'},
    {state:'South Carolina', amount:'81,140', profession:'Genetic Counselors'},
    {state:'Tennessee', amount:'75,680', profession:'Genetic Counselors'},
    {state:'Texas', amount:'92,960', profession:'Genetic Counselors'},
    {state:'Utah', amount:'85,330', profession:'Genetic Counselors'},
    {state:'Washington', amount:'84,450', profession:'Genetic Counselors'},
    {state:'Wisconsin', amount:'82,070', profession:'Genetic Counselors'},

    // High School Teachers
    {state:'Alabama', amount:'51,180', profession:'High School Teachers'},
    {state:'Alaska', amount:'77,920', profession:'High School Teachers'},
    {state:'Arizona', amount:'48,610', profession:'High School Teachers'},
    {state:'Arkansas', amount:'51,780', profession:'High School Teachers'},
    {state:'California', amount:'80,510', profession:'High School Teachers'},
    {state:'Colorado', amount:'55,110', profession:'High School Teachers'},
    {state:'Connecticut', amount:'76,980', profession:'High School Teachers'},
    {state:'Delaware', amount:'65,040', profession:'High School Teachers'},
    {state:'District of Columbia', amount:'65,180', profession:'High School Teachers'},
    {state:'Florida', amount:'54,120', profession:'High School Teachers'},
    {state:'Georgia', amount:'58,050', profession:'High School Teachers'},
    {state:'Hawaii', amount:'60,810', profession:'High School Teachers'},
    {state:'Idaho', amount:'51,170', profession:'High School Teachers'},
    {state:'Illinois', amount:'72,370', profession:'High School Teachers'},
    {state:'Indiana', amount:'53,030', profession:'High School Teachers'},
    {state:'Iowa', amount:'56,510', profession:'High School Teachers'},
    {state:'Kansas', amount:'51,490', profession:'High School Teachers'},
    {state:'Kentucky', amount:'56,200', profession:'High School Teachers'},
    {state:'Louisiana', amount:'51,810', profession:'High School Teachers'},
    {state:'Maine', amount:'54,240', profession:'High School Teachers'},
    {state:'Maryland', amount:'72,610', profession:'High School Teachers'},
    {state:'Massachusetts', amount:'80,020', profession:'High School Teachers'},
    {state:'Michigan', amount:'62,950', profession:'High School Teachers'},
    {state:'Minnesota', amount:'64,610', profession:'High School Teachers'},
    {state:'Mississippi', amount:'47,190', profession:'High School Teachers'},
    {state:'Missouri', amount:'54,280', profession:'High School Teachers'},
    {state:'Montana', amount:'50,670', profession:'High School Teachers'},
    {state:'Nebraska', amount:'57,500', profession:'High School Teachers'},
    {state:'Nevada', amount:'57,910', profession:'High School Teachers'},
    {state:'New Hampshire', amount:'61,510', profession:'High School Teachers'},
    {state:'New Jersey', amount:'76,390', profession:'High School Teachers'},
    {state:'New Mexico', amount:'55,380', profession:'High School Teachers'},
    {state:'New York', amount:'85,300', profession:'High School Teachers'},
    {state:'North Carolina', amount:'47,580', profession:'High School Teachers'},
    {state:'North Dakota', amount:'55,400', profession:'High School Teachers'},
    {state:'Ohio', amount:'61,930', profession:'High School Teachers'},
    {state:'Oklahoma', amount:'42,540', profession:'High School Teachers'},
    {state:'Oregon', amount:'72,640', profession:'High School Teachers'},
    {state:'Pennsylvania', amount:'64,830', profession:'High School Teachers'},
    {state:'Rhode Island', amount:'71,440', profession:'High School Teachers'},
    {state:'South Carolina', amount:'54,400', profession:'High School Teachers'},
    {state:'South Dakota', amount:'42,960', profession:'High School Teachers'},
    {state:'Tennessee', amount:'53,620', profession:'High School Teachers'},
    {state:'Texas', amount:'58,190', profession:'High School Teachers'},
    {state:'Utah', amount:'59,070', profession:'High School Teachers'},
    {state:'Vermont', amount:'65,850', profession:'High School Teachers'},
    {state:'Virginia', amount:'68,770', profession:'High School Teachers'},
    {state:'Washington', amount:'67,550', profession:'High School Teachers'},
    {state:'West Virginia', amount:'47,050', profession:'High School Teachers'},
    {state:'Wisconsin', amount:'58,360', profession:'High School Teachers'},
    {state:'Wyoming', amount:'60,620', profession:'High School Teachers'},
    {state:'Guam', amount:'50,460', profession:'High School Teachers'},

    // Marriage and Family Therapists
    {state:'Alabama', amount:'40,540', profession:'Marriage and Family Therapists'},
    {state:'Alaska', amount:'64,200', profession:'Marriage and Family Therapists'},
    {state:'Arizona', amount:'48,390', profession:'Marriage and Family Therapists'},
    {state:'Arkansas', amount:'48,610', profession:'Marriage and Family Therapists'},
    {state:'California', amount:'51,950', profession:'Marriage and Family Therapists'},
    {state:'Colorado', amount:'74,900', profession:'Marriage and Family Therapists'},
    {state:'Connecticut', amount:'61,750', profession:'Marriage and Family Therapists'},
    {state:'Delaware', amount:'51,540', profession:'Marriage and Family Therapists'},
    {state:'District of Columbia', amount:'49,750', profession:'Marriage and Family Therapists'},
    {state:'Florida', amount:'50,680', profession:'Marriage and Family Therapists'},
    {state:'Georgia', amount:'68,470', profession:'Marriage and Family Therapists'},
    {state:'Hawaii', amount:'79,660', profession:'Marriage and Family Therapists'},
    {state:'Idaho', amount:'52,150', profession:'Marriage and Family Therapists'},
    {state:'Illinois', amount:'47,200', profession:'Marriage and Family Therapists'},
    {state:'Indiana', amount:'47,110', profession:'Marriage and Family Therapists'},
    {state:'Iowa', amount:'54,030', profession:'Marriage and Family Therapists'},
    {state:'Kansas', amount:'42,390', profession:'Marriage and Family Therapists'},
    {state:'Kentucky', amount:'41,280', profession:'Marriage and Family Therapists'},
    {state:'Louisiana', amount:'37,530', profession:'Marriage and Family Therapists'},
    {state:'Maine', amount:'75,460', profession:'Marriage and Family Therapists'},
    {state:'Maryland', amount:'49,650', profession:'Marriage and Family Therapists'},
    {state:'Massachusetts', amount:'57,020', profession:'Marriage and Family Therapists'},
    {state:'Michigan', amount:'53,680', profession:'Marriage and Family Therapists'},
    {state:'Minnesota', amount:'57,770', profession:'Marriage and Family Therapists'},
    {state:'Mississippi', amount:'38,910', profession:'Marriage and Family Therapists'},
    {state:'Missouri', amount:'50,840', profession:'Marriage and Family Therapists'},
    {state:'Montana', amount:'45,310', profession:'Marriage and Family Therapists'},
    {state:'Nebraska', amount:'48,850', profession:'Marriage and Family Therapists'},
    {state:'Nevada', amount:'54,290', profession:'Marriage and Family Therapists'},
    {state:'New Hampshire', amount:'43,400', profession:'Marriage and Family Therapists'},
    {state:'New Jersey', amount:'72,380', profession:'Marriage and Family Therapists'},
    {state:'New Mexico', amount:'49,500', profession:'Marriage and Family Therapists'},
    {state:'New York', amount:'49,420', profession:'Marriage and Family Therapists'},
    {state:'North Carolina', amount:'54,320', profession:'Marriage and Family Therapists'},
    {state:'North Dakota', amount:'45,210', profession:'Marriage and Family Therapists'},
    {state:'Ohio', amount:'46,180', profession:'Marriage and Family Therapists'},
    {state:'Oklahoma', amount:'54,850', profession:'Marriage and Family Therapists'},
    {state:'Oregon', amount:'58,050', profession:'Marriage and Family Therapists'},
    {state:'Pennsylvania', amount:'58,400', profession:'Marriage and Family Therapists'},
    {state:'South Dakota', amount:'40,000', profession:'Marriage and Family Therapists'},
    {state:'Tennessee', amount:'39,920', profession:'Marriage and Family Therapists'},
    {state:'Texas', amount:'45,820', profession:'Marriage and Family Therapists'},
    {state:'Utah', amount:'70,960', profession:'Marriage and Family Therapists'},
    {state:'Virginia', amount:'54,250', profession:'Marriage and Family Therapists'},
    {state:'Washington', amount:'47,470', profession:'Marriage and Family Therapists'},
    {state:'West Virginia', amount:'43,460', profession:'Marriage and Family Therapists'},
    {state:'Wisconsin', amount:'51,070', profession:'Marriage and Family Therapists'},
    {state:'Wyoming', amount:'63,690', profession:'Marriage and Family Therapists'},

    // Biochemists and Biophysicist
    {state:'Alabama', amount:'87,520', profession:'Biochemists and Biophysicists'},
    {state:'Arizona', amount:'96,610', profession:'Biochemists and Biophysicists'},
    {state:'California', amount:'101,770', profession:'Biochemists and Biophysicists'},
    {state:'Colorado', amount:'82,940', profession:'Biochemists and Biophysicists'},
    {state:'Delaware', amount:'93,530', profession:'Biochemists and Biophysicists'},
    {state:'Florida', amount:'82,830', profession:'Biochemists and Biophysicists'},
    {state:'Georgia', amount:'89,450', profession:'Biochemists and Biophysicists'},
    {state:'Illinois', amount:'111,760', profession:'Biochemists and Biophysicists'},
    {state:'Indiana', amount:'107,040', profession:'Biochemists and Biophysicists'},
    {state:'Iowa', amount:'63,890', profession:'Biochemists and Biophysicists'},
    {state:'Kentucky', amount:'84,320', profession:'Biochemists and Biophysicists'},
    {state:'Maine', amount:'74,430', profession:'Biochemists and Biophysicists'},
    {state:'Maryland', amount:'99,370', profession:'Biochemists and Biophysicists'},
    {state:'Massachusetts', amount:'104,650', profession:'Biochemists and Biophysicists'},
    {state:'Michigan', amount:'79,560', profession:'Biochemists and Biophysicists'},
    {state:'Minnesota', amount:'77,740', profession:'Biochemists and Biophysicists'},
    {state:'Missouri', amount:'92,000', profession:'Biochemists and Biophysicists'},
    {state:'New Hampshire', amount:'102,910', profession:'Biochemists and Biophysicists'},
    {state:'New Jersey', amount:'145,180', profession:'Biochemists and Biophysicists'},
    {state:'New York', amount:'68,990', profession:'Biochemists and Biophysicists'},
    {state:'North Carolina', amount:'90,150', profession:'Biochemists and Biophysicists'},
    {state:'Ohio', amount:'62,140', profession:'Biochemists and Biophysicists'},
    {state:'Oregon', amount:'79,130', profession:'Biochemists and Biophysicists'},
    {state:'Pennsylvania', amount:'94,860', profession:'Biochemists and Biophysicists'},
    {state:'Tennessee', amount:'95,440', profession:'Biochemists and Biophysicists'},
    {state:'Texas', amount:'88,680', profession:'Biochemists and Biophysicists'},
    {state:'Utah', amount:'67,210', profession:'Biochemists and Biophysicists'},
    {state:'Washington', amount:'74,370', profession:'Biochemists and Biophysicists'},
    {state:'Wisconsin', amount:'82,170', profession:'Biochemists and Biophysicists'},
    {state:'West Virginia', amount:'100', profession:'Biochemists and Biophysicists'},
    {state:'Wisconsin', amount:'330', profession:'Biochemists and Biophysicists'},

    // Licensed Practical and Licensed Vocational Nurses
    {state:'Alabama', amount:'38,230', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Alaska', amount:'58,250', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Arizona', amount:'54,090', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Arkansas', amount:'39,570', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'California', amount:'56,200', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Colorado', amount:'51,210', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Connecticut', amount:'56,970', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Delaware', amount:'52,860', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'District of Columbia', amount:'53,370', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Florida', amount:'44,400', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Georgia', amount:'41,690', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Hawaii', amount:'50,930', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Idaho', amount:'44,280', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Illinois', amount:'51,080', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Indiana', amount:'44,310', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Iowa', amount:'42,820', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Kansas', amount:'43,240', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Kentucky', amount:'41,920', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Louisiana', amount:'39,480', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Maine', amount:'45,610', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Maryland', amount:'53,650', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Massachusetts', amount:'58,990', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Michigan', amount:'49,040', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Minnesota', amount:'47,020', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Mississippi', amount:'37,930', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Missouri', amount:'42,580', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Montana', amount:'43,770', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Nebraska', amount:'43,160', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Nevada', amount:'57,140', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'New Hampshire', amount:'52,510', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'New Jersey', amount:'56,290', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'New Mexico', amount:'47,560', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'New York', amount:'48,770', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'North Carolina', amount:'44,610', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'North Dakota', amount:'46,410', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Ohio', amount:'43,430', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Oklahoma', amount:'41,260', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Oregon', amount:'53,240', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Pennsylvania', amount:'48,120', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Rhode Island', amount:'59,130', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'South Carolina', amount:'40,890', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'South Dakota', amount:'38,630', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Tennessee', amount:'40,120', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Texas', amount:'46,990', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Utah', amount:'48,130', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Vermont', amount:'49,720', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Virginia', amount:'44,850', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Washington', amount:'55,420', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'West Virginia', amount:'36,770', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Wisconsin', amount:'45,290', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Wyoming', amount:'46,790', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Guam', amount:'34,700', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Puerto Rico', amount:'23,530', profession:'Licensed Practical and Licensed Vocational Nurses'},
    {state:'Virgin Islands', amount:'46,970', profession:'Licensed Practical and Licensed Vocational Nurses'},

    // Medical Secretaries
    {state:'Alabama', amount:'34,050', profession:'Medical Secretaries'},
    {state:'Alaska', amount:'40,820', profession:'Medical Secretaries'},
    {state:'Arizona', amount:'36,110', profession:'Medical Secretaries'},
    {state:'Arkansas', amount:'32,380', profession:'Medical Secretaries'},
    {state:'California', amount:'42,900', profession:'Medical Secretaries'},
    {state:'Colorado', amount:'38,890', profession:'Medical Secretaries'},
    {state:'Connecticut', amount:'42,270', profession:'Medical Secretaries'},
    {state:'Delaware', amount:'37,110', profession:'Medical Secretaries'},
    {state:'District of Columbia', amount:'50,370', profession:'Medical Secretaries'},
    {state:'Florida', amount:'33,520', profession:'Medical Secretaries'},
    {state:'Georgia', amount:'35,060', profession:'Medical Secretaries'},
    {state:'Hawaii', amount:'42,010', profession:'Medical Secretaries'},
    {state:'Idaho', amount:'34,270', profession:'Medical Secretaries'},
    {state:'Illinois', amount:'36,320', profession:'Medical Secretaries'},
    {state:'Indiana', amount:'35,030', profession:'Medical Secretaries'},
    {state:'Iowa', amount:'35,860', profession:'Medical Secretaries'},
    {state:'Kansas', amount:'34,280', profession:'Medical Secretaries'},
    {state:'Kentucky', amount:'32,220', profession:'Medical Secretaries'},
    {state:'Louisiana', amount:'30,660', profession:'Medical Secretaries'},
    {state:'Maine', amount:'34,390', profession:'Medical Secretaries'},
    {state:'Maryland', amount:'39,200', profession:'Medical Secretaries'},
    {state:'Massachusetts', amount:'43,450', profession:'Medical Secretaries'},
    {state:'Michigan', amount:'35,370', profession:'Medical Secretaries'},
    {state:'Minnesota', amount:'42,750', profession:'Medical Secretaries'},
    {state:'Mississippi', amount:'30,760', profession:'Medical Secretaries'},
    {state:'Missouri', amount:'34,270', profession:'Medical Secretaries'},
    {state:'Montana', amount:'32,540', profession:'Medical Secretaries'},
    {state:'Nebraska', amount:'34,160', profession:'Medical Secretaries'},
    {state:'Nevada', amount:'37,440', profession:'Medical Secretaries'},
    {state:'New Hampshire', amount:'40,200', profession:'Medical Secretaries'},
    {state:'New Jersey', amount:'42,670', profession:'Medical Secretaries'},
    {state:'New Mexico', amount:'32,680', profession:'Medical Secretaries'},
    {state:'New York', amount:'40,850', profession:'Medical Secretaries'},
    {state:'North Carolina', amount:'33,790', profession:'Medical Secretaries'},
    {state:'North Dakota', amount:'37,790', profession:'Medical Secretaries'},
    {state:'Ohio', amount:'34,450', profession:'Medical Secretaries'},
    {state:'Oklahoma', amount:'32,080', profession:'Medical Secretaries'},
    {state:'Oregon', amount:'40,000', profession:'Medical Secretaries'},
    {state:'Pennsylvania', amount:'35,550', profession:'Medical Secretaries'},
    {state:'Rhode Island', amount:'38,160', profession:'Medical Secretaries'},
    {state:'South Carolina', amount:'35,250', profession:'Medical Secretaries'},
    {state:'South Dakota', amount:'35,380', profession:'Medical Secretaries'},
    {state:'Tennessee', amount:'32,720', profession:'Medical Secretaries'},
    {state:'Texas', amount:'34,150', profession:'Medical Secretaries'},
    {state:'Utah', amount:'33,090', profession:'Medical Secretaries'},
    {state:'Vermont', amount:'39,440', profession:'Medical Secretaries'},
    {state:'Virginia', amount:'37,940', profession:'Medical Secretaries'},
    {state:'Washington', amount:'42,680', profession:'Medical Secretaries'},
    {state:'West Virginia', amount:'30,270', profession:'Medical Secretaries'},
    {state:'Wisconsin', amount:'35,830', profession:'Medical Secretaries'},
    {state:'Wyoming', amount:'34,760', profession:'Medical Secretaries'},
    {state:'Guam', amount:'27,840', profession:'Medical Secretaries'},
    {state:'Puerto Rico', amount:'21,990', profession:'Medical Secretaries'},
    {state:'Virgin Islands', amount:'30,020', profession:'Medical Secretaries'},

    // Loan Officers
    {state:'Alabama', amount:'67,860', profession:'Loan Officers'},
    {state:'Alaska', amount:'71,120', profession:'Loan Officers'},
    {state:'Arizona', amount:'62,430', profession:'Loan Officers'},
    {state:'Arkansas', amount:'73,990', profession:'Loan Officers'},
    {state:'California', amount:'78,940', profession:'Loan Officers'},
    {state:'Colorado', amount:'71,010', profession:'Loan Officers'},
    {state:'Connecticut', amount:'91,730', profession:'Loan Officers'},
    {state:'Delaware', amount:'70,100', profession:'Loan Officers'},
    {state:'District of Columbia', amount:'95,000', profession:'Loan Officers'},
    {state:'Florida', amount:'78,000', profession:'Loan Officers'},
    {state:'Georgia', amount:'75,060', profession:'Loan Officers'},
    {state:'Hawaii', amount:'72,790', profession:'Loan Officers'},
    {state:'Idaho', amount:'60,810', profession:'Loan Officers'},
    {state:'Illinois', amount:'81,620', profession:'Loan Officers'},
    {state:'Indiana', amount:'67,450', profession:'Loan Officers'},
    {state:'Iowa', amount:'67,580', profession:'Loan Officers'},
    {state:'Kansas', amount:'84,320', profession:'Loan Officers'},
    {state:'Kentucky', amount:'67,450', profession:'Loan Officers'},
    {state:'Louisiana', amount:'56,190', profession:'Loan Officers'},
    {state:'Maine', amount:'76,340', profession:'Loan Officers'},
    {state:'Maryland', amount:'84,240', profession:'Loan Officers'},
    {state:'Massachusetts', amount:'94,540', profession:'Loan Officers'},
    {state:'Minnesota', amount:'79,420', profession:'Loan Officers'},
    {state:'Mississippi', amount:'65,360', profession:'Loan Officers'},
    {state:'Missouri', amount:'76,550', profession:'Loan Officers'},
    {state:'Montana', amount:'63,910', profession:'Loan Officers'},
    {state:'Nebraska', amount:'81,740', profession:'Loan Officers'},
    {state:'Nevada', amount:'80,290', profession:'Loan Officers'},
    {state:'New Hampshire', amount:'90,500', profession:'Loan Officers'},
    {state:'New Jersey', amount:'85,540', profession:'Loan Officers'},
    {state:'New Mexico', amount:'63,320', profession:'Loan Officers'},
    {state:'New York', amount:'103,450', profession:'Loan Officers'},
    {state:'North Carolina', amount:'72,210', profession:'Loan Officers'},
    {state:'North Dakota', amount:'74,330', profession:'Loan Officers'},
    {state:'Ohio', amount:'72,030', profession:'Loan Officers'},
    {state:'Oklahoma', amount:'67,810', profession:'Loan Officers'},
    {state:'Oregon', amount:'76,680', profession:'Loan Officers'},
    {state:'Pennsylvania', amount:'68,280', profession:'Loan Officers'},
    {state:'Rhode Island', amount:'69,500', profession:'Loan Officers'},
    {state:'South Carolina', amount:'69,240', profession:'Loan Officers'},
    {state:'South Dakota', amount:'63,230', profession:'Loan Officers'},
    {state:'Tennessee', amount:'63,810', profession:'Loan Officers'},
    {state:'Texas', amount:'83,910', profession:'Loan Officers'},
    {state:'Utah', amount:'57,640', profession:'Loan Officers'},
    {state:'Vermont', amount:'66,350', profession:'Loan Officers'},
    {state:'Virginia', amount:'80,440', profession:'Loan Officers'},
    {state:'Washington', amount:'74,830', profession:'Loan Officers'},
    {state:'West Virginia', amount:'55,370', profession:'Loan Officers'},
    {state:'Wisconsin', amount:'73,390', profession:'Loan Officers'},
    {state:'Wyoming', amount:'69,530', profession:'Loan Officers'},
    {state:'Guam', amount:'49,540', profession:'Loan Officers'},
    {state:'Puerto Rico', amount:'38,150', profession:'Loan Officers'},

    // Sales Managers
    {state:'Alabama', amount:'115,750', profession:'Sales Managers'},
    {state:'Alaska', amount:'109,210', profession:'Sales Managers'},
    {state:'Arizona', amount:'113,430', profession:'Sales Managers'},
    {state:'Arkansas', amount:'119,090', profession:'Sales Managers'},
    {state:'California', amount:'134,010', profession:'Sales Managers'},
    {state:'Colorado', amount:'160,320', profession:'Sales Managers'},
    {state:'Connecticut', amount:'152,760', profession:'Sales Managers'},
    {state:'Delaware', amount:'174,940', profession:'Sales Managers'},
    {state:'District of Columbia', amount:'132,870', profession:'Sales Managers'},
    {state:'Florida', amount:'125,050', profession:'Sales Managers'},
    {state:'Georgia', amount:'140,820', profession:'Sales Managers'},
    {state:'Hawaii', amount:'101,480', profession:'Sales Managers'},
    {state:'Idaho', amount:'103,780', profession:'Sales Managers'},
    {state:'Illinois', amount:'131,400', profession:'Sales Managers'},
    {state:'Indiana', amount:'129,020', profession:'Sales Managers'},
    {state:'Iowa', amount:'117,170', profession:'Sales Managers'},
    {state:'Kansas', amount:'147,230', profession:'Sales Managers'},
    {state:'Kentucky', amount:'121,260', profession:'Sales Managers'},
    {state:'Louisiana', amount:'106,850', profession:'Sales Managers'},
    {state:'Maine', amount:'121,130', profession:'Sales Managers'},
    {state:'Maryland', amount:'147,530', profession:'Sales Managers'},
    {state:'Massachusetts', amount:'151,010', profession:'Sales Managers'},
    {state:'Michigan', amount:'142,340', profession:'Sales Managers'},
    {state:'Minnesota', amount:'132,420', profession:'Sales Managers'},
    {state:'Mississippi', amount:'108,100', profession:'Sales Managers'},
    {state:'Missouri', amount:'133,570', profession:'Sales Managers'},
    {state:'Nebraska', amount:'107,030', profession:'Sales Managers'},
    {state:'New Hampshire', amount:'152,120', profession:'Sales Managers'},
    {state:'New Jersey', amount:'168,950', profession:'Sales Managers'},
    {state:'New Mexico', amount:'105,240', profession:'Sales Managers'},
    {state:'New York', amount:'198,390', profession:'Sales Managers'},
    {state:'North Carolina', amount:'147,690', profession:'Sales Managers'},
    {state:'North Dakota', amount:'108,500', profession:'Sales Managers'},
    {state:'Ohio', amount:'134,600', profession:'Sales Managers'},
    {state:'Oklahoma', amount:'111,360', profession:'Sales Managers'},
    {state:'Oregon', amount:'126,340', profession:'Sales Managers'},
    {state:'Pennsylvania', amount:'151,620', profession:'Sales Managers'},
    {state:'Rhode Island', amount:'161,970', profession:'Sales Managers'},
    {state:'South Carolina', amount:'118,750', profession:'Sales Managers'},
    {state:'South Dakota', amount:'128,760', profession:'Sales Managers'},
    {state:'Tennessee', amount:'111,700', profession:'Sales Managers'},
    {state:'Texas', amount:'148,000', profession:'Sales Managers'},
    {state:'Utah', amount:'122,190', profession:'Sales Managers'},
    {state:'Vermont', amount:'140,260', profession:'Sales Managers'},
    {state:'Virginia', amount:'170,760', profession:'Sales Managers'},
    {state:'Washington', amount:'140,700', profession:'Sales Managers'},
    {state:'West Virginia', amount:'102,280', profession:'Sales Managers'},
    {state:'Wisconsin', amount:'135,940', profession:'Sales Managers'},
    {state:'Wyoming', amount:'117,350', profession:'Sales Managers'},
    {state:'Guam', amount:'58,550', profession:'Sales Managers'},
    {state:'Puerto Rico', amount:'91,460', profession:'Sales Managers'},

    // Industrial-Organizational Psychologists
    {state:'California', amount:'149,820', profession:'Industrial-Organizational Psychologists'},
    {state:'Massachusetts', amount:'75,660', profession:'Industrial-Organizational Psychologists'},
    {state:'Minnesota', amount:'114,990', profession:'Industrial-Organizational Psychologists'},
    {state:'New Jersey', amount:'119,700', profession:'Industrial-Organizational Psychologists'},
    {state:'Oklahoma', amount:'58,920', profession:'Industrial-Organizational Psychologists'},
    {state:'Pennsylvania', amount:'96,730', profession:'Industrial-Organizational Psychologists'},
    {state:'Virginia', amount:'126,220', profession:'Industrial-Organizational Psychologists'},

    // Network and Computer Systems Administrators
    {state:'Alabama', amount:'76,370', profession:'Network and Computer Systems Administrators'},
    {state:'Alaska', amount:'82,980', profession:'Network and Computer Systems Administrators'},
    {state:'Arizona', amount:'85,850', profession:'Network and Computer Systems Administrators'},
    {state:'Arkansas', amount:'65,220', profession:'Network and Computer Systems Administrators'},
    {state:'California', amount:'97,810', profession:'Network and Computer Systems Administrators'},
    {state:'Colorado', amount:'84,170', profession:'Network and Computer Systems Administrators'},
    {state:'Connecticut', amount:'93,230', profession:'Network and Computer Systems Administrators'},
    {state:'Delaware', amount:'80,990', profession:'Network and Computer Systems Administrators'},
    {state:'District of Columbia', amount:'99,920', profession:'Network and Computer Systems Administrators'},
    {state:'Florida', amount:'79,070', profession:'Network and Computer Systems Administrators'},
    {state:'Georgia', amount:'86,910', profession:'Network and Computer Systems Administrators'},
    {state:'Hawaii', amount:'86,530', profession:'Network and Computer Systems Administrators'},
    {state:'Idaho', amount:'66,930', profession:'Network and Computer Systems Administrators'},
    {state:'Illinois', amount:'86,290', profession:'Network and Computer Systems Administrators'},
    {state:'Indiana', amount:'75,500', profession:'Network and Computer Systems Administrators'},
    {state:'Iowa', amount:'74,940', profession:'Network and Computer Systems Administrators'},
    {state:'Kansas', amount:'75,940', profession:'Network and Computer Systems Administrators'},
    {state:'Kentucky', amount:'64,320', profession:'Network and Computer Systems Administrators'},
    {state:'Louisiana', amount:'68,380', profession:'Network and Computer Systems Administrators'},
    {state:'Maine', amount:'76,780', profession:'Network and Computer Systems Administrators'},
    {state:'Maryland', amount:'108,190', profession:'Network and Computer Systems Administrators'},
    {state:'Massachusetts', amount:'91,470', profession:'Network and Computer Systems Administrators'},
    {state:'Michigan', amount:'77,580', profession:'Network and Computer Systems Administrators'},
    {state:'Minnesota', amount:'85,620', profession:'Network and Computer Systems Administrators'},
    {state:'Mississippi', amount:'75,000', profession:'Network and Computer Systems Administrators'},
    {state:'Missouri', amount:'82,160', profession:'Network and Computer Systems Administrators'},
    {state:'Montana', amount:'64,780', profession:'Network and Computer Systems Administrators'},
    {state:'Nebraska', amount:'78,620', profession:'Network and Computer Systems Administrators'},
    {state:'Nevada', amount:'84,330', profession:'Network and Computer Systems Administrators'},
    {state:'New Hampshire', amount:'87,720', profession:'Network and Computer Systems Administrators'},
    {state:'New Jersey', amount:'99,070', profession:'Network and Computer Systems Administrators'},
    {state:'New Mexico', amount:'76,700', profession:'Network and Computer Systems Administrators'},
    {state:'New York', amount:'94,940', profession:'Network and Computer Systems Administrators'},
    {state:'North Carolina', amount:'84,870', profession:'Network and Computer Systems Administrators'},
    {state:'North Dakota', amount:'71,180', profession:'Network and Computer Systems Administrators'},
    {state:'Ohio', amount:'80,500', profession:'Network and Computer Systems Administrators'},
    {state:'Oklahoma', amount:'73,130', profession:'Network and Computer Systems Administrators'},
    {state:'Oregon', amount:'82,020', profession:'Network and Computer Systems Administrators'},
    {state:'Pennsylvania', amount:'77,700', profession:'Network and Computer Systems Administrators'},
    {state:'Rhode Island', amount:'90,600', profession:'Network and Computer Systems Administrators'},
    {state:'South Carolina', amount:'75,630', profession:'Network and Computer Systems Administrators'},
    {state:'South Dakota', amount:'62,420', profession:'Network and Computer Systems Administrators'},
    {state:'Tennessee', amount:'80,030', profession:'Network and Computer Systems Administrators'},
    {state:'Texas', amount:'89,500', profession:'Network and Computer Systems Administrators'},
    {state:'Utah', amount:'81,430', profession:'Network and Computer Systems Administrators'},
    {state:'Vermont', amount:'75,170', profession:'Network and Computer Systems Administrators'},
    {state:'Virginia', amount:'93,860', profession:'Network and Computer Systems Administrators'},
    {state:'Washington', amount:'92,750', profession:'Network and Computer Systems Administrators'},
    {state:'West Virginia', amount:'68,980', profession:'Network and Computer Systems Administrators'},
    {state:'Wisconsin', amount:'75,320', profession:'Network and Computer Systems Administrators'},
    {state:'Wyoming', amount:'66,340', profession:'Network and Computer Systems Administrators'},
    {state:'Guam', amount:'56,670', profession:'Network and Computer Systems Administrators'},
    {state:'Puerto Rico', amount:'47,000', profession:'Network and Computer Systems Administrators'},

    // Human Resources Specialists
    {state:'Alabama', amount:'60,660', profession:'Human Resources Specialists'},
    {state:'Alaska', amount:'71,160', profession:'Human Resources Specialists'},
    {state:'Arizona', amount:'60,820', profession:'Human Resources Specialists'},
    {state:'Arkansas', amount:'56,700', profession:'Human Resources Specialists'},
    {state:'California', amount:'75,010', profession:'Human Resources Specialists'},
    {state:'Colorado', amount:'69,420', profession:'Human Resources Specialists'},
    {state:'Connecticut', amount:'70,280', profession:'Human Resources Specialists'},
    {state:'Delaware', amount:'67,530', profession:'Human Resources Specialists'},
    {state:'District of Columbia', amount:'93,880', profession:'Human Resources Specialists'},
    {state:'Florida', amount:'58,600', profession:'Human Resources Specialists'},
    {state:'Georgia', amount:'60,230', profession:'Human Resources Specialists'},
    {state:'Hawaii', amount:'66,490', profession:'Human Resources Specialists'},
    {state:'Idaho', amount:'62,240', profession:'Human Resources Specialists'},
    {state:'Illinois', amount:'62,410', profession:'Human Resources Specialists'},
    {state:'Indiana', amount:'56,140', profession:'Human Resources Specialists'},
    {state:'Iowa', amount:'57,960', profession:'Human Resources Specialists'},
    {state:'Kansas', amount:'60,970', profession:'Human Resources Specialists'},
    {state:'Kentucky', amount:'57,000', profession:'Human Resources Specialists'},
    {state:'Louisiana', amount:'55,610', profession:'Human Resources Specialists'},
    {state:'Maine', amount:'58,980', profession:'Human Resources Specialists'},
    {state:'Maryland', amount:'76,560', profession:'Human Resources Specialists'},
    {state:'Massachusetts', amount:'75,700', profession:'Human Resources Specialists'},
    {state:'Michigan', amount:'62,470', profession:'Human Resources Specialists'},
    {state:'Minnesota', amount:'64,490', profession:'Human Resources Specialists'},
    {state:'Mississippi', amount:'52,030', profession:'Human Resources Specialists'},
    {state:'Missouri', amount:'62,790', profession:'Human Resources Specialists'},
    {state:'Montana', amount:'53,980', profession:'Human Resources Specialists'},
    {state:'Nebraska', amount:'58,720', profession:'Human Resources Specialists'},
    {state:'Nevada', amount:'58,610', profession:'Human Resources Specialists'},
    {state:'New Hampshire', amount:'63,960', profession:'Human Resources Specialists'},
    {state:'New Jersey', amount:'75,360', profession:'Human Resources Specialists'},
    {state:'New Mexico', amount:'61,300', profession:'Human Resources Specialists'},
    {state:'New York', amount:'75,650', profession:'Human Resources Specialists'},
    {state:'North Carolina', amount:'64,690', profession:'Human Resources Specialists'},
    {state:'North Dakota', amount:'60,230', profession:'Human Resources Specialists'},
    {state:'Ohio', amount:'62,790', profession:'Human Resources Specialists'},
    {state:'Oklahoma', amount:'54,940', profession:'Human Resources Specialists'},
    {state:'Oregon', amount:'62,640', profession:'Human Resources Specialists'},
    {state:'Pennsylvania', amount:'67,370', profession:'Human Resources Specialists'},
    {state:'Rhode Island', amount:'72,960', profession:'Human Resources Specialists'},
    {state:'South Carolina', amount:'57,590', profession:'Human Resources Specialists'},
    {state:'South Dakota', amount:'54,320', profession:'Human Resources Specialists'},
    {state:'Tennessee', amount:'58,700', profession:'Human Resources Specialists'},
    {state:'Texas', amount:'67,190', profession:'Human Resources Specialists'},
    {state:'Utah', amount:'56,960', profession:'Human Resources Specialists'},
    {state:'Vermont', amount:'59,200', profession:'Human Resources Specialists'},
    {state:'Virginia', amount:'75,120', profession:'Human Resources Specialists'},
    {state:'Washington', amount:'72,370', profession:'Human Resources Specialists'},
    {state:'West Virginia', amount:'61,240', profession:'Human Resources Specialists'},
    {state:'Wisconsin', amount:'61,180', profession:'Human Resources Specialists'},
    {state:'Wyoming', amount:'57,360', profession:'Human Resources Specialists'},
    {state:'Guam', amount:'51,710', profession:'Human Resources Specialists'},
    {state:'Puerto Rico', amount:'36,800', profession:'Human Resources Specialists'},
    {state:'Virgin Islands', amount:'60,070', profession:'Human Resources Specialists'},

    // Medical Assistants
    {state:'Alabama', amount:'28,460', profession:'Medical Assistants'},
    {state:'Alaska', amount:'45,490', profession:'Medical Assistants'},
    {state:'Arizona', amount:'33,410', profession:'Medical Assistants'},
    {state:'Arkansas', amount:'30,320', profession:'Medical Assistants'},
    {state:'California', amount:'38,250', profession:'Medical Assistants'},
    {state:'Colorado', amount:'36,180', profession:'Medical Assistants'},
    {state:'Connecticut', amount:'38,350', profession:'Medical Assistants'},
    {state:'Delaware', amount:'33,350', profession:'Medical Assistants'},
    {state:'District of Columbia', amount:'42,010', profession:'Medical Assistants'},
    {state:'Florida', amount:'32,870', profession:'Medical Assistants'},
    {state:'Georgia', amount:'32,060', profession:'Medical Assistants'},
    {state:'Hawaii', amount:'38,040', profession:'Medical Assistants'},
    {state:'Idaho', amount:'33,540', profession:'Medical Assistants'},
    {state:'Illinois', amount:'35,910', profession:'Medical Assistants'},
    {state:'Indiana', amount:'32,580', profession:'Medical Assistants'},
    {state:'Iowa', amount:'34,990', profession:'Medical Assistants'},
    {state:'Kansas', amount:'31,400', profession:'Medical Assistants'},
    {state:'Kentucky', amount:'31,900', profession:'Medical Assistants'},
    {state:'Louisiana', amount:'28,740', profession:'Medical Assistants'},
    {state:'Maine', amount:'35,160', profession:'Medical Assistants'},
    {state:'Maryland', amount:'36,350', profession:'Medical Assistants'},
    {state:'Massachusetts', amount:'40,270', profession:'Medical Assistants'},
    {state:'Michigan', amount:'32,540', profession:'Medical Assistants'},
    {state:'Minnesota', amount:'40,320', profession:'Medical Assistants'},
    {state:'Mississippi', amount:'30,470', profession:'Medical Assistants'},
    {state:'Missouri', amount:'32,260', profession:'Medical Assistants'},
    {state:'Montana', amount:'34,520', profession:'Medical Assistants'},
    {state:'Nebraska', amount:'34,670', profession:'Medical Assistants'},
    {state:'Nevada', amount:'33,610', profession:'Medical Assistants'},
    {state:'New Hampshire', amount:'36,730', profession:'Medical Assistants'},
    {state:'New Jersey', amount:'35,840', profession:'Medical Assistants'},
    {state:'New Mexico', amount:'30,750', profession:'Medical Assistants'},
    {state:'New York', amount:'37,560', profession:'Medical Assistants'},
    {state:'North Carolina', amount:'32,710', profession:'Medical Assistants'},
    {state:'North Dakota', amount:'36,560', profession:'Medical Assistants'},
    {state:'Ohio', amount:'31,900', profession:'Medical Assistants'},
    {state:'Oklahoma', amount:'30,960', profession:'Medical Assistants'},
    {state:'Oregon', amount:'38,260', profession:'Medical Assistants'},
    {state:'Pennsylvania', amount:'32,770', profession:'Medical Assistants'},
    {state:'Rhode Island', amount:'35,830', profession:'Medical Assistants'},
    {state:'South Carolina', amount:'32,120', profession:'Medical Assistants'},
    {state:'South Dakota', amount:'29,890', profession:'Medical Assistants'},
    {state:'Tennessee', amount:'32,370', profession:'Medical Assistants'},
    {state:'Texas', amount:'31,580', profession:'Medical Assistants'},
    {state:'Utah', amount:'33,000', profession:'Medical Assistants'},
    {state:'Vermont', amount:'37,740', profession:'Medical Assistants'},
    {state:'Virginia', amount:'35,010', profession:'Medical Assistants'},
    {state:'Washington', amount:'41,340', profession:'Medical Assistants'},
    {state:'West Virginia', amount:'28,160', profession:'Medical Assistants'},
    {state:'Wisconsin', amount:'36,410', profession:'Medical Assistants'},
    {state:'Wyoming', amount:'33,830', profession:'Medical Assistants'},
    {state:'Guam', amount:'26,600', profession:'Medical Assistants'},
    {state:'Puerto Rico', amount:'21,820', profession:'Medical Assistants'},
    {state:'Virgin Islands', amount:'31,730', profession:'Medical Assistants'},

    // Police and Sheriff Patrol Officers
    {state:'Alabama', amount:'45,930', profession:'Police and Sheriff Patrol Officers'},
    {state:'Alaska', amount:'88,030', profession:'Police and Sheriff Patrol Officers'},
    {state:'Arizona', amount:'64,640', profession:'Police and Sheriff Patrol Officers'},
    {state:'Arkansas', amount:'39,560', profession:'Police and Sheriff Patrol Officers'},
    {state:'California', amount:'101,380', profession:'Police and Sheriff Patrol Officers'},
    {state:'Colorado', amount:'72,950', profession:'Police and Sheriff Patrol Officers'},
    {state:'Connecticut', amount:'71,920', profession:'Police and Sheriff Patrol Officers'},
    {state:'Delaware', amount:'70,000', profession:'Police and Sheriff Patrol Officers'},
    {state:'District of Columbia', amount:'74,940', profession:'Police and Sheriff Patrol Officers'},
    {state:'Florida', amount:'59,610', profession:'Police and Sheriff Patrol Officers'},
    {state:'Georgia', amount:'42,990', profession:'Police and Sheriff Patrol Officers'},
    {state:'Hawaii', amount:'74,040', profession:'Police and Sheriff Patrol Officers'},
    {state:'Idaho', amount:'53,880', profession:'Police and Sheriff Patrol Officers'},
    {state:'Illinois', amount:'75,720', profession:'Police and Sheriff Patrol Officers'},
    {state:'Indiana', amount:'55,310', profession:'Police and Sheriff Patrol Officers'},
    {state:'Iowa', amount:'58,340', profession:'Police and Sheriff Patrol Officers'},
    {state:'Kansas', amount:'48,350', profession:'Police and Sheriff Patrol Officers'},
    {state:'Kentucky', amount:'45,600', profession:'Police and Sheriff Patrol Officers'},
    {state:'Louisiana', amount:'41,550', profession:'Police and Sheriff Patrol Officers'},
    {state:'Maine', amount:'49,840', profession:'Police and Sheriff Patrol Officers'},
    {state:'Maryland', amount:'68,230', profession:'Police and Sheriff Patrol Officers'},
    {state:'Massachusetts', amount:'69,870', profession:'Police and Sheriff Patrol Officers'},
    {state:'Michigan', amount:'56,270', profession:'Police and Sheriff Patrol Officers'},
    {state:'Minnesota', amount:'69,060', profession:'Police and Sheriff Patrol Officers'},
    {state:'Mississippi', amount:'35,550', profession:'Police and Sheriff Patrol Officers'},
    {state:'Missouri', amount:'48,920', profession:'Police and Sheriff Patrol Officers'},
    {state:'Montana', amount:'56,230', profession:'Police and Sheriff Patrol Officers'},
    {state:'Nebraska', amount:'57,530', profession:'Police and Sheriff Patrol Officers'},
    {state:'Nevada', amount:'70,450', profession:'Police and Sheriff Patrol Officers'},
    {state:'New Hampshire', amount:'58,120', profession:'Police and Sheriff Patrol Officers'},
    {state:'New Jersey', amount:'83,720', profession:'Police and Sheriff Patrol Officers'},
    {state:'New Mexico', amount:'51,250', profession:'Police and Sheriff Patrol Officers'},
    {state:'New York', amount:'74,860', profession:'Police and Sheriff Patrol Officers'},
    {state:'North Carolina', amount:'48,420', profession:'Police and Sheriff Patrol Officers'},
    {state:'North Dakota', amount:'57,190', profession:'Police and Sheriff Patrol Officers'},
    {state:'Ohio', amount:'61,040', profession:'Police and Sheriff Patrol Officers'},
    {state:'Oklahoma', amount:'46,120', profession:'Police and Sheriff Patrol Officers'},
    {state:'Oregon', amount:'70,360', profession:'Police and Sheriff Patrol Officers'},
    {state:'Pennsylvania', amount:'66,600', profession:'Police and Sheriff Patrol Officers'},
    {state:'Rhode Island', amount:'60,890', profession:'Police and Sheriff Patrol Officers'},
    {state:'South Carolina', amount:'42,280', profession:'Police and Sheriff Patrol Officers'},
    {state:'South Dakota', amount:'48,550', profession:'Police and Sheriff Patrol Officers'},
    {state:'Tennessee', amount:'44,600', profession:'Police and Sheriff Patrol Officers'},
    {state:'Texas', amount:'61,870', profession:'Police and Sheriff Patrol Officers'},
    {state:'Utah', amount:'53,890', profession:'Police and Sheriff Patrol Officers'},
    {state:'Vermont', amount:'52,940', profession:'Police and Sheriff Patrol Officers'},
    {state:'Virginia', amount:'56,710', profession:'Police and Sheriff Patrol Officers'},
    {state:'Washington', amount:'77,670', profession:'Police and Sheriff Patrol Officers'},
    {state:'West Virginia', amount:'43,590', profession:'Police and Sheriff Patrol Officers'},
    {state:'Wisconsin', amount:'62,040', profession:'Police and Sheriff Patrol Officers'},
    {state:'Wyoming', amount:'55,050', profession:'Police and Sheriff Patrol Officers'},
    {state:'Puerto Rico', amount:'31,680', profession:'Police and Sheriff Patrol Officers'},

    // Veterinarians
    {state:'Alabama', amount:'92,930', profession:'Veterinarians'},
    {state:'Alaska', amount:'121,010', profession:'Veterinarians'},
    {state:'Arizona', amount:'98,680', profession:'Veterinarians'},
    {state:'Arkansas', amount:'82,060', profession:'Veterinarians'},
    {state:'California', amount:'121,750', profession:'Veterinarians'},
    {state:'Colorado', amount:'92,710', profession:'Veterinarians'},
    {state:'Connecticut', amount:'105,380', profession:'Veterinarians'},
    {state:'Delaware', amount:'115,640', profession:'Veterinarians'},
    {state:'District of Columbia', amount:'103,840', profession:'Veterinarians'},
    {state:'Florida', amount:'103,580', profession:'Veterinarians'},
    {state:'Georgia', amount:'91,270', profession:'Veterinarians'},
    {state:'Hawaii', amount:'*', profession:'Veterinarians'},
    {state:'Idaho', amount:'102,450', profession:'Veterinarians'},
    {state:'Illinois', amount:'108,280', profession:'Veterinarians'},
    {state:'Indiana', amount:'89,060', profession:'Veterinarians'},
    {state:'Iowa', amount:'88,690', profession:'Veterinarians'},
    {state:'Kansas', amount:'98,260', profession:'Veterinarians'},
    {state:'Kentucky', amount:'86,160', profession:'Veterinarians'},
    {state:'Louisiana', amount:'87,200', profession:'Veterinarians'},
    {state:'Maine', amount:'89,340', profession:'Veterinarians'},
    {state:'Maryland', amount:'117,100', profession:'Veterinarians'},
    {state:'Massachusetts', amount:'109,520', profession:'Veterinarians'},
    {state:'Michigan', amount:'100,380', profession:'Veterinarians'},
    {state:'Minnesota', amount:'95,060', profession:'Veterinarians'},
    {state:'Mississippi', amount:'77,790', profession:'Veterinarians'},
    {state:'Missouri', amount:'90,580', profession:'Veterinarians'},
    {state:'Montana', amount:'79,380', profession:'Veterinarians'},
    {state:'Nebraska', amount:'82,040', profession:'Veterinarians'},
    {state:'Nevada', amount:'119,590', profession:'Veterinarians'},
    {state:'New Hampshire', amount:'106,680', profession:'Veterinarians'},
    {state:'New Jersey', amount:'120,700', profession:'Veterinarians'},
    {state:'New Mexico', amount:'96,440', profession:'Veterinarians'},
    {state:'New York', amount:'117,800', profession:'Veterinarians'},
    {state:'North Carolina', amount:'104,540', profession:'Veterinarians'},
    {state:'North Dakota', amount:'92,200', profession:'Veterinarians'},
    {state:'Ohio', amount:'103,970', profession:'Veterinarians'},
    {state:'Oklahoma', amount:'82,950', profession:'Veterinarians'},
    {state:'Oregon', amount:'109,450', profession:'Veterinarians'},
    {state:'Pennsylvania', amount:'109,580', profession:'Veterinarians'},
    {state:'Rhode Island', amount:'105,780', profession:'Veterinarians'},
    {state:'South Carolina', amount:'111,100', profession:'Veterinarians'},
    {state:'South Dakota', amount:'100,050', profession:'Veterinarians'},
    {state:'Tennessee', amount:'93,520', profession:'Veterinarians'},
    {state:'Texas', amount:'124,060', profession:'Veterinarians'},
    {state:'Utah', amount:'76,980', profession:'Veterinarians'},
    {state:'Vermont', amount:'96,350', profession:'Veterinarians'},
    {state:'Virginia', amount:'125,360', profession:'Veterinarians'},
    {state:'Washington', amount:'93,010', profession:'Veterinarians'},
    {state:'West Virginia', amount:'92,510', profession:'Veterinarians'},
    {state:'Wisconsin', amount:'90,120', profession:'Veterinarians'},
    {state:'Wyoming', amount:'83,420', profession:'Veterinarians'},
    {state:'Puerto Rico', amount:'84,710', profession:'Veterinarians'},

    // Educational, Guidance, School, and Vocational Counselors
    {state:'Alabama', amount:'53,420', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Alaska', amount:'66,730', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Arizona', amount:'53,980', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Arkansas', amount:'53,950', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'California', amount:'74,530', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Colorado', amount:'53,090', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Connecticut', amount:'65,510', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Delaware', amount:'63,990', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'District of Columbia', amount:'67,050', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Florida', amount:'50,350', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Georgia', amount:'56,500', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Hawaii', amount:'59,110', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Idaho', amount:'43,660', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Illinois', amount:'56,540', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Indiana', amount:'51,560', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Iowa', amount:'54,650', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Kansas', amount:'50,100', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Kentucky', amount:'58,770', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Louisiana', amount:'55,500', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Maine', amount:'53,100', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Maryland', amount:'65,910', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Massachusetts', amount:'69,570', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Michigan', amount:'55,890', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Minnesota', amount:'58,360', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Mississippi', amount:'50,940', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Missouri', amount:'50,900', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Montana', amount:'48,010', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Nebraska', amount:'60,200', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Nevada', amount:'54,960', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'New Hampshire', amount:'53,070', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'New Jersey', amount:'72,050', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'New Mexico', amount:'56,200', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'New York', amount:'67,920', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'North Carolina', amount:'50,140', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'North Dakota', amount:'57,250', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Ohio', amount:'57,280', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Oklahoma', amount:'44,000', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Oregon', amount:'62,250', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Pennsylvania', amount:'61,260', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Rhode Island', amount:'62,800', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'South Carolina', amount:'52,890', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'South Dakota', amount:'42,750', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Tennessee', amount:'51,240', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Texas', amount:'60,080', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Utah', amount:'52,200', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Vermont', amount:'54,790', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Virginia', amount:'65,230', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Washington', amount:'64,210', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'West Virginia', amount:'44,730', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Wisconsin', amount:'55,330', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Wyoming', amount:'56,080', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Guam', amount:'58,970', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Puerto Rico', amount:'35,900', profession:'Educational, Guidance, School, and Vocational Counselors'},
    {state:'Virgin Islands', amount:'52,120', profession:'Educational, Guidance, School, and Vocational Counselors'},

    // Hairdressers, Hairstylists, and Cosmetologists
    {state:'Alabama', amount:'23,490', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Alaska', amount:'32,170', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Arizona', amount:'29,010', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Arkansas', amount:'23,890', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'California', amount:'31,400', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Colorado', amount:'34,830', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Connecticut', amount:'34,140', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Delaware', amount:'35,810', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'District of Columbia', amount:'45,680', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Florida', amount:'31,530', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Georgia', amount:'26,960', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Hawaii', amount:'34,300', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Idaho', amount:'31,090', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Illinois', amount:'29,900', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Indiana', amount:'27,460', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Iowa', amount:'28,360', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Kansas', amount:'25,620', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Kentucky', amount:'27,270', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Louisiana', amount:'22,990', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Maine', amount:'28,680', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Maryland', amount:'30,590', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Massachusetts', amount:'42,260', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Michigan', amount:'29,080', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Minnesota', amount:'30,690', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Mississippi', amount:'25,800', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Missouri', amount:'28,620', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Montana', amount:'26,170', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Nebraska', amount:'28,850', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Nevada', amount:'23,420', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'New Hampshire', amount:'28,770', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'New Jersey', amount:'37,230', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'New Mexico', amount:'23,370', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'New York', amount:'30,920', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'North Carolina', amount:'28,550', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'North Dakota', amount:'28,240', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Ohio', amount:'27,300', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Oklahoma', amount:'25,180', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Oregon', amount:'28,050', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Pennsylvania', amount:'26,990', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Rhode Island', amount:'28,730', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'South Carolina', amount:'24,090', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'South Dakota', amount:'30,630', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Tennessee', amount:'28,300', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Texas', amount:'25,520', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Utah', amount:'26,370', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Vermont', amount:'35,700', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Virginia', amount:'34,250', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Washington', amount:'40,910', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'West Virginia', amount:'24,260', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Wisconsin', amount:'28,970', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Wyoming', amount:'30,000', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Guam', amount:'27,990', profession:'Hairdressers, Hairstylists, and Cosmetologists'},
    {state:'Puerto Rico', amount:'26,260', profession:'Hairdressers, Hairstylists, and Cosmetologists'},

    // Cost Estimators
    {state:'Alabama', amount:'59,870', profession:'Cost Estimators'},
    {state:'Alaska', amount:'83,450', profession:'Cost Estimators'},
    {state:'Arizona', amount:'66,410', profession:'Cost Estimators'},
    {state:'Arkansas', amount:'61,500', profession:'Cost Estimators'},
    {state:'California', amount:'78,190', profession:'Cost Estimators'},
    {state:'Colorado', amount:'73,110', profession:'Cost Estimators'},
    {state:'Connecticut', amount:'74,910', profession:'Cost Estimators'},
    {state:'Delaware', amount:'68,690', profession:'Cost Estimators'},
    {state:'District of Columbia', amount:'93,880', profession:'Cost Estimators'},
    {state:'Florida', amount:'62,370', profession:'Cost Estimators'},
    {state:'Georgia', amount:'67,190', profession:'Cost Estimators'},
    {state:'Hawaii', amount:'82,390', profession:'Cost Estimators'},
    {state:'Idaho', amount:'60,400', profession:'Cost Estimators'},
    {state:'Illinois', amount:'66,480', profession:'Cost Estimators'},
    {state:'Indiana', amount:'65,790', profession:'Cost Estimators'},
    {state:'Iowa', amount:'62,410', profession:'Cost Estimators'},
    {state:'Kansas', amount:'66,500', profession:'Cost Estimators'},
    {state:'Kentucky', amount:'65,460', profession:'Cost Estimators'},
    {state:'Louisiana', amount:'67,650', profession:'Cost Estimators'},
    {state:'Maine', amount:'61,960', profession:'Cost Estimators'},
    {state:'Maryland', amount:'71,650', profession:'Cost Estimators'},
    {state:'Massachusetts', amount:'77,670', profession:'Cost Estimators'},
    {state:'Michigan', amount:'63,810', profession:'Cost Estimators'},
    {state:'Minnesota', amount:'65,520', profession:'Cost Estimators'},
    {state:'Mississippi', amount:'60,360', profession:'Cost Estimators'},
    {state:'Missouri', amount:'67,620', profession:'Cost Estimators'},
    {state:'Montana', amount:'58,960', profession:'Cost Estimators'},
    {state:'Nebraska', amount:'59,160', profession:'Cost Estimators'},
    {state:'Nevada', amount:'66,650', profession:'Cost Estimators'},
    {state:'New Hampshire', amount:'67,610', profession:'Cost Estimators'},
    {state:'New Jersey', amount:'75,340', profession:'Cost Estimators'},
    {state:'New Mexico', amount:'59,580', profession:'Cost Estimators'},
    {state:'New York', amount:'75,730', profession:'Cost Estimators'},
    {state:'North Carolina', amount:'62,590', profession:'Cost Estimators'},
    {state:'North Dakota', amount:'69,010', profession:'Cost Estimators'},
    {state:'Ohio', amount:'64,700', profession:'Cost Estimators'},
    {state:'Oklahoma', amount:'64,300', profession:'Cost Estimators'},
    {state:'Oregon', amount:'71,490', profession:'Cost Estimators'},
    {state:'Pennsylvania', amount:'67,330', profession:'Cost Estimators'},
    {state:'Rhode Island', amount:'67,470', profession:'Cost Estimators'},
    {state:'South Carolina', amount:'63,520', profession:'Cost Estimators'},
    {state:'South Dakota', amount:'54,860', profession:'Cost Estimators'},
    {state:'Tennessee', amount:'63,770', profession:'Cost Estimators'},
    {state:'Texas', amount:'73,950', profession:'Cost Estimators'},
    {state:'Utah', amount:'65,940', profession:'Cost Estimators'},
    {state:'Vermont', amount:'65,790', profession:'Cost Estimators'},
    {state:'Virginia', amount:'74,160', profession:'Cost Estimators'},
    {state:'Washington', amount:'77,510', profession:'Cost Estimators'},
    {state:'West Virginia', amount:'63,890', profession:'Cost Estimators'},
    {state:'Wisconsin', amount:'57,990', profession:'Cost Estimators'},
    {state:'Wyoming', amount:'76,670', profession:'Cost Estimators'},
    {state:'Guam', amount:'62,450', profession:'Cost Estimators'},
    {state:'Puerto Rico', amount:'37,250', profession:'Cost Estimators'},

    // Market Research Analysts and Marketing Specialists
    {state:'Alabama',amount:'59,980',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Alaska',amount:'69,880',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Arizona',amount:'62,930',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Arkansas',amount:'68,050',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'California',amount:'78,090',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Colorado',amount:'73,460',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Connecticut',amount:'77,010',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Delaware',amount:'82,890',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'District of Columbia',amount:'79,770',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Florida',amount:'64,730',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Georgia',amount:'67,080',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Hawaii',amount:'60,030',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Idaho',amount:'53,500',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Illinois',amount:'61,670',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Indiana',amount:'56,560',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Iowa',amount:'59,270',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Kansas',amount:'64,910',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Kentucky',amount:'58,190',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Louisiana',amount:'49,460',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Maine',amount:'68,670',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Maryland',amount:'67,900',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Massachusetts',amount:'74,510',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Michigan',amount:'67,500',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Minnesota',amount:'74,300',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Mississippi',amount:'45,530',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Missouri',amount:'65,360',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Montana',amount:'58,650',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Nebraska',amount:'54,390',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Nevada',amount:'59,090',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'New Hampshire',amount:'68,010',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'New Jersey',amount:'87,210',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'New Mexico',amount:'57,010',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'New York',amount:'77,230',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'North Carolina',amount:'69,170',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'North Dakota',amount:'52,870',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Ohio',amount:'65,920',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Oklahoma',amount:'59,600',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Oregon',amount:'72,170',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Pennsylvania',amount:'68,630',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Rhode Island',amount:'72,180',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'South Carolina',amount:'60,290',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'South Dakota',amount:'55,430',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Tennessee',amount:'60,990',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Texas',amount:'78,200',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Utah',amount:'57,660',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Vermont',amount:'63,290',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Virginia',amount:'75,050',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Washington',amount:'81,890',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'West Virginia',amount:'45,760',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Wisconsin',amount:'57,710',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Wyoming',amount:'54,560',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Guam',amount:'46,260',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Puerto Rico',amount:'34,080',profession:'Market Research Analysts and Marketing Specialists'},
    {state:'Virgin Islands',amount:'33,310',profession:'Market Research Analysts and Marketing Specialists'},

    // Plumbers, Pipefitters, and Steamfitters
    {state:'Alabama',amount:'45,260',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Alaska',amount:'75,520',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Arizona',amount:'48,950',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Arkansas',amount:'43,540',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'California',amount:'61,410',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Colorado',amount:'53,350',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Connecticut',amount:'63,780',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Delaware',amount:'61,640',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'District of Columbia',amount:'69,800',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Florida',amount:'44,200',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Georgia',amount:'48,680',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Hawaii',amount:'73,810',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Idaho',amount:'47,320',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Illinois',amount:'79,400',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Indiana',amount:'60,030',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Iowa',amount:'52,060',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Kansas',amount:'55,140',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Kentucky',amount:'55,890',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Louisiana',amount:'54,940',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Maine',amount:'50,830',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Maryland',amount:'60,610',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Massachusetts',amount:'70,320',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Michigan',amount:'61,620',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Minnesota',amount:'74,220',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Mississippi',amount:'45,280',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Missouri',amount:'63,550',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Montana',amount:'60,940',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Nebraska',amount:'55,110',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Nevada',amount:'55,600',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'New Hampshire',amount:'55,180',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'New Jersey',amount:'71,370',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'New Mexico',amount:'45,420',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'New York',amount:'73,820',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'North Carolina',amount:'43,750',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'North Dakota',amount:'53,800',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Ohio',amount:'55,640',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Oklahoma',amount:'50,710',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Oregon',amount:'73,810',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Pennsylvania',amount:'60,380',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'South Carolina',amount:'44,970',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'South Dakota',amount:'43,600',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Tennessee',amount:'48,850',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Texas',amount:'49,180',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Utah',amount:'51,970',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Vermont',amount:'51,210',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Virginia',amount:'50,330',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Washington',amount:'67,090',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'West Virginia',amount:'60,000',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Wisconsin',amount:'68,510',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Wyoming',amount:'53,550',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Guam',amount:'34,360',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Puerto Rico',amount:'21,660',profession:'Plumbers, Pipefitters, and Steamfitters'},
    {state:'Virgin Islands',amount:'48,950',profession:'Plumbers, Pipefitters, and Steamfitters'},
    
    // Computer Network Architects
    {state:'Alabama',amount:'104,580',profession:'Computer Network Architects'},
    {state:'Alaska',amount:'94,250',profession:'Computer Network Architects'},
    {state:'Arizona',amount:'101,750',profession:'Computer Network Architects'},
    {state:'Arkansas',amount:'89,840',profession:'Computer Network Architects'},
    {state:'California',amount:'127,500',profession:'Computer Network Architects'},
    {state:'Colorado',amount:'115,300',profession:'Computer Network Architects'},
    {state:'Connecticut',amount:'122,200',profession:'Computer Network Architects'},
    {state:'Delaware',amount:'126,990',profession:'Computer Network Architects'},
    {state:'District of Columbia',amount:'123,200',profession:'Computer Network Architects'},
    {state:'Florida',amount:'91,180',profession:'Computer Network Architects'},
    {state:'Georgia',amount:'114,240',profession:'Computer Network Architects'},
    {state:'Hawaii',amount:'98,880',profession:'Computer Network Architects'},
    {state:'Illinois',amount:'114,780',profession:'Computer Network Architects'},
    {state:'Indiana',amount:'88,210',profession:'Computer Network Architects'},
    {state:'Iowa',amount:'119,590',profession:'Computer Network Architects'},
    {state:'Kansas',amount:'93,670',profession:'Computer Network Architects'},
    {state:'Kentucky',amount:'77,950',profession:'Computer Network Architects'},
    {state:'Louisiana',amount:'79,560',profession:'Computer Network Architects'},
    {state:'Maine',amount:'97,890',profession:'Computer Network Architects'},
    {state:'Maryland',amount:'121,720',profession:'Computer Network Architects'},
    {state:'Massachusetts',amount:'121,700',profession:'Computer Network Architects'},
    {state:'Michigan',amount:'100,710',profession:'Computer Network Architects'},
    {state:'Minnesota',amount:'110,330',profession:'Computer Network Architects'},
    {state:'Mississippi',amount:'89,550',profession:'Computer Network Architects'},
    {state:'Missouri',amount:'99,880',profession:'Computer Network Architects'},
    {state:'Montana',amount:'88,520',profession:'Computer Network Architects'},
    {state:'Nebraska',amount:'98,430',profession:'Computer Network Architects'},
    {state:'Nevada',amount:'104,350',profession:'Computer Network Architects'},
    {state:'New Hampshire',amount:'123,310',profession:'Computer Network Architects'},
    {state:'New Jersey',amount:'124,310',profession:'Computer Network Architects'},
    {state:'New Mexico',amount:'111,210',profession:'Computer Network Architects'},
    {state:'New York',amount:'113,300',profession:'Computer Network Architects'},
    {state:'North Carolina',amount:'108,040',profession:'Computer Network Architects'},
    {state:'North Dakota',amount:'94,750',profession:'Computer Network Architects'},
    {state:'Ohio',amount:'97,250',profession:'Computer Network Architects'},
    {state:'Oklahoma',amount:'87,160',profession:'Computer Network Architects'},
    {state:'Oregon',amount:'108,990',profession:'Computer Network Architects'},
    {state:'Pennsylvania',amount:'101,090',profession:'Computer Network Architects'},
    {state:'Rhode Island',amount:'117,650',profession:'Computer Network Architects'},
    {state:'South Carolina',amount:'85,450',profession:'Computer Network Architects'},
    {state:'South Dakota',amount:'100,330',profession:'Computer Network Architects'},
    {state:'Tennessee',amount:'102,030',profession:'Computer Network Architects'},
    {state:'Texas',amount:'119,340',profession:'Computer Network Architects'},
    {state:'Utah',amount:'114,900',profession:'Computer Network Architects'},
    {state:'Vermont',amount:'85,930',profession:'Computer Network Architects'},
    {state:'Virginia',amount:'123,050',profession:'Computer Network Architects'},
    {state:'Washington',amount:'111,960',profession:'Computer Network Architects'},
    {state:'West Virginia',amount:'92,060',profession:'Computer Network Architects'},
    {state:'Wisconsin',amount:'97,110',profession:'Computer Network Architects'},
    {state:'Puerto Rico',amount:'66,810',profession:'Computer Network Architects'},

    // Wind Turbine Service Technicians
    {state:'California',amount:'57,770',profession:'Wind Turbine Service Technicians'},
    {state:'Colorado',amount:'69,070',profession:'Wind Turbine Service Technicians'},
    {state:'Illinois',amount:'64,180',profession:'Wind Turbine Service Technicians'},
    {state:'Indiana',amount:'47,730',profession:'Wind Turbine Service Technicians'},
    {state:'Iowa',amount:'60,960',profession:'Wind Turbine Service Technicians'},
    {state:'Kansas',amount:'58,190',profession:'Wind Turbine Service Technicians'},
    {state:'Minnesota',amount:'63,580',profession:'Wind Turbine Service Technicians'},
    {state:'New Mexico',amount:'48,200',profession:'Wind Turbine Service Technicians'},
    {state:'New York',amount:'53,820',profession:'Wind Turbine Service Technicians'},
    {state:'North Dakota',amount:'67,520',profession:'Wind Turbine Service Technicians'},
    {state:'Oklahoma',amount:'52,200',profession:'Wind Turbine Service Technicians'},
    {state:'Oregon',amount:'56,940',profession:'Wind Turbine Service Technicians'},
    {state:'Pennsylvania',amount:'59,860',profession:'Wind Turbine Service Technicians'},
    {state:'Texas',amount:'55,340',profession:'Wind Turbine Service Technicians'},
    {state:'Washington',amount:'65,270',profession:'Wind Turbine Service Technicians'},
    {state:'West Virginia',amount:'78,010',profession:'Wind Turbine Service Technicians'},
    {state:'Wyoming',amount:'46,140',profession:'Wind Turbine Service Technicians'},
    
    // Home Health Aides
    {state:'Alabama',amount:'20,780',profession:'Home Health Aides'},
    {state:'Alaska',amount:'29,890',profession:'Home Health Aides'},
    {state:'Arizona',amount:'25,470',profession:'Home Health Aides'},
    {state:'Arkansas',amount:'23,070',profession:'Home Health Aides'},
    {state:'California',amount:'33,680',profession:'Home Health Aides'},
    {state:'Colorado',amount:'26,980',profession:'Home Health Aides'},
    {state:'Connecticut',amount:'28,240',profession:'Home Health Aides'},
    {state:'Delaware',amount:'29,560',profession:'Home Health Aides'},
    {state:'District of Columbia',amount:'29,290',profession:'Home Health Aides'},
    {state:'Florida',amount:'24,280',profession:'Home Health Aides'},
    {state:'Georgia',amount:'23,140',profession:'Home Health Aides'},
    {state:'Hawaii',amount:'27,620',profession:'Home Health Aides'},
    {state:'Idaho',amount:'25,150',profession:'Home Health Aides'},
    {state:'Illinois',amount:'25,370',profession:'Home Health Aides'},
    {state:'Indiana',amount:'23,960',profession:'Home Health Aides'},
    {state:'Iowa',amount:'30,320',profession:'Home Health Aides'},
    {state:'Kansas',amount:'24,560',profession:'Home Health Aides'},
    {state:'Kentucky',amount:'24,460',profession:'Home Health Aides'},
    {state:'Louisiana',amount:'21,080',profession:'Home Health Aides'},
    {state:'Maine',amount:'27,380',profession:'Home Health Aides'},
    {state:'Maryland',amount:'27,540',profession:'Home Health Aides'},
    {state:'Massachusetts',amount:'30,830',profession:'Home Health Aides'},
    {state:'Michigan',amount:'24,770',profession:'Home Health Aides'},
    {state:'Minnesota',amount:'28,940',profession:'Home Health Aides'},
    {state:'Mississippi',amount:'22,580',profession:'Home Health Aides'},
    {state:'Missouri',amount:'25,080',profession:'Home Health Aides'},
    {state:'Montana',amount:'25,940',profession:'Home Health Aides'},
    {state:'Nebraska',amount:'24,380',profession:'Home Health Aides'},
    {state:'Nevada',amount:'35,450',profession:'Home Health Aides'},
    {state:'New Hampshire',amount:'29,140',profession:'Home Health Aides'},
    {state:'New Jersey',amount:'24,450',profession:'Home Health Aides'},
    {state:'New Mexico',amount:'23,080',profession:'Home Health Aides'},
    {state:'New York',amount:'26,240',profession:'Home Health Aides'},
    {state:'North Carolina',amount:'21,120',profession:'Home Health Aides'},
    {state:'North Dakota',amount:'34,100',profession:'Home Health Aides'},
    {state:'Ohio',amount:'22,570',profession:'Home Health Aides'},
    {state:'Oklahoma',amount:'23,380',profession:'Home Health Aides'},
    {state:'Oregon',amount:'26,450',profession:'Home Health Aides'},
    {state:'Pennsylvania',amount:'25,310',profession:'Home Health Aides'},
    {state:'Rhode Island',amount:'32,440',profession:'Home Health Aides'},
    {state:'South Carolina',amount:'21,810',profession:'Home Health Aides'},
    {state:'South Dakota',amount:'29,820',profession:'Home Health Aides'},
    {state:'Tennessee',amount:'22,620',profession:'Home Health Aides'},
    {state:'Texas',amount:'21,910',profession:'Home Health Aides'},
    {state:'Utah',amount:'26,580',profession:'Home Health Aides'},
    {state:'Vermont',amount:'28,110',profession:'Home Health Aides'},
    {state:'Virginia',amount:'23,440',profession:'Home Health Aides'},
    {state:'Washington',amount:'30,100',profession:'Home Health Aides'},
    {state:'West Virginia',amount:'23,120',profession:'Home Health Aides'},
    {state:'Wisconsin',amount:'25,330',profession:'Home Health Aides'},
    {state:'Wyoming',amount:'28,060',profession:'Home Health Aides'},
    {state:'Puerto Rico',amount:'18,410',profession:'Home Health Aides'},

    // Pharmacists
    {state:'Alabama',amount:'122,200',profession:'Pharmacists'},
    {state:'Alaska',amount:'139,880',profession:'Pharmacists'},
    {state:'Arizona',amount:'125,210',profession:'Pharmacists'},
    {state:'Arkansas',amount:'118,320',profession:'Pharmacists'},
    {state:'California',amount:'139,690',profession:'Pharmacists'},
    {state:'Colorado',amount:'120,980',profession:'Pharmacists'},
    {state:'Connecticut',amount:'123,950',profession:'Pharmacists'},
    {state:'Delaware',amount:'125,400',profession:'Pharmacists'},
    {state:'District of Columbia',amount:'125,160',profession:'Pharmacists'},
    {state:'Florida',amount:'119,710',profession:'Pharmacists'},
    {state:'Georgia',amount:'118,710',profession:'Pharmacists'},
    {state:'Hawaii',amount:'121,780',profession:'Pharmacists'},
    {state:'Idaho',amount:'121,940',profession:'Pharmacists'},
    {state:'Illinois',amount:'125,360',profession:'Pharmacists'},
    {state:'Indiana',amount:'117,260',profession:'Pharmacists'},
    {state:'Iowa',amount:'116,160',profession:'Pharmacists'},
    {state:'Kansas',amount:'121,790',profession:'Pharmacists'},
    {state:'Kentucky',amount:'122,450',profession:'Pharmacists'},
    {state:'Louisiana',amount:'119,380',profession:'Pharmacists'},
    {state:'Maine',amount:'133,050',profession:'Pharmacists'},
    {state:'Maryland',amount:'121,210',profession:'Pharmacists'},
    {state:'Massachusetts',amount:'116,890',profession:'Pharmacists'},
    {state:'Michigan',amount:'117,680',profession:'Pharmacists'},
    {state:'Minnesota',amount:'129,080',profession:'Pharmacists'},
    {state:'Mississippi',amount:'124,120',profession:'Pharmacists'},
    {state:'Missouri',amount:'128,420',profession:'Pharmacists'},
    {state:'Montana',amount:'112,290',profession:'Pharmacists'},
    {state:'Nebraska',amount:'119,670',profession:'Pharmacists'},
    {state:'Nevada',amount:'124,430',profession:'Pharmacists'},
    {state:'New Hampshire',amount:'127,350',profession:'Pharmacists'},
    {state:'New Jersey',amount:'120,660',profession:'Pharmacists'},
    {state:'New Mexico',amount:'125,450',profession:'Pharmacists'},
    {state:'New York',amount:'121,030',profession:'Pharmacists'},
    {state:'North Carolina',amount:'123,370',profession:'Pharmacists'},
    {state:'North Dakota',amount:'103,250',profession:'Pharmacists'},
    {state:'Ohio',amount:'116,720',profession:'Pharmacists'},
    {state:'Oklahoma',amount:'115,000',profession:'Pharmacists'},
    {state:'Oregon',amount:'130,480',profession:'Pharmacists'},
    {state:'Pennsylvania',amount:'116,200',profession:'Pharmacists'},
    {state:'Rhode Island',amount:'120,890',profession:'Pharmacists'},
    {state:'South Carolina',amount:'122,900',profession:'Pharmacists'},
    {state:'South Dakota',amount:'116,410',profession:'Pharmacists'},
    {state:'Tennessee',amount:'124,310',profession:'Pharmacists'},
    {state:'Texas',amount:'126,800',profession:'Pharmacists'},
    {state:'Utah',amount:'117,570',profession:'Pharmacists'},
    {state:'Vermont',amount:'135,420',profession:'Pharmacists'},
    {state:'Virginia',amount:'123,920',profession:'Pharmacists'},
    {state:'Washington',amount:'127,360',profession:'Pharmacists'},
    {state:'West Virginia',amount:'115,130',profession:'Pharmacists'},
    {state:'Wisconsin',amount:'132,400',profession:'Pharmacists'},
    {state:'Wyoming',amount:'117,700',profession:'Pharmacists'},
    {state:'Guam',amount:'115,030',profession:'Pharmacists'},
    {state:'Puerto Rico',amount:'87,840',profession:'Pharmacists'},
    {state:'Virgin Islands',amount:'126,720',profession:'Pharmacists'},

    // Social and Community Service Managers
    {state:'Alabama',amount:'66,430',profession:'Social and Community Service Managers'},
    {state:'Alaska',amount:'73,410',profession:'Social and Community Service Managers'},
    {state:'Arizona',amount:'65,610',profession:'Social and Community Service Managers'},
    {state:'Arkansas',amount:'57,360',profession:'Social and Community Service Managers'},
    {state:'California',amount:'73,640',profession:'Social and Community Service Managers'},
    {state:'Colorado',amount:'84,360',profession:'Social and Community Service Managers'},
    {state:'Connecticut',amount:'73,560',profession:'Social and Community Service Managers'},
    {state:'Delaware',amount:'69,230',profession:'Social and Community Service Managers'},
    {state:'District of Columbia',amount:'101,360',profession:'Social and Community Service Managers'},
    {state:'Florida',amount:'71,820',profession:'Social and Community Service Managers'},
    {state:'Georgia',amount:'66,000',profession:'Social and Community Service Managers'},
    {state:'Hawaii',amount:'71,590',profession:'Social and Community Service Managers'},
    {state:'Idaho',amount:'52,490',profession:'Social and Community Service Managers'},
    {state:'Illinois',amount:'66,150',profession:'Social and Community Service Managers'},
    {state:'Indiana',amount:'61,180',profession:'Social and Community Service Managers'},
    {state:'Iowa',amount:'58,410',profession:'Social and Community Service Managers'},
    {state:'Kansas',amount:'63,010',profession:'Social and Community Service Managers'},
    {state:'Kentucky',amount:'63,210',profession:'Social and Community Service Managers'},
    {state:'Louisiana',amount:'70,120',profession:'Social and Community Service Managers'},
    {state:'Maine',amount:'60,620',profession:'Social and Community Service Managers'},
    {state:'Maryland',amount:'76,670',profession:'Social and Community Service Managers'},
    {state:'Massachusetts',amount:'70,500',profession:'Social and Community Service Managers'},
    {state:'Michigan',amount:'72,450',profession:'Social and Community Service Managers'},
    {state:'Minnesota',amount:'75,280',profession:'Social and Community Service Managers'},
    {state:'Mississippi',amount:'47,700',profession:'Social and Community Service Managers'},
    {state:'Missouri',amount:'60,450',profession:'Social and Community Service Managers'},
    {state:'Montana',amount:'55,440',profession:'Social and Community Service Managers'},
    {state:'Nebraska',amount:'65,270',profession:'Social and Community Service Managers'},
    {state:'Nevada',amount:'75,840',profession:'Social and Community Service Managers'},
    {state:'New Hampshire',amount:'65,380',profession:'Social and Community Service Managers'},
    {state:'New Jersey',amount:'88,570',profession:'Social and Community Service Managers'},
    {state:'New Mexico',amount:'65,750',profession:'Social and Community Service Managers'},
    {state:'New York',amount:'86,700',profession:'Social and Community Service Managers'},
    {state:'North Carolina',amount:'69,640',profession:'Social and Community Service Managers'},
    {state:'North Dakota',amount:'65,850',profession:'Social and Community Service Managers'},
    {state:'Ohio',amount:'73,210',profession:'Social and Community Service Managers'},
    {state:'Oklahoma',amount:'62,530',profession:'Social and Community Service Managers'},
    {state:'Oregon',amount:'63,590',profession:'Social and Community Service Managers'},
    {state:'Pennsylvania',amount:'65,620',profession:'Social and Community Service Managers'},
    {state:'Rhode Island',amount:'96,550',profession:'Social and Community Service Managers'},
    {state:'South Carolina',amount:'68,610',profession:'Social and Community Service Managers'},
    {state:'South Dakota',amount:'71,630',profession:'Social and Community Service Managers'},
    {state:'Tennessee',amount:'68,450',profession:'Social and Community Service Managers'},
    {state:'Texas',amount:'72,560',profession:'Social and Community Service Managers'},
    {state:'Utah',amount:'64,320',profession:'Social and Community Service Managers'},
    {state:'Vermont',amount:'65,260',profession:'Social and Community Service Managers'},
    {state:'Virginia',amount:'89,290',profession:'Social and Community Service Managers'},
    {state:'Washington',amount:'63,870',profession:'Social and Community Service Managers'},
    {state:'West Virginia',amount:'56,460',profession:'Social and Community Service Managers'},
    {state:'Wisconsin',amount:'66,750',profession:'Social and Community Service Managers'},
    {state:'Wyoming',amount:'63,270',profession:'Social and Community Service Managers'},
    {state:'Guam',amount:'56,130',profession:'Social and Community Service Managers'},
    {state:'Puerto Rico',amount:'35,580',profession:'Social and Community Service Managers'},
    {state:'Virgin Islands',amount:'73,810',profession:'Social and Community Service Managers'},

    // Psychiatrists
    {state:'Alabama',amount:'166,220',profession:'Psychiatrists'},
    {state:'Alaska',amount:'222,310',profession:'Psychiatrists'},
    {state:'Arizona',amount:'240,660',profession:'Psychiatrists'},
    {state:'Arkansas',amount:'153,920',profession:'Psychiatrists'},
    {state:'California',amount:'255,790',profession:'Psychiatrists'},
    {state:'Colorado',amount:'234,860',profession:'Psychiatrists'},
    {state:'Connecticut',amount:'258,200',profession:'Psychiatrists'},
    {state:'District of Columbia',amount:'167,190',profession:'Psychiatrists'},
    {state:'Florida',amount:'195,400',profession:'Psychiatrists'},
    {state:'Georgia',amount:'231,410',profession:'Psychiatrists'},
    {state:'Hawaii',amount:'269,800',profession:'Psychiatrists'},
    {state:'Illinois',amount:'251,390',profession:'Psychiatrists'},
    {state:'Indiana',amount:'243,630',profession:'Psychiatrists'},
    {state:'Iowa',amount:'211,870',profession:'Psychiatrists'},
    {state:'Kansas',amount:'226,090',profession:'Psychiatrists'},
    {state:'Kentucky',amount:'210,680',profession:'Psychiatrists'},
    {state:'Louisiana',amount:'120,090',profession:'Psychiatrists'},
    {state:'Maine',amount:'256,270',profession:'Psychiatrists'},
    {state:'Maryland',amount:'215,000',profession:'Psychiatrists'},
    {state:'Massachusetts',amount:'194,220',profession:'Psychiatrists'},
    {state:'Michigan',amount:'212,030',profession:'Psychiatrists'},
    {state:'Minnesota',amount:'250,550',profession:'Psychiatrists'},
    {state:'Mississippi',amount:'221,060',profession:'Psychiatrists'},
    {state:'Missouri',amount:'240,300',profession:'Psychiatrists'},
    {state:'Montana',amount:'167,370',profession:'Psychiatrists'},
    {state:'Nebraska',amount:'240,180',profession:'Psychiatrists'},
    {state:'Nevada',amount:'214,980',profession:'Psychiatrists'},
    {state:'New Hampshire',amount:'212,710',profession:'Psychiatrists'},
    {state:'New Jersey',amount:'245,990',profession:'Psychiatrists'},
    {state:'New Mexico',amount:'255,410',profession:'Psychiatrists'},
    {state:'New York',amount:'208,750',profession:'Psychiatrists'},
    {state:'North Carolina',amount:'189,190',profession:'Psychiatrists'},
    {state:'North Dakota',amount:'196,410',profession:'Psychiatrists'},
    {state:'Ohio',amount:'194,700',profession:'Psychiatrists'},
    {state:'Oklahoma',amount:'183,930',profession:'Psychiatrists'},
    {state:'Oregon',amount:'242,020',profession:'Psychiatrists'},
    {state:'Pennsylvania',amount:'232,990',profession:'Psychiatrists'},
    {state:'Rhode Island',amount:'224,440',profession:'Psychiatrists'},
    {state:'South Carolina',amount:'226,120',profession:'Psychiatrists'},
    {state:'Tennessee',amount:'195,670',profession:'Psychiatrists'},
    {state:'Texas',amount:'204,480',profession:'Psychiatrists'},
    {state:'Utah',amount:'145,700',profession:'Psychiatrists'},
    {state:'Vermont',amount:'186,400',profession:'Psychiatrists'},
    {state:'Virginia',amount:'198,810',profession:'Psychiatrists'},
    {state:'Washington',amount:'245,990',profession:'Psychiatrists'},
    {state:'West Virginia',amount:'166,400',profession:'Psychiatrists'},
    {state:'Wisconsin',amount:'186,200',profession:'Psychiatrists'},
    {state:'Puerto Rico',amount:'82,720',profession:'Psychiatrists'},

    // Personal Care Aides
    {state:'Alabama',amount:'19,250',profession:'Personal Care Aides'},
    {state:'Alaska',amount:'33,840',profession:'Personal Care Aides'},
    {state:'Arizona',amount:'24,440',profession:'Personal Care Aides'},
    {state:'Arkansas',amount:'21,390',profession:'Personal Care Aides'},
    {state:'California',amount:'27,210',profession:'Personal Care Aides'},
    {state:'Colorado',amount:'26,410',profession:'Personal Care Aides'},
    {state:'Connecticut',amount:'27,300',profession:'Personal Care Aides'},
    {state:'Delaware',amount:'23,840',profession:'Personal Care Aides'},
    {state:'District of Columbia',amount:'30,440',profession:'Personal Care Aides'},
    {state:'Florida',amount:'23,390',profession:'Personal Care Aides'},
    {state:'Georgia',amount:'22,540',profession:'Personal Care Aides'},
    {state:'Hawaii',amount:'27,530',profession:'Personal Care Aides'},
    {state:'Idaho',amount:'22,970',profession:'Personal Care Aides'},
    {state:'Illinois',amount:'24,600',profession:'Personal Care Aides'},
    {state:'Indiana',amount:'22,830',profession:'Personal Care Aides'},
    {state:'Iowa',amount:'25,050',profession:'Personal Care Aides'},
    {state:'Kansas',amount:'21,920',profession:'Personal Care Aides'},
    {state:'Kentucky',amount:'25,740',profession:'Personal Care Aides'},
    {state:'Louisiana',amount:'19,300',profession:'Personal Care Aides'},
    {state:'Maine',amount:'25,490',profession:'Personal Care Aides'},
    {state:'Maryland',amount:'26,910',profession:'Personal Care Aides'},
    {state:'Massachusetts',amount:'29,080',profession:'Personal Care Aides'},
    {state:'Michigan',amount:'24,230',profession:'Personal Care Aides'},
    {state:'Minnesota',amount:'26,260',profession:'Personal Care Aides'},
    {state:'Mississippi',amount:'20,800',profession:'Personal Care Aides'},
    {state:'Missouri',amount:'23,020',profession:'Personal Care Aides'},
    {state:'Montana',amount:'24,250',profession:'Personal Care Aides'},
    {state:'Nebraska',amount:'26,230',profession:'Personal Care Aides'},
    {state:'Nevada',amount:'23,580',profession:'Personal Care Aides'},
    {state:'New Hampshire',amount:'26,900',profession:'Personal Care Aides'},
    {state:'New Jersey',amount:'29,890',profession:'Personal Care Aides'},
    {state:'New Mexico',amount:'21,020',profession:'Personal Care Aides'},
    {state:'New York',amount:'27,640',profession:'Personal Care Aides'},
    {state:'North Carolina',amount:'21,660',profession:'Personal Care Aides'},
    {state:'North Dakota',amount:'32,890',profession:'Personal Care Aides'},
    {state:'Ohio',amount:'23,530',profession:'Personal Care Aides'},
    {state:'Oklahoma',amount:'20,270',profession:'Personal Care Aides'},
    {state:'Oregon',amount:'26,980',profession:'Personal Care Aides'},
    {state:'Pennsylvania',amount:'24,880',profession:'Personal Care Aides'},
    {state:'Rhode Island',amount:'27,190',profession:'Personal Care Aides'},
    {state:'South Carolina',amount:'20,990',profession:'Personal Care Aides'},
    {state:'South Dakota',amount:'24,400',profession:'Personal Care Aides'},
    {state:'Tennessee',amount:'21,060',profession:'Personal Care Aides'},
    {state:'Texas',amount:'19,960',profession:'Personal Care Aides'},
    {state:'Utah',amount:'25,740',profession:'Personal Care Aides'},
    {state:'Vermont',amount:'30,750',profession:'Personal Care Aides'},
    {state:'Virginia',amount:'21,240',profession:'Personal Care Aides'},
    {state:'Washington',amount:'29,140',profession:'Personal Care Aides'},
    {state:'West Virginia',amount:'20,760',profession:'Personal Care Aides'},
    {state:'Wisconsin',amount:'24,250',profession:'Personal Care Aides'},
    {state:'Wyoming',amount:'26,780',profession:'Personal Care Aides'},
    {state:'Puerto Rico',amount:'18,120',profession:'Personal Care Aides'},
    {state:'Virgin Islands',amount:'23,760',profession:'Personal Care Aides'},

    // Web Developers
    {state:'Alabama',amount:'67,250',profession:'Web Developers'},
    {state:'Alaska',amount:'59,990',profession:'Web Developers'},
    {state:'Arizona',amount:'70,450',profession:'Web Developers'},
    {state:'Arkansas',amount:'50,930',profession:'Web Developers'},
    {state:'California',amount:'86,160',profession:'Web Developers'},
    {state:'Colorado',amount:'78,790',profession:'Web Developers'},
    {state:'Connecticut',amount:'78,200',profession:'Web Developers'},
    {state:'Delaware',amount:'72,070',profession:'Web Developers'},
    {state:'District of Columbia',amount:'87,320',profession:'Web Developers'},
    {state:'Florida',amount:'64,160',profession:'Web Developers'},
    {state:'Georgia',amount:'80,090',profession:'Web Developers'},
    {state:'Hawaii',amount:'62,710',profession:'Web Developers'},
    {state:'Idaho',amount:'54,720',profession:'Web Developers'},
    {state:'Illinois',amount:'74,420',profession:'Web Developers'},
    {state:'Indiana',amount:'59,870',profession:'Web Developers'},
    {state:'Iowa',amount:'58,340',profession:'Web Developers'},
    {state:'Kansas',amount:'62,850',profession:'Web Developers'},
    {state:'Kentucky',amount:'71,610',profession:'Web Developers'},
    {state:'Louisiana',amount:'55,310',profession:'Web Developers'},
    {state:'Maine',amount:'60,290',profession:'Web Developers'},
    {state:'Maryland',amount:'78,030',profession:'Web Developers'},
    {state:'Massachusetts',amount:'84,300',profession:'Web Developers'},
    {state:'Michigan',amount:'67,000',profession:'Web Developers'},
    {state:'Minnesota',amount:'79,690',profession:'Web Developers'},
    {state:'Mississippi',amount:'63,800',profession:'Web Developers'},
    {state:'Missouri',amount:'65,090',profession:'Web Developers'},
    {state:'Montana',amount:'49,510',profession:'Web Developers'},
    {state:'Nebraska',amount:'58,500',profession:'Web Developers'},
    {state:'Nevada',amount:'59,320',profession:'Web Developers'},
    {state:'New Hampshire',amount:'66,890',profession:'Web Developers'},
    {state:'New Jersey',amount:'84,500',profession:'Web Developers'},
    {state:'New Mexico',amount:'61,470',profession:'Web Developers'},
    {state:'New York',amount:'79,880',profession:'Web Developers'},
    {state:'North Carolina',amount:'73,610',profession:'Web Developers'},
    {state:'North Dakota',amount:'59,090',profession:'Web Developers'},
    {state:'Ohio',amount:'64,700',profession:'Web Developers'},
    {state:'Oklahoma',amount:'60,280',profession:'Web Developers'},
    {state:'Oregon',amount:'68,760',profession:'Web Developers'},
    {state:'Pennsylvania',amount:'72,030',profession:'Web Developers'},
    {state:'Rhode Island',amount:'71,520',profession:'Web Developers'},
    {state:'South Carolina',amount:'77,950',profession:'Web Developers'},
    {state:'South Dakota',amount:'54,410',profession:'Web Developers'},
    {state:'Tennessee',amount:'61,910',profession:'Web Developers'},
    {state:'Texas',amount:'74,250',profession:'Web Developers'},
    {state:'Utah',amount:'69,940',profession:'Web Developers'},
    {state:'Vermont',amount:'60,790',profession:'Web Developers'},
    {state:'Virginia',amount:'88,850',profession:'Web Developers'},
    {state:'Washington',amount:'94,060',profession:'Web Developers'},
    {state:'West Virginia',amount:'55,580',profession:'Web Developers'},
    {state:'Wisconsin',amount:'53,730',profession:'Web Developers'},
    {state:'Wyoming',amount:'64,340',profession:'Web Developers'},
    {state:'Puerto Rico',amount:'38,560',profession:'Web Developers'},

    // Substance Abuse, Behavioral Disorder, and Mental Health Counselors
    {state:'Alabama',amount:'42,640',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Alaska',amount:'62,920',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Arizona',amount:'42,310',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Arkansas',amount:'52,110',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'California',amount:'50,950',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Colorado',amount:'48,490',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Connecticut',amount:'52,070',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Delaware',amount:'44,660',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'District of Columbia',amount:'59,850',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Florida',amount:'44,140',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Georgia',amount:'45,150',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Hawaii',amount:'54,550',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Idaho',amount:'46,920',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Illinois',amount:'44,250',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Indiana',amount:'44,550',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Iowa',amount:'47,600',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Kansas',amount:'41,330',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Kentucky',amount:'42,240',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Louisiana',amount:'40,380',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Maine',amount:'50,600',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Maryland',amount:'46,350',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Massachusetts',amount:'47,880',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Michigan',amount:'48,440',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Minnesota',amount:'49,280',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Mississippi',amount:'39,710',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Missouri',amount:'38,150',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Montana',amount:'45,160',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Nebraska',amount:'49,850',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Nevada',amount:'51,130',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New Hampshire',amount:'43,600',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New Jersey',amount:'58,410',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New Mexico',amount:'47,040',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'New York',amount:'51,380',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'North Carolina',amount:'48,900',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'North Dakota',amount:'55,220',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Ohio',amount:'47,040',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Oklahoma',amount:'48,670',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Oregon',amount:'59,390',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Pennsylvania',amount:'45,740',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'South Carolina',amount:'38,410',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'South Dakota',amount:'41,790',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Tennessee',amount:'38,030',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Texas',amount:'47,010',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Utah',amount:'66,330',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Vermont',amount:'46,950',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Virginia',amount:'49,860',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Washington',amount:'48,430',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'West Virginia',amount:'39,950',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Wisconsin',amount:'42,650',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Wyoming',amount:'56,690',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},
    {state:'Puerto Rico',amount:'26,610',profession:'Substance Abuse, Behavioral Disorder, and Mental Health Counselors'},

    // Optometrists
    {state:'Alabama',amount:'114,070',profession:'Optometrists'},
    {state:'Alaska',amount:'165,640',profession:'Optometrists'},
    {state:'Arizona',amount:'124,920',profession:'Optometrists'},
    {state:'Arkansas',amount:'95,500',profession:'Optometrists'},
    {state:'California',amount:'117,180',profession:'Optometrists'},
    {state:'Colorado',amount:'132,030',profession:'Optometrists'},
    {state:'Connecticut',amount:'138,140',profession:'Optometrists'},
    {state:'Delaware',amount:'116,210',profession:'Optometrists'},
    {state:'District of Columbia',amount:'90,140',profession:'Optometrists'},
    {state:'Florida',amount:'102,060',profession:'Optometrists'},
    {state:'Georgia',amount:'104,970',profession:'Optometrists'},
    {state:'Hawaii',amount:'117,310',profession:'Optometrists'},
    {state:'Idaho',amount:'96,070',profession:'Optometrists'},
    {state:'Illinois',amount:'121,610',profession:'Optometrists'},
    {state:'Indiana',amount:'113,880',profession:'Optometrists'},
    {state:'Iowa',amount:'130,160',profession:'Optometrists'},
    {state:'Kansas',amount:'117,840',profession:'Optometrists'},
    {state:'Kentucky',amount:'114,550',profession:'Optometrists'},
    {state:'Louisiana',amount:'104,360',profession:'Optometrists'},
    {state:'Maine',amount:'136,510',profession:'Optometrists'},
    {state:'Maryland',amount:'129,000',profession:'Optometrists'},
    {state:'Massachusetts',amount:'141,890',profession:'Optometrists'},
    {state:'Michigan',amount:'112,440',profession:'Optometrists'},
    {state:'Minnesota',amount:'134,270',profession:'Optometrists'},
    {state:'Mississippi',amount:'133,370',profession:'Optometrists'},
    {state:'Missouri',amount:'114,110',profession:'Optometrists'},
    {state:'Montana',amount:'110,370',profession:'Optometrists'},
    {state:'Nebraska',amount:'104,010',profession:'Optometrists'},
    {state:'Nevada',amount:'127,940',profession:'Optometrists'},
    {state:'New Hampshire',amount:'131,180',profession:'Optometrists'},
    {state:'New Jersey',amount:'114,630',profession:'Optometrists'},
    {state:'New Mexico',amount:'86,870',profession:'Optometrists'},
    {state:'New York',amount:'124,820',profession:'Optometrists'},
    {state:'North Carolina',amount:'136,260',profession:'Optometrists'},
    {state:'North Dakota',amount:'175,090',profession:'Optometrists'},
    {state:'Ohio',amount:'132,400',profession:'Optometrists'},
    {state:'Oklahoma',amount:'109,300',profession:'Optometrists'},
    {state:'Oregon',amount:'99,560',profession:'Optometrists'},
    {state:'Pennsylvania',amount:'119,820',profession:'Optometrists'},
    {state:'Rhode Island',amount:'104,320',profession:'Optometrists'},
    {state:'South Carolina',amount:'142,290',profession:'Optometrists'},
    {state:'South Dakota',amount:'96,540',profession:'Optometrists'},
    {state:'Tennessee',amount:'115,960',profession:'Optometrists'},
    {state:'Texas',amount:'123,930',profession:'Optometrists'},
    {state:'Utah',amount:'74,490',profession:'Optometrists'},
    {state:'Vermont',amount:'170,550',profession:'Optometrists'},
    {state:'Virginia',amount:'129,010',profession:'Optometrists'},
    {state:'Washington',amount:'119,860',profession:'Optometrists'},
    {state:'West Virginia',amount:'118,270',profession:'Optometrists'},
    {state:'Wisconsin',amount:'122,310',profession:'Optometrists'},
    {state:'Wyoming',amount:'135,220',profession:'Optometrists'},
    {state:'Puerto Rico',amount:'61,180',profession:'Optometrists'},

    // Database Administrators
    {state:'Alabama',amount:'83,580',profession:'Database Administrators'},
    {state:'Alaska',amount:'79,600',profession:'Database Administrators'},
    {state:'Arizona',amount:'88,670',profession:'Database Administrators'},
    {state:'Arkansas',amount:'73,600',profession:'Database Administrators'},
    {state:'California',amount:'100,890',profession:'Database Administrators'},
    {state:'Colorado',amount:'91,410',profession:'Database Administrators'},
    {state:'Connecticut',amount:'100,570',profession:'Database Administrators'},
    {state:'Delaware',amount:'92,460',profession:'Database Administrators'},
    {state:'District of Columbia',amount:'95,710',profession:'Database Administrators'},
    {state:'Florida',amount:'86,870',profession:'Database Administrators'},
    {state:'Georgia',amount:'92,090',profession:'Database Administrators'},
    {state:'Hawaii',amount:'90,380',profession:'Database Administrators'},
    {state:'Idaho',amount:'69,280',profession:'Database Administrators'},
    {state:'Illinois',amount:'96,230',profession:'Database Administrators'},
    {state:'Indiana',amount:'74,340',profession:'Database Administrators'},
    {state:'Iowa',amount:'90,540',profession:'Database Administrators'},
    {state:'Kansas',amount:'82,430',profession:'Database Administrators'},
    {state:'Kentucky',amount:'78,310',profession:'Database Administrators'},
    {state:'Louisiana',amount:'90,420',profession:'Database Administrators'},
    {state:'Maine',amount:'76,540',profession:'Database Administrators'},
    {state:'Maryland',amount:'85,240',profession:'Database Administrators'},
    {state:'Massachusetts',amount:'98,620',profession:'Database Administrators'},
    {state:'Michigan',amount:'83,900',profession:'Database Administrators'},
    {state:'Minnesota',amount:'91,110',profession:'Database Administrators'},
    {state:'Mississippi',amount:'75,020',profession:'Database Administrators'},
    {state:'Missouri',amount:'86,660',profession:'Database Administrators'},
    {state:'Montana',amount:'69,270',profession:'Database Administrators'},
    {state:'Nebraska',amount:'82,550',profession:'Database Administrators'},
    {state:'Nevada',amount:'89,320',profession:'Database Administrators'},
    {state:'New Hampshire',amount:'95,880',profession:'Database Administrators'},
    {state:'New Jersey',amount:'110,160',profession:'Database Administrators'},
    {state:'New Mexico',amount:'80,270',profession:'Database Administrators'},
    {state:'New York',amount:'99,000',profession:'Database Administrators'},
    {state:'North Carolina',amount:'92,140',profession:'Database Administrators'},
    {state:'North Dakota',amount:'71,290',profession:'Database Administrators'},
    {state:'Ohio',amount:'89,330',profession:'Database Administrators'},
    {state:'Oklahoma',amount:'74,110',profession:'Database Administrators'},
    {state:'Oregon',amount:'92,150',profession:'Database Administrators'},
    {state:'Pennsylvania',amount:'84,510',profession:'Database Administrators'},
    {state:'Rhode Island',amount:'92,410',profession:'Database Administrators'},
    {state:'South Carolina',amount:'82,500',profession:'Database Administrators'},
    {state:'South Dakota',amount:'76,770',profession:'Database Administrators'},
    {state:'Tennessee',amount:'78,650',profession:'Database Administrators'},
    {state:'Texas',amount:'95,470',profession:'Database Administrators'},
    {state:'Utah',amount:'94,230',profession:'Database Administrators'},
    {state:'Vermont',amount:'78,150',profession:'Database Administrators'},
    {state:'Virginia',amount:'98,090',profession:'Database Administrators'},
    {state:'Washington',amount:'104,700',profession:'Database Administrators'},
    {state:'West Virginia',amount:'68,940',profession:'Database Administrators'},
    {state:'Wisconsin',amount:'84,990',profession:'Database Administrators'},
    {state:'Wyoming',amount:'59,780',profession:'Database Administrators'},
    {state:'Puerto Rico',amount:'48,210',profession:'Database Administrators'},

    // Orthotists and Prosthetists
    {state:'Alabama',amount:'61,600',profession:'Orthotists and Prosthetists'},
    {state:'Alaska',amount:'62,070',profession:'Orthotists and Prosthetists'},
    {state:'Arizona',amount:'71,010',profession:'Orthotists and Prosthetists'},
    {state:'Arkansas',amount:'59,150',profession:'Orthotists and Prosthetists'},
    {state:'California',amount:'88,460',profession:'Orthotists and Prosthetists'},
    {state:'Colorado',amount:'58,740',profession:'Orthotists and Prosthetists'},
    {state:'Florida',amount:'54,830',profession:'Orthotists and Prosthetists'},
    {state:'Georgia',amount:'67,830',profession:'Orthotists and Prosthetists'},
    {state:'Hawaii',amount:'62,590',profession:'Orthotists and Prosthetists'},
    {state:'Idaho',amount:'72,720',profession:'Orthotists and Prosthetists'},
    {state:'Illinois',amount:'81,090',profession:'Orthotists and Prosthetists'},
    {state:'Indiana',amount:'58,460',profession:'Orthotists and Prosthetists'},
    {state:'Iowa',amount:'66,490',profession:'Orthotists and Prosthetists'},
    {state:'Kansas',amount:'76,480',profession:'Orthotists and Prosthetists'},
    {state:'Kentucky',amount:'66,080',profession:'Orthotists and Prosthetists'},
    {state:'Louisiana',amount:'83,060',profession:'Orthotists and Prosthetists'},
    {state:'Maine',amount:'78,620',profession:'Orthotists and Prosthetists'},
    {state:'Maryland',amount:'65,620',profession:'Orthotists and Prosthetists'},
    {state:'Massachusetts',amount:'79,020',profession:'Orthotists and Prosthetists'},
    {state:'Michigan',amount:'76,430',profession:'Orthotists and Prosthetists'},
    {state:'Minnesota',amount:'76,920',profession:'Orthotists and Prosthetists'},
    {state:'Mississippi',amount:'*',profession:'Orthotists and Prosthetists'},
    {state:'Missouri',amount:'76,540',profession:'Orthotists and Prosthetists'},
    {state:'Montana',amount:'55,690',profession:'Orthotists and Prosthetists'},
    {state:'Nebraska',amount:'64,740',profession:'Orthotists and Prosthetists'},
    {state:'Nevada',amount:'70,510',profession:'Orthotists and Prosthetists'},
    {state:'New Hampshire',amount:'81,460',profession:'Orthotists and Prosthetists'},
    {state:'New Jersey',amount:'70,900',profession:'Orthotists and Prosthetists'},
    {state:'New York',amount:'79,990',profession:'Orthotists and Prosthetists'},
    {state:'North Carolina',amount:'78,910',profession:'Orthotists and Prosthetists'},
    {state:'North Dakota',amount:'66,810',profession:'Orthotists and Prosthetists'},
    {state:'Ohio',amount:'69,380',profession:'Orthotists and Prosthetists'},
    {state:'Oklahoma',amount:'55,080',profession:'Orthotists and Prosthetists'},
    {state:'Oregon',amount:'68,860',profession:'Orthotists and Prosthetists'},
    {state:'Pennsylvania',amount:'67,320',profession:'Orthotists and Prosthetists'},
    {state:'Rhode Island',amount:'75,310',profession:'Orthotists and Prosthetists'},
    {state:'South Carolina',amount:'64,300',profession:'Orthotists and Prosthetists'},
    {state:'South Dakota',amount:'66,260',profession:'Orthotists and Prosthetists'},
    {state:'Tennessee',amount:'62,800',profession:'Orthotists and Prosthetists'},
    {state:'Texas',amount:'82,730',profession:'Orthotists and Prosthetists'},
    {state:'Virginia',amount:'79,290',profession:'Orthotists and Prosthetists'},
    {state:'Washington',amount:'74,100',profession:'Orthotists and Prosthetists'},
    {state:'West Virginia',amount:'67,130',profession:'Orthotists and Prosthetists'},
    {state:'Wisconsin',amount:'71,380',profession:'Orthotists and Prosthetists'},
    {state:'Puerto Rico',amount:'67,410',profession:'Orthotists and Prosthetists'},

    // Political Scientists
    {state:'California',amount:'74,060',profession:'Political Scientists'},
    {state:'District of Columbia',amount:'120,610',profession:'Political Scientists'},
    {state:'Florida',amount:'95,120',profession:'Political Scientists'},
    {state:'Illinois',amount:'80,520',profession:'Political Scientists'},
    {state:'Maine',amount:'72,850',profession:'Political Scientists'},
    {state:'Maryland',amount:'123,150',profession:'Political Scientists'},
    {state:'Massachusetts',amount:'88,120',profession:'Political Scientists'},
    {state:'Michigan',amount:'95,570',profession:'Political Scientists'},
    {state:'New York',amount:'122,440',profession:'Political Scientists'},
    {state:'Pennsylvania',amount:'102,110',profession:'Political Scientists'},
    {state:'Texas',amount:'87,610',profession:'Political Scientists'},
    {state:'Virginia',amount:'128,590',profession:'Political Scientists'},
    {state:'Washington',amount:'84,480',profession:'Political Scientists'},

    // Clinical, Counseling, and School Psychologists
    {state:'Alabama',amount:'69,070',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Alaska',amount:'91,450',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Arizona',amount:'66,040',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Arkansas',amount:'69,000',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'California',amount:'108,350',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Colorado',amount:'85,470',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Connecticut',amount:'90,870',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Delaware',amount:'78,850',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'District of Columbia',amount:'95,500',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Florida',amount:'76,190',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Georgia',amount:'89,190',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Hawaii',amount:'94,550',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Idaho',amount:'64,270',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Illinois',amount:'75,180',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Indiana',amount:'73,350',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Iowa',amount:'85,260',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Kansas',amount:'65,320',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Kentucky',amount:'64,330',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Louisiana',amount:'86,630',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Maine',amount:'75,620',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Maryland',amount:'79,820',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Massachusetts',amount:'86,490',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Michigan',amount:'83,210',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Minnesota',amount:'85,860',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Mississippi',amount:'67,570',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Missouri',amount:'76,480',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Montana',amount:'63,720',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Nebraska',amount:'66,510',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Nevada',amount:'83,760',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'New Hampshire',amount:'84,270',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'New Jersey',amount:'98,470',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'New Mexico',amount:'73,600',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'New York',amount:'94,140',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'North Carolina',amount:'77,470',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'North Dakota',amount:'87,090',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Ohio',amount:'75,710',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Oklahoma',amount:'60,760',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Oregon',amount:'103,870',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Pennsylvania',amount:'83,610',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Rhode Island',amount:'83,030',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'South Carolina',amount:'63,050',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'South Dakota',amount:'73,900',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Tennessee',amount:'69,510',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Texas',amount:'73,650',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Utah',amount:'80,920',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Vermont',amount:'77,670',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Virginia',amount:'80,380',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Washington',amount:'73,840',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'West Virginia',amount:'59,200',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Wisconsin',amount:'83,420',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Wyoming',amount:'78,360',profession:'Clinical, Counseling, and School Psychologists'},
    {state:'Puerto Rico',amount:'50,440',profession:'Clinical, Counseling, and School Psychologists'},

    // Personal Financial Advisors
    {state:'Alabama',amount:'117,350',profession:'Personal Financial Advisors'},
    {state:'Alaska',amount:'93,530',profession:'Personal Financial Advisors'},
    {state:'Arizona',amount:'107,160',profession:'Personal Financial Advisors'},
    {state:'Arkansas',amount:'96,600',profession:'Personal Financial Advisors'},
    {state:'California',amount:'128,730',profession:'Personal Financial Advisors'},
    {state:'Colorado',amount:'103,540',profession:'Personal Financial Advisors'},
    {state:'Connecticut',amount:'131,280',profession:'Personal Financial Advisors'},
    {state:'Delaware',amount:'126,880',profession:'Personal Financial Advisors'},
    {state:'District of Columbia',amount:'158,460',profession:'Personal Financial Advisors'},
    {state:'Florida',amount:'122,840',profession:'Personal Financial Advisors'},
    {state:'Georgia',amount:'121,420',profession:'Personal Financial Advisors'},
    {state:'Hawaii',amount:'81,700',profession:'Personal Financial Advisors'},
    {state:'Idaho',amount:'104,640',profession:'Personal Financial Advisors'},
    {state:'Illinois',amount:'126,640',profession:'Personal Financial Advisors'},
    {state:'Indiana',amount:'111,330',profession:'Personal Financial Advisors'},
    {state:'Iowa',amount:'105,540',profession:'Personal Financial Advisors'},
    {state:'Kansas',amount:'93,720',profession:'Personal Financial Advisors'},
    {state:'Kentucky',amount:'85,470',profession:'Personal Financial Advisors'},
    {state:'Louisiana',amount:'92,300',profession:'Personal Financial Advisors'},
    {state:'Maine',amount:'135,170',profession:'Personal Financial Advisors'},
    {state:'Maryland',amount:'110,080',profession:'Personal Financial Advisors'},
    {state:'Massachusetts',amount:'128,140',profession:'Personal Financial Advisors'},
    {state:'Michigan',amount:'102,010',profession:'Personal Financial Advisors'},
    {state:'Minnesota',amount:'99,490',profession:'Personal Financial Advisors'},
    {state:'Mississippi',amount:'102,820',profession:'Personal Financial Advisors'},
    {state:'Missouri',amount:'85,830',profession:'Personal Financial Advisors'},
    {state:'Montana',amount:'102,730',profession:'Personal Financial Advisors'},
    {state:'Nebraska',amount:'85,890',profession:'Personal Financial Advisors'},
    {state:'Nevada',amount:'108,540',profession:'Personal Financial Advisors'},
    {state:'New Hampshire',amount:'105,010',profession:'Personal Financial Advisors'},
    {state:'New Jersey',amount:'127,150',profession:'Personal Financial Advisors'},
    {state:'New Mexico',amount:'133,500',profession:'Personal Financial Advisors'},
    {state:'New York',amount:'164,260',profession:'Personal Financial Advisors'},
    {state:'North Carolina',amount:'134,860',profession:'Personal Financial Advisors'},
    {state:'North Dakota',amount:'100,360',profession:'Personal Financial Advisors'},
    {state:'Ohio',amount:'102,300',profession:'Personal Financial Advisors'},
    {state:'Oklahoma',amount:'74,340',profession:'Personal Financial Advisors'},
    {state:'Oregon',amount:'117,730',profession:'Personal Financial Advisors'},
    {state:'Pennsylvania',amount:'109,250',profession:'Personal Financial Advisors'},
    {state:'Rhode Island',amount:'112,430',profession:'Personal Financial Advisors'},
    {state:'South Carolina',amount:'89,830',profession:'Personal Financial Advisors'},
    {state:'South Dakota',amount:'77,490',profession:'Personal Financial Advisors'},
    {state:'Tennessee',amount:'89,960',profession:'Personal Financial Advisors'},
    {state:'Texas',amount:'110,820',profession:'Personal Financial Advisors'},
    {state:'Utah',amount:'88,440',profession:'Personal Financial Advisors'},
    {state:'Vermont',amount:'85,150',profession:'Personal Financial Advisors'},
    {state:'Virginia',amount:'121,250',profession:'Personal Financial Advisors'},
    {state:'Washington',amount:'109,870',profession:'Personal Financial Advisors'},
    {state:'West Virginia',amount:'95,210',profession:'Personal Financial Advisors'},
    {state:'Wisconsin',amount:'115,820',profession:'Personal Financial Advisors'},
    {state:'Wyoming',amount:'135,340',profession:'Personal Financial Advisors'},
    {state:'Puerto Rico',amount:'76,090',profession:'Personal Financial Advisors'},

    // Construction Managers
    {state:'Alabama',amount:'96,500',profession:'Construction Managers'},
    {state:'Alaska',amount:'115,580',profession:'Construction Managers'},
    {state:'Arizona',amount:'92,520',profession:'Construction Managers'},
    {state:'Arkansas',amount:'78,250',profession:'Construction Managers'},
    {state:'California',amount:'117,770',profession:'Construction Managers'},
    {state:'Colorado',amount:'97,170',profession:'Construction Managers'},
    {state:'Connecticut',amount:'112,570',profession:'Construction Managers'},
    {state:'Delaware',amount:'124,000',profession:'Construction Managers'},
    {state:'District of Columbia',amount:'103,310',profession:'Construction Managers'},
    {state:'Florida',amount:'94,150',profession:'Construction Managers'},
    {state:'Georgia',amount:'105,330',profession:'Construction Managers'},
    {state:'Hawaii',amount:'109,850',profession:'Construction Managers'},
    {state:'Idaho',amount:'78,880',profession:'Construction Managers'},
    {state:'Illinois',amount:'95,020',profession:'Construction Managers'},
    {state:'Indiana',amount:'86,210',profession:'Construction Managers'},
    {state:'Iowa',amount:'84,710',profession:'Construction Managers'},
    {state:'Kansas',amount:'87,270',profession:'Construction Managers'},
    {state:'Kentucky',amount:'89,990',profession:'Construction Managers'},
    {state:'Louisiana',amount:'99,610',profession:'Construction Managers'},
    {state:'Maine',amount:'84,410',profession:'Construction Managers'},
    {state:'Maryland',amount:'106,050',profession:'Construction Managers'},
    {state:'Massachusetts',amount:'109,130',profession:'Construction Managers'},
    {state:'Michigan',amount:'101,810',profession:'Construction Managers'},
    {state:'Minnesota',amount:'93,230',profession:'Construction Managers'},
    {state:'Mississippi',amount:'79,380',profession:'Construction Managers'},
    {state:'Missouri',amount:'96,680',profession:'Construction Managers'},
    {state:'Montana',amount:'96,000',profession:'Construction Managers'},
    {state:'Nebraska',amount:'93,080',profession:'Construction Managers'},
    {state:'Nevada',amount:'94,350',profession:'Construction Managers'},
    {state:'New Hampshire',amount:'91,490',profession:'Construction Managers'},
    {state:'New Jersey',amount:'145,400',profession:'Construction Managers'},
    {state:'New Mexico',amount:'89,410',profession:'Construction Managers'},
    {state:'New York',amount:'131,950',profession:'Construction Managers'},
    {state:'North Carolina',amount:'109,520',profession:'Construction Managers'},
    {state:'North Dakota',amount:'109,640',profession:'Construction Managers'},
    {state:'Ohio',amount:'103,700',profession:'Construction Managers'},
    {state:'Oklahoma',amount:'85,950',profession:'Construction Managers'},
    {state:'Oregon',amount:'98,110',profession:'Construction Managers'},
    {state:'Pennsylvania',amount:'106,270',profession:'Construction Managers'},
    {state:'Rhode Island',amount:'132,750',profession:'Construction Managers'},
    {state:'South Carolina',amount:'100,030',profession:'Construction Managers'},
    {state:'South Dakota',amount:'95,820',profession:'Construction Managers'},
    {state:'Tennessee',amount:'82,870',profession:'Construction Managers'},
    {state:'Texas',amount:'98,420',profession:'Construction Managers'},
    {state:'Utah',amount:'83,990',profession:'Construction Managers'},
    {state:'Vermont',amount:'92,730',profession:'Construction Managers'},
    {state:'Virginia',amount:'109,980',profession:'Construction Managers'},
    {state:'Washington',amount:'100,180',profession:'Construction Managers'},
    {state:'West Virginia',amount:'113,320',profession:'Construction Managers'},
    {state:'Wisconsin',amount:'113,270',profession:'Construction Managers'},
    {state:'Wyoming',amount:'96,050',profession:'Construction Managers'},
    {state:'Guam',amount:'69,590',profession:'Construction Managers'},
    {state:'Puerto Rico',amount:'59,530',profession:'Construction Managers'},
    {state:'Virgin Islands',amount:'83,960',profession:'Construction Managers'},

    // Lawyers
    {state:'Alabama',amount:'117,100',profession:'Lawyers'},
    {state:'Alaska',amount:'121,680',profession:'Lawyers'},
    {state:'Arizona',amount:'145,750',profession:'Lawyers'},
    {state:'Arkansas',amount:'98,780',profession:'Lawyers'},
    {state:'California',amount:'171,550',profession:'Lawyers'},
    {state:'Colorado',amount:'147,560',profession:'Lawyers'},
    {state:'Connecticut',amount:'153,640',profession:'Lawyers'},
    {state:'District of Columbia',amount:'192,530',profession:'Lawyers'},
    {state:'Florida',amount:'128,920',profession:'Lawyers'},
    {state:'Georgia',amount:'128,930',profession:'Lawyers'},
    {state:'Hawaii',amount:'111,290',profession:'Lawyers'},
    {state:'Idaho',amount:'99,360',profession:'Lawyers'},
    {state:'Illinois',amount:'152,980',profession:'Lawyers'},
    {state:'Indiana',amount:'113,360',profession:'Lawyers'},
    {state:'Iowa',amount:'112,630',profession:'Lawyers'},
    {state:'Kansas',amount:'109,020',profession:'Lawyers'},
    {state:'Kentucky',amount:'100,100',profession:'Lawyers'},
    {state:'Louisiana',amount:'105,490',profession:'Lawyers'},
    {state:'Maine',amount:'107,120',profession:'Lawyers'},
    {state:'Maryland',amount:'128,340',profession:'Lawyers'},
    {state:'Massachusetts',amount:'165,610',profession:'Lawyers'},
    {state:'Michigan',amount:'110,180',profession:'Lawyers'},
    {state:'Minnesota',amount:'119,330',profession:'Lawyers'},
    {state:'Mississippi',amount:'97,990',profession:'Lawyers'},
    {state:'Missouri',amount:'113,780',profession:'Lawyers'},
    {state:'Montana',amount:'88,600',profession:'Lawyers'},
    {state:'Nebraska',amount:'108,170',profession:'Lawyers'},
    {state:'Nevada',amount:'138,920',profession:'Lawyers'},
    {state:'New Hampshire',amount:'125,890',profession:'Lawyers'},
    {state:'New Jersey',amount:'139,020',profession:'Lawyers'},
    {state:'New Mexico',amount:'105,910',profession:'Lawyers'},
    {state:'New York',amount:'167,110',profession:'Lawyers'},
    {state:'North Carolina',amount:'129,990',profession:'Lawyers'},
    {state:'North Dakota',amount:'107,290',profession:'Lawyers'},
    {state:'Ohio',amount:'121,520',profession:'Lawyers'},
    {state:'Oklahoma',amount:'118,790',profession:'Lawyers'},
    {state:'Oregon',amount:'119,500',profession:'Lawyers'},
    {state:'Pennsylvania',amount:'138,610',profession:'Lawyers'},
    {state:'Rhode Island',amount:'125,330',profession:'Lawyers'},
    {state:'South Carolina',amount:'105,320',profession:'Lawyers'},
    {state:'South Dakota',amount:'109,070',profession:'Lawyers'},
    {state:'Tennessee',amount:'124,470',profession:'Lawyers'},
    {state:'Texas',amount:'150,250',profession:'Lawyers'},
    {state:'Utah',amount:'112,380',profession:'Lawyers'},
    {state:'Vermont',amount:'107,490',profession:'Lawyers'},
    {state:'Virginia',amount:'139,180',profession:'Lawyers'},
    {state:'Washington',amount:'136,480',profession:'Lawyers'},
    {state:'West Virginia',amount:'98,630',profession:'Lawyers'},
    {state:'Wisconsin',amount:'130,450',profession:'Lawyers'},
    {state:'Wyoming',amount:'105,600',profession:'Lawyers'},
    {state:'Guam',amount:'100,090',profession:'Lawyers'},
    {state:'Puerto Rico',amount:'74,690',profession:'Lawyers'},
    {state:'Virgin Islands',amount:'129,130',profession:'Lawyers'},
    
    // Mechanical Engineers
    {state:'Alabama',amount:'90,030',profession:'Mechanical Engineers'},
    {state:'Alaska',amount:'128,690',profession:'Mechanical Engineers'},
    {state:'Arizona',amount:'98,390',profession:'Mechanical Engineers'},
    {state:'Arkansas',amount:'71,730',profession:'Mechanical Engineers'},
    {state:'California',amount:'107,370',profession:'Mechanical Engineers'},
    {state:'Colorado',amount:'104,220',profession:'Mechanical Engineers'},
    {state:'Connecticut',amount:'94,270',profession:'Mechanical Engineers'},
    {state:'Delaware',amount:'106,220',profession:'Mechanical Engineers'},
    {state:'District of Columbia',amount:'112,780',profession:'Mechanical Engineers'},
    {state:'Florida',amount:'87,770',profession:'Mechanical Engineers'},
    {state:'Georgia',amount:'84,870',profession:'Mechanical Engineers'},
    {state:'Hawaii',amount:'81,730',profession:'Mechanical Engineers'},
    {state:'Idaho',amount:'86,010',profession:'Mechanical Engineers'},
    {state:'Illinois',amount:'92,030',profession:'Mechanical Engineers'},
    {state:'Indiana',amount:'82,510',profession:'Mechanical Engineers'},
    {state:'Iowa',amount:'80,530',profession:'Mechanical Engineers'},
    {state:'Kansas',amount:'82,210',profession:'Mechanical Engineers'},
    {state:'Kentucky',amount:'84,380',profession:'Mechanical Engineers'},
    {state:'Louisiana',amount:'101,810',profession:'Mechanical Engineers'},
    {state:'Maine',amount:'93,310',profession:'Mechanical Engineers'},
    {state:'Maryland',amount:'109,960',profession:'Mechanical Engineers'},
    {state:'Massachusetts',amount:'98,190',profession:'Mechanical Engineers'},
    {state:'Michigan',amount:'91,100',profession:'Mechanical Engineers'},
    {state:'Minnesota',amount:'87,030',profession:'Mechanical Engineers'},
    {state:'Mississippi',amount:'85,570',profession:'Mechanical Engineers'},
    {state:'Missouri',amount:'85,450',profession:'Mechanical Engineers'},
    {state:'Montana',amount:'77,140',profession:'Mechanical Engineers'},
    {state:'Nebraska',amount:'80,650',profession:'Mechanical Engineers'},
    {state:'Nevada',amount:'88,950',profession:'Mechanical Engineers'},
    {state:'New Hampshire',amount:'97,270',profession:'Mechanical Engineers'},
    {state:'New Jersey',amount:'95,680',profession:'Mechanical Engineers'},
    {state:'New Mexico',amount:'110,210',profession:'Mechanical Engineers'},
    {state:'New York',amount:'91,820',profession:'Mechanical Engineers'},
    {state:'North Carolina',amount:'87,470',profession:'Mechanical Engineers'},
    {state:'North Dakota',amount:'75,770',profession:'Mechanical Engineers'},
    {state:'Ohio',amount:'81,020',profession:'Mechanical Engineers'},
    {state:'Oklahoma',amount:'88,190',profession:'Mechanical Engineers'},
    {state:'Oregon',amount:'85,890',profession:'Mechanical Engineers'},
    {state:'Pennsylvania',amount:'85,740',profession:'Mechanical Engineers'},
    {state:'Rhode Island',amount:'94,520',profession:'Mechanical Engineers'},
    {state:'South Carolina',amount:'93,730',profession:'Mechanical Engineers'},
    {state:'South Dakota',amount:'76,220',profession:'Mechanical Engineers'},
    {state:'Tennessee',amount:'87,990',profession:'Mechanical Engineers'},
    {state:'Texas',amount:'105,570',profession:'Mechanical Engineers'},
    {state:'Utah',amount:'88,150',profession:'Mechanical Engineers'},
    {state:'Vermont',amount:'94,580',profession:'Mechanical Engineers'},
    {state:'Virginia',amount:'100,540',profession:'Mechanical Engineers'},
    {state:'Washington',amount:'96,860',profession:'Mechanical Engineers'},
    {state:'West Virginia',amount:'84,070',profession:'Mechanical Engineers'},
    {state:'Wisconsin',amount:'79,360',profession:'Mechanical Engineers'},
    {state:'Wyoming',amount:'84,200',profession:'Mechanical Engineers'},
    {state:'Guam',amount:'60,280',profession:'Mechanical Engineers'},
    {state:'Puerto Rico',amount:'58,020',profession:'Mechanical Engineers'},
    
    // Information Security Analysts
    {state:'Alabama',amount:'92,500',profession:'Information Security Analysts'},
    {state:'Alaska',amount:'105,280',profession:'Information Security Analysts'},
    {state:'Arizona',amount:'93,960',profession:'Information Security Analysts'},
    {state:'Arkansas',amount:'81,710',profession:'Information Security Analysts'},
    {state:'California',amount:'110,340',profession:'Information Security Analysts'},
    {state:'Colorado',amount:'102,820',profession:'Information Security Analysts'},
    {state:'Connecticut',amount:'112,900',profession:'Information Security Analysts'},
    {state:'Delaware',amount:'106,780',profession:'Information Security Analysts'},
    {state:'District of Columbia',amount:'118,080',profession:'Information Security Analysts'},
    {state:'Florida',amount:'91,950',profession:'Information Security Analysts'},
    {state:'Georgia',amount:'94,490',profession:'Information Security Analysts'},
    {state:'Hawaii',amount:'91,520',profession:'Information Security Analysts'},
    {state:'Idaho',amount:'86,590',profession:'Information Security Analysts'},
    {state:'Illinois',amount:'98,640',profession:'Information Security Analysts'},
    {state:'Indiana',amount:'80,080',profession:'Information Security Analysts'},
    {state:'Iowa',amount:'83,030',profession:'Information Security Analysts'},
    {state:'Kansas',amount:'86,160',profession:'Information Security Analysts'},
    {state:'Kentucky',amount:'83,890',profession:'Information Security Analysts'},
    {state:'Louisiana',amount:'74,350',profession:'Information Security Analysts'},
    {state:'Maine',amount:'82,270',profession:'Information Security Analysts'},
    {state:'Maryland',amount:'107,960',profession:'Information Security Analysts'},
    {state:'Massachusetts',amount:'108,400',profession:'Information Security Analysts'},
    {state:'Michigan',amount:'93,850',profession:'Information Security Analysts'},
    {state:'Minnesota',amount:'97,040',profession:'Information Security Analysts'},
    {state:'Mississippi',amount:'73,550',profession:'Information Security Analysts'},
    {state:'Missouri',amount:'91,210',profession:'Information Security Analysts'},
    {state:'Montana',amount:'64,790',profession:'Information Security Analysts'},
    {state:'Nebraska',amount:'84,540',profession:'Information Security Analysts'},
    {state:'Nevada',amount:'89,530',profession:'Information Security Analysts'},
    {state:'New Hampshire',amount:'100,850',profession:'Information Security Analysts'},
    {state:'New Jersey',amount:'121,600',profession:'Information Security Analysts'},
    {state:'New Mexico',amount:'106,360',profession:'Information Security Analysts'},
    {state:'New York',amount:'122,000',profession:'Information Security Analysts'},
    {state:'North Carolina',amount:'104,430',profession:'Information Security Analysts'},
    {state:'North Dakota',amount:'79,940',profession:'Information Security Analysts'},
    {state:'Ohio',amount:'93,770',profession:'Information Security Analysts'},
    {state:'Oklahoma',amount:'81,900',profession:'Information Security Analysts'},
    {state:'Oregon',amount:'92,620',profession:'Information Security Analysts'},
    {state:'Pennsylvania',amount:'97,620',profession:'Information Security Analysts'},
    {state:'Rhode Island',amount:'109,580',profession:'Information Security Analysts'},
    {state:'South Carolina',amount:'75,770',profession:'Information Security Analysts'},
    {state:'South Dakota',amount:'91,630',profession:'Information Security Analysts'},
    {state:'Tennessee',amount:'82,160',profession:'Information Security Analysts'},
    {state:'Texas',amount:'104,170',profession:'Information Security Analysts'},
    {state:'Utah',amount:'86,790',profession:'Information Security Analysts'},
    {state:'Vermont',amount:'84,680',profession:'Information Security Analysts'},
    {state:'Virginia',amount:'111,780',profession:'Information Security Analysts'},
    {state:'Washington',amount:'107,800',profession:'Information Security Analysts'},
    {state:'West Virginia',amount:'84,620',profession:'Information Security Analysts'},
    {state:'Wisconsin',amount:'81,050',profession:'Information Security Analysts'},
    {state:'Wyoming',amount:'73,280',profession:'Information Security Analysts'},
    {state:'Puerto Rico',amount:'42,440',profession:'Information Security Analysts'},
    
    // Psychologists, All Other
    {state:'Alabama',amount:'90,050',profession:'Psychologists, All Other'},
    {state:'Arizona',amount:'87,600',profession:'Psychologists, All Other'},
    {state:'Arkansas',amount:'83,030',profession:'Psychologists, All Other'},
    {state:'California',amount:'114,860',profession:'Psychologists, All Other'},
    {state:'Colorado',amount:'83,630',profession:'Psychologists, All Other'},
    {state:'Connecticut',amount:'96,180',profession:'Psychologists, All Other'},
    {state:'District of Columbia',amount:'95,380',profession:'Psychologists, All Other'},
    {state:'Florida',amount:'96,640',profession:'Psychologists, All Other'},
    {state:'Georgia',amount:'95,940',profession:'Psychologists, All Other'},
    {state:'Hawaii',amount:'94,260',profession:'Psychologists, All Other'},
    {state:'Idaho',amount:'87,410',profession:'Psychologists, All Other'},
    {state:'Illinois',amount:'87,410',profession:'Psychologists, All Other'},
    {state:'Indiana',amount:'88,470',profession:'Psychologists, All Other'},
    {state:'Kansas',amount:'102,910',profession:'Psychologists, All Other'},
    {state:'Kentucky',amount:'91,020',profession:'Psychologists, All Other'},
    {state:'Louisiana',amount:'76,510',profession:'Psychologists, All Other'},
    {state:'Maine',amount:'82,790',profession:'Psychologists, All Other'},
    {state:'Maryland',amount:'112,330',profession:'Psychologists, All Other'},
    {state:'Massachusetts',amount:'83,550',profession:'Psychologists, All Other'},
    {state:'Michigan',amount:'88,120',profession:'Psychologists, All Other'},
    {state:'Minnesota',amount:'93,310',profession:'Psychologists, All Other'},
    {state:'Mississippi',amount:'81,610',profession:'Psychologists, All Other'},
    {state:'Missouri',amount:'86,730',profession:'Psychologists, All Other'},
    {state:'Montana',amount:'69,870',profession:'Psychologists, All Other'},
    {state:'Nevada',amount:'74,060',profession:'Psychologists, All Other'},
    {state:'New Hampshire',amount:'98,410',profession:'Psychologists, All Other'},
    {state:'New Mexico',amount:'84,080',profession:'Psychologists, All Other'},
    {state:'New York',amount:'99,640',profession:'Psychologists, All Other'},
    {state:'Ohio',amount:'92,900',profession:'Psychologists, All Other'},
    {state:'Oklahoma',amount:'89,300',profession:'Psychologists, All Other'},
    {state:'Pennsylvania',amount:'87,940',profession:'Psychologists, All Other'},
    {state:'Rhode Island',amount:'73,080',profession:'Psychologists, All Other'},
    {state:'South Carolina',amount:'92,560',profession:'Psychologists, All Other'},
    {state:'South Dakota',amount:'84,200',profession:'Psychologists, All Other'},
    {state:'Tennessee',amount:'87,260',profession:'Psychologists, All Other'},
    {state:'Texas',amount:'90,780',profession:'Psychologists, All Other'},
    {state:'Utah',amount:'86,340',profession:'Psychologists, All Other'},
    {state:'Virginia',amount:'97,200',profession:'Psychologists, All Other'},
    {state:'Washington',amount:'102,760',profession:'Psychologists, All Other'},
    {state:'West Virginia',amount:'82,970',profession:'Psychologists, All Other'},
    {state:'Wisconsin',amount:'80,620',profession:'Psychologists, All Other'},
    {state:'Puerto Rico',amount:'77,880',profession:'Psychologists, All Other'},
    {state:'West Virginia',amount:'130',profession:'Psychologists, All Other'},
    {state:'Wisconsin',amount:'190',profession:'Psychologists, All Other'},
    {state:'Puerto Rico',amount:'100',profession:'Psychologists, All Other'},
    
    // Landscaping and Groundskeeping Workers
    {state:'Alabama',amount:'26,340',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Alaska',amount:'39,050',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Arizona',amount:'28,730',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Arkansas',amount:'25,500',profession:'Landscaping and Groundskeeping Workers'},
    {state:'California',amount:'34,510',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Colorado',amount:'33,940',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Connecticut',amount:'36,700',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Delaware',amount:'30,690',profession:'Landscaping and Groundskeeping Workers'},
    {state:'District of Columbia',amount:'37,190',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Florida',amount:'27,610',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Georgia',amount:'28,900',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Hawaii',amount:'34,070',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Idaho',amount:'29,070',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Illinois',amount:'31,740',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Indiana',amount:'27,820',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Iowa',amount:'29,760',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Kansas',amount:'30,320',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Kentucky',amount:'28,010',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Louisiana',amount:'26,040',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Maine',amount:'31,990',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Maryland',amount:'32,870',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Massachusetts',amount:'38,090',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Michigan',amount:'29,670',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Minnesota',amount:'35,970',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Mississippi',amount:'25,920',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Missouri',amount:'31,400',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Montana',amount:'30,560',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Nebraska',amount:'30,690',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Nevada',amount:'29,850',profession:'Landscaping and Groundskeeping Workers'},
    {state:'New Hampshire',amount:'32,230',profession:'Landscaping and Groundskeeping Workers'},
    {state:'New Jersey',amount:'32,700',profession:'Landscaping and Groundskeeping Workers'},
    {state:'New Mexico',amount:'27,930',profession:'Landscaping and Groundskeeping Workers'},
    {state:'New York',amount:'34,820',profession:'Landscaping and Groundskeeping Workers'},
    {state:'North Carolina',amount:'28,130',profession:'Landscaping and Groundskeeping Workers'},
    {state:'North Dakota',amount:'33,680',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Ohio',amount:'29,070',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Oklahoma',amount:'26,990',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Oregon',amount:'33,620',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Pennsylvania',amount:'30,120',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Rhode Island',amount:'33,850',profession:'Landscaping and Groundskeeping Workers'},
    {state:'South Carolina',amount:'27,400',profession:'Landscaping and Groundskeeping Workers'},
    {state:'South Dakota',amount:'27,720',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Tennessee',amount:'27,030',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Texas',amount:'28,170',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Utah',amount:'29,510',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Vermont',amount:'33,740',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Virginia',amount:'30,000',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Washington',amount:'36,910',profession:'Landscaping and Groundskeeping Workers'},
    {state:'West Virginia',amount:'25,030',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Wisconsin',amount:'31,800',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Wyoming',amount:'32,880',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Guam',amount:'21,540',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Puerto Rico',amount:'21,040',profession:'Landscaping and Groundskeeping Workers'},
    {state:'Virgin Islands',amount:'28,480',profession:'Landscaping and Groundskeeping Workers'},
    
    // Business Operations Specialists, All Other
    {state:'Alabama',amount:'85,140',profession:'Business Operations Specialists, All Other'},
    {state:'Alaska',amount:'82,160',profession:'Business Operations Specialists, All Other'},
    {state:'Arizona',amount:'67,670',profession:'Business Operations Specialists, All Other'},
    {state:'Arkansas',amount:'59,530',profession:'Business Operations Specialists, All Other'},
    {state:'California',amount:'83,470',profession:'Business Operations Specialists, All Other'},
    {state:'Colorado',amount:'82,130',profession:'Business Operations Specialists, All Other'},
    {state:'Connecticut',amount:'78,120',profession:'Business Operations Specialists, All Other'},
    {state:'Delaware',amount:'81,880',profession:'Business Operations Specialists, All Other'},
    {state:'District of Columbia',amount:'102,730',profession:'Business Operations Specialists, All Other'},
    {state:'Florida',amount:'66,440',profession:'Business Operations Specialists, All Other'},
    {state:'Georgia',amount:'75,070',profession:'Business Operations Specialists, All Other'},
    {state:'Hawaii',amount:'73,310',profession:'Business Operations Specialists, All Other'},
    {state:'Idaho',amount:'67,630',profession:'Business Operations Specialists, All Other'},
    {state:'Illinois',amount:'71,780',profession:'Business Operations Specialists, All Other'},
    {state:'Indiana',amount:'61,290',profession:'Business Operations Specialists, All Other'},
    {state:'Iowa',amount:'65,020',profession:'Business Operations Specialists, All Other'},
    {state:'Kansas',amount:'74,520',profession:'Business Operations Specialists, All Other'},
    {state:'Kentucky',amount:'66,450',profession:'Business Operations Specialists, All Other'},
    {state:'Louisiana',amount:'60,430',profession:'Business Operations Specialists, All Other'},
    {state:'Maine',amount:'66,760',profession:'Business Operations Specialists, All Other'},
    {state:'Maryland',amount:'91,400',profession:'Business Operations Specialists, All Other'},
    {state:'Massachusetts',amount:'85,980',profession:'Business Operations Specialists, All Other'},
    {state:'Michigan',amount:'70,410',profession:'Business Operations Specialists, All Other'},
    {state:'Minnesota',amount:'71,220',profession:'Business Operations Specialists, All Other'},
    {state:'Mississippi',amount:'65,650',profession:'Business Operations Specialists, All Other'},
    {state:'Missouri',amount:'73,500',profession:'Business Operations Specialists, All Other'},
    {state:'Montana',amount:'66,290',profession:'Business Operations Specialists, All Other'},
    {state:'Nebraska',amount:'74,370',profession:'Business Operations Specialists, All Other'},
    {state:'Nevada',amount:'71,580',profession:'Business Operations Specialists, All Other'},
    {state:'New Hampshire',amount:'70,890',profession:'Business Operations Specialists, All Other'},
    {state:'New Jersey',amount:'78,920',profession:'Business Operations Specialists, All Other'},
    {state:'New Mexico',amount:'70,340',profession:'Business Operations Specialists, All Other'},
    {state:'New York',amount:'83,330',profession:'Business Operations Specialists, All Other'},
    {state:'North Carolina',amount:'74,040',profession:'Business Operations Specialists, All Other'},
    {state:'North Dakota',amount:'73,010',profession:'Business Operations Specialists, All Other'},
    {state:'Ohio',amount:'71,190',profession:'Business Operations Specialists, All Other'},
    {state:'Oklahoma',amount:'72,940',profession:'Business Operations Specialists, All Other'},
    {state:'Oregon',amount:'68,890',profession:'Business Operations Specialists, All Other'},
    {state:'Pennsylvania',amount:'80,910',profession:'Business Operations Specialists, All Other'},
    {state:'Rhode Island',amount:'80,380',profession:'Business Operations Specialists, All Other'},
    {state:'South Carolina',amount:'69,340',profession:'Business Operations Specialists, All Other'},
    {state:'South Dakota',amount:'70,830',profession:'Business Operations Specialists, All Other'},
    {state:'Tennessee',amount:'62,330',profession:'Business Operations Specialists, All Other'},
    {state:'Texas',amount:'80,140',profession:'Business Operations Specialists, All Other'},
    {state:'Utah',amount:'72,100',profession:'Business Operations Specialists, All Other'},
    {state:'Vermont',amount:'67,910',profession:'Business Operations Specialists, All Other'},
    {state:'Virginia',amount:'88,180',profession:'Business Operations Specialists, All Other'},
    {state:'Washington',amount:'77,850',profession:'Business Operations Specialists, All Other'},
    {state:'West Virginia',amount:'70,180',profession:'Business Operations Specialists, All Other'},
    {state:'Wisconsin',amount:'57,620',profession:'Business Operations Specialists, All Other'},
    {state:'Wyoming',amount:'69,740',profession:'Business Operations Specialists, All Other'},
    {state:'Guam',amount:'68,670',profession:'Business Operations Specialists, All Other'},
    {state:'Puerto Rico',amount:'40,850',profession:'Business Operations Specialists, All Other'},
    {state:'Virgin Islands',amount:'54,800',profession:'Business Operations Specialists, All Other'},
    
    // Civil Engineers
    {state:'Alabama',amount:'84,320',profession:'Civil Engineers'},
    {state:'Alaska',amount:'125,470',profession:'Civil Engineers'},
    {state:'Arizona',amount:'84,770',profession:'Civil Engineers'},
    {state:'Arkansas',amount:'81,780',profession:'Civil Engineers'},
    {state:'California',amount:'109,680',profession:'Civil Engineers'},
    {state:'Colorado',amount:'93,560',profession:'Civil Engineers'},
    {state:'Connecticut',amount:'93,630',profession:'Civil Engineers'},
    {state:'Delaware',amount:'91,410',profession:'Civil Engineers'},
    {state:'District of Columbia',amount:'99,820',profession:'Civil Engineers'},
    {state:'Florida',amount:'89,480',profession:'Civil Engineers'},
    {state:'Georgia',amount:'81,110',profession:'Civil Engineers'},
    {state:'Hawaii',amount:'86,680',profession:'Civil Engineers'},
    {state:'Idaho',amount:'78,280',profession:'Civil Engineers'},
    {state:'Illinois',amount:'94,570',profession:'Civil Engineers'},
    {state:'Indiana',amount:'82,420',profession:'Civil Engineers'},
    {state:'Iowa',amount:'83,940',profession:'Civil Engineers'},
    {state:'Kansas',amount:'82,340',profession:'Civil Engineers'},
    {state:'Kentucky',amount:'82,840',profession:'Civil Engineers'},
    {state:'Louisiana',amount:'98,700',profession:'Civil Engineers'},
    {state:'Maine',amount:'82,160',profession:'Civil Engineers'},
    {state:'Maryland',amount:'86,110',profession:'Civil Engineers'},
    {state:'Massachusetts',amount:'94,210',profession:'Civil Engineers'},
    {state:'Michigan',amount:'82,240',profession:'Civil Engineers'},
    {state:'Minnesota',amount:'90,760',profession:'Civil Engineers'},
    {state:'Mississippi',amount:'85,880',profession:'Civil Engineers'},
    {state:'Missouri',amount:'86,710',profession:'Civil Engineers'},
    {state:'Montana',amount:'77,480',profession:'Civil Engineers'},
    {state:'Nebraska',amount:'84,240',profession:'Civil Engineers'},
    {state:'Nevada',amount:'100,700',profession:'Civil Engineers'},
    {state:'New Hampshire',amount:'83,970',profession:'Civil Engineers'},
    {state:'New Jersey',amount:'103,760',profession:'Civil Engineers'},
    {state:'New Mexico',amount:'88,840',profession:'Civil Engineers'},
    {state:'New York',amount:'102,250',profession:'Civil Engineers'},
    {state:'North Carolina',amount:'86,270',profession:'Civil Engineers'},
    {state:'North Dakota',amount:'83,460',profession:'Civil Engineers'},
    {state:'Ohio',amount:'82,180',profession:'Civil Engineers'},
    {state:'Oklahoma',amount:'91,090',profession:'Civil Engineers'},
    {state:'Oregon',amount:'88,270',profession:'Civil Engineers'},
    {state:'Pennsylvania',amount:'88,740',profession:'Civil Engineers'},
    {state:'Rhode Island',amount:'87,220',profession:'Civil Engineers'},
    {state:'South Carolina',amount:'84,660',profession:'Civil Engineers'},
    {state:'South Dakota',amount:'77,030',profession:'Civil Engineers'},
    {state:'Tennessee',amount:'93,810',profession:'Civil Engineers'},
    {state:'Texas',amount:'102,990',profession:'Civil Engineers'},
    {state:'Utah',amount:'80,690',profession:'Civil Engineers'},
    {state:'Vermont',amount:'74,960',profession:'Civil Engineers'},
    {state:'Virginia',amount:'94,780',profession:'Civil Engineers'},
    {state:'Washington',amount:'93,120',profession:'Civil Engineers'},
    {state:'West Virginia',amount:'82,210',profession:'Civil Engineers'},
    {state:'Wisconsin',amount:'78,660',profession:'Civil Engineers'},
    {state:'Wyoming',amount:'85,220',profession:'Civil Engineers'},
    {state:'Guam',amount:'65,070',profession:'Civil Engineers'},
    {state:'Puerto Rico',amount:'55,500',profession:'Civil Engineers'},
    {state:'Virgin Islands',amount:'62,320',profession:'Civil Engineers'},
    
    // Diagnostic Medical Sonographers
    {state:'Alabama',amount:'56,450',profession:'Diagnostic Medical Sonographers'},
    {state:'Alaska',amount:'93,740',profession:'Diagnostic Medical Sonographers'},
    {state:'Arizona',amount:'83,320',profession:'Diagnostic Medical Sonographers'},
    {state:'Arkansas',amount:'63,140',profession:'Diagnostic Medical Sonographers'},
    {state:'California',amount:'92,660',profession:'Diagnostic Medical Sonographers'},
    {state:'Colorado',amount:'83,430',profession:'Diagnostic Medical Sonographers'},
    {state:'Connecticut',amount:'82,370',profession:'Diagnostic Medical Sonographers'},
    {state:'Delaware',amount:'72,230',profession:'Diagnostic Medical Sonographers'},
    {state:'District of Columbia',amount:'90,860',profession:'Diagnostic Medical Sonographers'},
    {state:'Florida',amount:'65,830',profession:'Diagnostic Medical Sonographers'},
    {state:'Georgia',amount:'61,960',profession:'Diagnostic Medical Sonographers'},
    {state:'Hawaii',amount:'94,350',profession:'Diagnostic Medical Sonographers'},
    {state:'Idaho',amount:'80,330',profession:'Diagnostic Medical Sonographers'},
    {state:'Illinois',amount:'76,700',profession:'Diagnostic Medical Sonographers'},
    {state:'Indiana',amount:'68,970',profession:'Diagnostic Medical Sonographers'},
    {state:'Iowa',amount:'68,960',profession:'Diagnostic Medical Sonographers'},
    {state:'Kansas',amount:'72,020',profession:'Diagnostic Medical Sonographers'},
    {state:'Kentucky',amount:'65,790',profession:'Diagnostic Medical Sonographers'},
    {state:'Louisiana',amount:'60,360',profession:'Diagnostic Medical Sonographers'},
    {state:'Maine',amount:'78,220',profession:'Diagnostic Medical Sonographers'},
    {state:'Maryland',amount:'75,270',profession:'Diagnostic Medical Sonographers'},
    {state:'Massachusetts',amount:'83,780',profession:'Diagnostic Medical Sonographers'},
    {state:'Michigan',amount:'61,130',profession:'Diagnostic Medical Sonographers'},
    {state:'Minnesota',amount:'80,390',profession:'Diagnostic Medical Sonographers'},
    {state:'Mississippi',amount:'61,200',profession:'Diagnostic Medical Sonographers'},
    {state:'Missouri',amount:'73,920',profession:'Diagnostic Medical Sonographers'},
    {state:'Montana',amount:'76,700',profession:'Diagnostic Medical Sonographers'},
    {state:'Nebraska',amount:'64,200',profession:'Diagnostic Medical Sonographers'},
    {state:'Nevada',amount:'76,220',profession:'Diagnostic Medical Sonographers'},
    {state:'New Hampshire',amount:'79,680',profession:'Diagnostic Medical Sonographers'},
    {state:'New Jersey',amount:'77,110',profession:'Diagnostic Medical Sonographers'},
    {state:'New Mexico',amount:'63,840',profession:'Diagnostic Medical Sonographers'},
    {state:'New York',amount:'74,960',profession:'Diagnostic Medical Sonographers'},
    {state:'North Carolina',amount:'66,850',profession:'Diagnostic Medical Sonographers'},
    {state:'North Dakota',amount:'70,950',profession:'Diagnostic Medical Sonographers'},
    {state:'Ohio',amount:'65,840',profession:'Diagnostic Medical Sonographers'},
    {state:'Oklahoma',amount:'68,900',profession:'Diagnostic Medical Sonographers'},
    {state:'Oregon',amount:'86,380',profession:'Diagnostic Medical Sonographers'},
    {state:'Pennsylvania',amount:'66,470',profession:'Diagnostic Medical Sonographers'},
    {state:'Rhode Island',amount:'84,990',profession:'Diagnostic Medical Sonographers'},
    {state:'South Carolina',amount:'65,870',profession:'Diagnostic Medical Sonographers'},
    {state:'South Dakota',amount:'60,500',profession:'Diagnostic Medical Sonographers'},
    {state:'Tennessee',amount:'64,080',profession:'Diagnostic Medical Sonographers'},
    {state:'Texas',amount:'71,580',profession:'Diagnostic Medical Sonographers'},
    {state:'Utah',amount:'75,070',profession:'Diagnostic Medical Sonographers'},
    {state:'Vermont',amount:'78,210',profession:'Diagnostic Medical Sonographers'},
    {state:'Virginia',amount:'74,390',profession:'Diagnostic Medical Sonographers'},
    {state:'Washington',amount:'87,960',profession:'Diagnostic Medical Sonographers'},
    {state:'West Virginia',amount:'61,740',profession:'Diagnostic Medical Sonographers'},
    {state:'Wisconsin',amount:'83,670',profession:'Diagnostic Medical Sonographers'},
    {state:'Wyoming',amount:'66,090',profession:'Diagnostic Medical Sonographers'},
    {state:'Puerto Rico',amount:'25,220',profession:'Diagnostic Medical Sonographers'},

    // Operations Research Analysts
    {state:'Alabama',amount:'89,380',profession:'Operations Research Analysts'},
    {state:'Alaska',amount:'72,130',profession:'Operations Research Analysts'},
    {state:'Arizona',amount:'76,760',profession:'Operations Research Analysts'},
    {state:'Arkansas',amount:'61,360',profession:'Operations Research Analysts'},
    {state:'California',amount:'95,470',profession:'Operations Research Analysts'},
    {state:'Colorado',amount:'90,270',profession:'Operations Research Analysts'},
    {state:'Connecticut',amount:'90,230',profession:'Operations Research Analysts'},
    {state:'Delaware',amount:'86,690',profession:'Operations Research Analysts'},
    {state:'District of Columbia',amount:'109,400',profession:'Operations Research Analysts'},
    {state:'Florida',amount:'73,710',profession:'Operations Research Analysts'},
    {state:'Georgia',amount:'69,370',profession:'Operations Research Analysts'},
    {state:'Hawaii',amount:'102,270',profession:'Operations Research Analysts'},
    {state:'Idaho',amount:'74,090',profession:'Operations Research Analysts'},
    {state:'Illinois',amount:'96,630',profession:'Operations Research Analysts'},
    {state:'Indiana',amount:'68,560',profession:'Operations Research Analysts'},
    {state:'Iowa',amount:'81,990',profession:'Operations Research Analysts'},
    {state:'Kansas',amount:'85,050',profession:'Operations Research Analysts'},
    {state:'Kentucky',amount:'70,010',profession:'Operations Research Analysts'},
    {state:'Louisiana',amount:'60,440',profession:'Operations Research Analysts'},
    {state:'Maine',amount:'77,750',profession:'Operations Research Analysts'},
    {state:'Maryland',amount:'99,870',profession:'Operations Research Analysts'},
    {state:'Massachusetts',amount:'88,190',profession:'Operations Research Analysts'},
    {state:'Michigan',amount:'88,820',profession:'Operations Research Analysts'},
    {state:'Minnesota',amount:'89,020',profession:'Operations Research Analysts'},
    {state:'Mississippi',amount:'74,690',profession:'Operations Research Analysts'},
    {state:'Missouri',amount:'77,210',profession:'Operations Research Analysts'},
    {state:'Montana',amount:'67,420',profession:'Operations Research Analysts'},
    {state:'Nebraska',amount:'62,030',profession:'Operations Research Analysts'},
    {state:'Nevada',amount:'85,800',profession:'Operations Research Analysts'},
    {state:'New Hampshire',amount:'95,830',profession:'Operations Research Analysts'},
    {state:'New Jersey',amount:'106,820',profession:'Operations Research Analysts'},
    {state:'New Mexico',amount:'86,080',profession:'Operations Research Analysts'},
    {state:'New York',amount:'102,560',profession:'Operations Research Analysts'},
    {state:'North Carolina',amount:'84,860',profession:'Operations Research Analysts'},
    {state:'North Dakota',amount:'64,580',profession:'Operations Research Analysts'},
    {state:'Ohio',amount:'82,810',profession:'Operations Research Analysts'},
    {state:'Oklahoma',amount:'68,090',profession:'Operations Research Analysts'},
    {state:'Oregon',amount:'85,780',profession:'Operations Research Analysts'},
    {state:'Pennsylvania',amount:'87,210',profession:'Operations Research Analysts'},
    {state:'Rhode Island',amount:'92,100',profession:'Operations Research Analysts'},
    {state:'South Carolina',amount:'76,670',profession:'Operations Research Analysts'},
    {state:'Tennessee',amount:'69,480',profession:'Operations Research Analysts'},
    {state:'Texas',amount:'82,660',profession:'Operations Research Analysts'},
    {state:'Utah',amount:'73,200',profession:'Operations Research Analysts'},
    {state:'Vermont',amount:'85,140',profession:'Operations Research Analysts'},
    {state:'Virginia',amount:'104,980',profession:'Operations Research Analysts'},
    {state:'Washington',amount:'93,080',profession:'Operations Research Analysts'},
    {state:'West Virginia',amount:'56,640',profession:'Operations Research Analysts'},
    {state:'Wisconsin',amount:'72,900',profession:'Operations Research Analysts'},
    {state:'Puerto Rico',amount:'71,410',profession:'Operations Research Analysts'},
    
    // Actuaries
    {state:'Alabama',amount:'102,080',profession:'Actuaries'},
    {state:'Arkansas',amount:'87,730',profession:'Actuaries'},
    {state:'California',amount:'120,680',profession:'Actuaries'},
    {state:'Colorado',amount:'119,660',profession:'Actuaries'},
    {state:'Connecticut',amount:'132,910',profession:'Actuaries'},
    {state:'District of Columbia',amount:'129,540',profession:'Actuaries'},
    {state:'Florida',amount:'107,850',profession:'Actuaries'},
    {state:'Georgia',amount:'118,790',profession:'Actuaries'},
    {state:'Idaho',amount:'121,590',profession:'Actuaries'},
    {state:'Illinois',amount:'110,430',profession:'Actuaries'},
    {state:'Indiana',amount:'100,950',profession:'Actuaries'},
    {state:'Iowa',amount:'107,390',profession:'Actuaries'},
    {state:'Kansas',amount:'113,910',profession:'Actuaries'},
    {state:'Maine',amount:'106,660',profession:'Actuaries'},
    {state:'Maryland',amount:'98,500',profession:'Actuaries'},
    {state:'Massachusetts',amount:'114,050',profession:'Actuaries'},
    {state:'Michigan',amount:'95,120',profession:'Actuaries'},
    {state:'Minnesota',amount:'116,150',profession:'Actuaries'},
    {state:'Mississippi',amount:'107,910',profession:'Actuaries'},
    {state:'Missouri',amount:'100,180',profession:'Actuaries'},
    {state:'Nebraska',amount:'106,630',profession:'Actuaries'},
    {state:'Nevada',amount:'86,200',profession:'Actuaries'},
    {state:'New Hampshire',amount:'129,110',profession:'Actuaries'},
    {state:'New Jersey',amount:'111,580',profession:'Actuaries'},
    {state:'New York',amount:'150,950',profession:'Actuaries'},
    {state:'North Carolina',amount:'117,190',profession:'Actuaries'},
    {state:'Ohio',amount:'100,620',profession:'Actuaries'},
    {state:'Oregon',amount:'107,410',profession:'Actuaries'},
    {state:'Pennsylvania',amount:'120,090',profession:'Actuaries'},
    {state:'Rhode Island',amount:'102,730',profession:'Actuaries'},
    {state:'Texas',amount:'107,260',profession:'Actuaries'},
    {state:'Utah',amount:'74,180',profession:'Actuaries'},
    {state:'Vermont',amount:'98,500',profession:'Actuaries'},
    {state:'Washington',amount:'131,330',profession:'Actuaries'},
    {state:'Wisconsin',amount:'106,850',profession:'Actuaries'},
    {state:'Puerto Rico',amount:'59,280',profession:'Actuaries'},
    
    // Physical Therapist Assistants
    {state:'Alabama',amount:'57,410',profession:'Physical Therapist Assistants'},
    {state:'Alaska',amount:'58,950',profession:'Physical Therapist Assistants'},
    {state:'Arizona',amount:'47,050',profession:'Physical Therapist Assistants'},
    {state:'Arkansas',amount:'56,940',profession:'Physical Therapist Assistants'},
    {state:'California',amount:'64,210',profession:'Physical Therapist Assistants'},
    {state:'Colorado',amount:'55,370',profession:'Physical Therapist Assistants'},
    {state:'Connecticut',amount:'65,810',profession:'Physical Therapist Assistants'},
    {state:'Delaware',amount:'56,890',profession:'Physical Therapist Assistants'},
    {state:'District of Columbia',amount:'40,920',profession:'Physical Therapist Assistants'},
    {state:'Florida',amount:'61,650',profession:'Physical Therapist Assistants'},
    {state:'Georgia',amount:'53,840',profession:'Physical Therapist Assistants'},
    {state:'Hawaii',amount:'58,750',profession:'Physical Therapist Assistants'},
    {state:'Idaho',amount:'49,410',profession:'Physical Therapist Assistants'},
    {state:'Illinois',amount:'58,060',profession:'Physical Therapist Assistants'},
    {state:'Indiana',amount:'55,730',profession:'Physical Therapist Assistants'},
    {state:'Iowa',amount:'50,420',profession:'Physical Therapist Assistants'},
    {state:'Kansas',amount:'55,190',profession:'Physical Therapist Assistants'},
    {state:'Kentucky',amount:'54,060',profession:'Physical Therapist Assistants'},
    {state:'Louisiana',amount:'48,300',profession:'Physical Therapist Assistants'},
    {state:'Maine',amount:'52,370',profession:'Physical Therapist Assistants'},
    {state:'Maryland',amount:'54,150',profession:'Physical Therapist Assistants'},
    {state:'Massachusetts',amount:'64,180',profession:'Physical Therapist Assistants'},
    {state:'Michigan',amount:'54,010',profession:'Physical Therapist Assistants'},
    {state:'Minnesota',amount:'53,830',profession:'Physical Therapist Assistants'},
    {state:'Mississippi',amount:'48,130',profession:'Physical Therapist Assistants'},
    {state:'Missouri',amount:'53,150',profession:'Physical Therapist Assistants'},
    {state:'Montana',amount:'46,130',profession:'Physical Therapist Assistants'},
    {state:'Nebraska',amount:'47,240',profession:'Physical Therapist Assistants'},
    {state:'Nevada',amount:'61,000',profession:'Physical Therapist Assistants'},
    {state:'New Hampshire',amount:'58,970',profession:'Physical Therapist Assistants'},
    {state:'New Jersey',amount:'68,000',profession:'Physical Therapist Assistants'},
    {state:'New Mexico',amount:'46,650',profession:'Physical Therapist Assistants'},
    {state:'New York',amount:'52,720',profession:'Physical Therapist Assistants'},
    {state:'North Carolina',amount:'60,190',profession:'Physical Therapist Assistants'},
    {state:'North Dakota',amount:'49,880',profession:'Physical Therapist Assistants'},
    {state:'Ohio',amount:'58,740',profession:'Physical Therapist Assistants'},
    {state:'Oklahoma',amount:'59,950',profession:'Physical Therapist Assistants'},
    {state:'Oregon',amount:'61,990',profession:'Physical Therapist Assistants'},
    {state:'Pennsylvania',amount:'54,100',profession:'Physical Therapist Assistants'},
    {state:'Rhode Island',amount:'63,630',profession:'Physical Therapist Assistants'},
    {state:'South Carolina',amount:'56,880',profession:'Physical Therapist Assistants'},
    {state:'South Dakota',amount:'42,910',profession:'Physical Therapist Assistants'},
    {state:'Tennessee',amount:'56,830',profession:'Physical Therapist Assistants'},
    {state:'Texas',amount:'69,890',profession:'Physical Therapist Assistants'},
    {state:'Utah',amount:'52,830',profession:'Physical Therapist Assistants'},
    {state:'Vermont',amount:'54,610',profession:'Physical Therapist Assistants'},
    {state:'Virginia',amount:'60,110',profession:'Physical Therapist Assistants'},
    {state:'Washington',amount:'58,210',profession:'Physical Therapist Assistants'},
    {state:'West Virginia',amount:'49,830',profession:'Physical Therapist Assistants'},
    {state:'Wisconsin',amount:'52,310',profession:'Physical Therapist Assistants'},
    {state:'Wyoming',amount:'56,520',profession:'Physical Therapist Assistants'},
    {state:'Puerto Rico',amount:'22,850',profession:'Physical Therapist Assistants'},
    
    // Marketing Managers
    {state:'Alabama',amount:'118,200',profession:'Marketing Managers'},
    {state:'Alaska',amount:'101,750',profession:'Marketing Managers'},
    {state:'Arizona',amount:'117,700',profession:'Marketing Managers'},
    {state:'Arkansas',amount:'155,020',profession:'Marketing Managers'},
    {state:'California',amount:'167,910',profession:'Marketing Managers'},
    {state:'Colorado',amount:'169,630',profession:'Marketing Managers'},
    {state:'Connecticut',amount:'154,810',profession:'Marketing Managers'},
    {state:'Delaware',amount:'163,090',profession:'Marketing Managers'},
    {state:'District of Columbia',amount:'165,640',profession:'Marketing Managers'},
    {state:'Florida',amount:'119,450',profession:'Marketing Managers'},
    {state:'Georgia',amount:'143,660',profession:'Marketing Managers'},
    {state:'Hawaii',amount:'112,800',profession:'Marketing Managers'},
    {state:'Idaho',amount:'105,210',profession:'Marketing Managers'},
    {state:'Illinois',amount:'130,110',profession:'Marketing Managers'},
    {state:'Indiana',amount:'108,750',profession:'Marketing Managers'},
    {state:'Iowa',amount:'109,450',profession:'Marketing Managers'},
    {state:'Kansas',amount:'142,740',profession:'Marketing Managers'},
    {state:'Kentucky',amount:'116,140',profession:'Marketing Managers'},
    {state:'Louisiana',amount:'97,540',profession:'Marketing Managers'},
    {state:'Maine',amount:'99,450',profession:'Marketing Managers'},
    {state:'Maryland',amount:'150,830',profession:'Marketing Managers'},
    {state:'Massachusetts',amount:'143,400',profession:'Marketing Managers'},
    {state:'Michigan',amount:'137,900',profession:'Marketing Managers'},
    {state:'Minnesota',amount:'139,440',profession:'Marketing Managers'},
    {state:'Mississippi',amount:'93,930',profession:'Marketing Managers'},
    {state:'Missouri',amount:'128,810',profession:'Marketing Managers'},
    {state:'Montana',amount:'125,860',profession:'Marketing Managers'},
    {state:'Nebraska',amount:'101,520',profession:'Marketing Managers'},
    {state:'Nevada',amount:'142,730',profession:'Marketing Managers'},
    {state:'New Hampshire',amount:'141,630',profession:'Marketing Managers'},
    {state:'New Jersey',amount:'177,330',profession:'Marketing Managers'},
    {state:'New Mexico',amount:'100,320',profession:'Marketing Managers'},
    {state:'New York',amount:'187,860',profession:'Marketing Managers'},
    {state:'North Carolina',amount:'145,180',profession:'Marketing Managers'},
    {state:'North Dakota',amount:'111,880',profession:'Marketing Managers'},
    {state:'Ohio',amount:'133,730',profession:'Marketing Managers'},
    {state:'Oklahoma',amount:'117,940',profession:'Marketing Managers'},
    {state:'Oregon',amount:'116,020',profession:'Marketing Managers'},
    {state:'Pennsylvania',amount:'154,700',profession:'Marketing Managers'},
    {state:'Rhode Island',amount:'159,400',profession:'Marketing Managers'},
    {state:'South Carolina',amount:'111,460',profession:'Marketing Managers'},
    {state:'South Dakota',amount:'145,400',profession:'Marketing Managers'},
    {state:'Tennessee',amount:'118,740',profession:'Marketing Managers'},
    {state:'Texas',amount:'146,640',profession:'Marketing Managers'},
    {state:'Utah',amount:'115,230',profession:'Marketing Managers'},
    {state:'Vermont',amount:'123,910',profession:'Marketing Managers'},
    {state:'Virginia',amount:'171,870',profession:'Marketing Managers'},
    {state:'Washington',amount:'155,580',profession:'Marketing Managers'},
    {state:'West Virginia',amount:'95,380',profession:'Marketing Managers'},
    {state:'Wisconsin',amount:'125,100',profession:'Marketing Managers'},
    {state:'Wyoming',amount:'100,000',profession:'Marketing Managers'},
    {state:'Guam',amount:'60,640',profession:'Marketing Managers'},
    {state:'Puerto Rico',amount:'85,100',profession:'Marketing Managers'},
    {state:'Virgin Islands',amount:'69,330',profession:'Marketing Managers'},
    
    // Dental Hygienists
    {state:'Alabama',amount:'46,500',profession:'Dental Hygienists'},
    {state:'Alaska',amount:'114,320',profession:'Dental Hygienists'},
    {state:'Arizona',amount:'85,890',profession:'Dental Hygienists'},
    {state:'Arkansas',amount:'71,090',profession:'Dental Hygienists'},
    {state:'California',amount:'100,830',profession:'Dental Hygienists'},
    {state:'Colorado',amount:'84,510',profession:'Dental Hygienists'},
    {state:'Connecticut',amount:'83,630',profession:'Dental Hygienists'},
    {state:'Delaware',amount:'78,550',profession:'Dental Hygienists'},
    {state:'District of Columbia',amount:'81,270',profession:'Dental Hygienists'},
    {state:'Florida',amount:'64,070',profession:'Dental Hygienists'},
    {state:'Georgia',amount:'65,650',profession:'Dental Hygienists'},
    {state:'Hawaii',amount:'77,920',profession:'Dental Hygienists'},
    {state:'Idaho',amount:'74,430',profession:'Dental Hygienists'},
    {state:'Illinois',amount:'72,640',profession:'Dental Hygienists'},
    {state:'Indiana',amount:'68,000',profession:'Dental Hygienists'},
    {state:'Iowa',amount:'68,870',profession:'Dental Hygienists'},
    {state:'Kansas',amount:'64,980',profession:'Dental Hygienists'},
    {state:'Kentucky',amount:'59,910',profession:'Dental Hygienists'},
    {state:'Louisiana',amount:'59,810',profession:'Dental Hygienists'},
    {state:'Maine',amount:'65,500',profession:'Dental Hygienists'},
    {state:'Maryland',amount:'85,240',profession:'Dental Hygienists'},
    {state:'Massachusetts',amount:'82,750',profession:'Dental Hygienists'},
    {state:'Michigan',amount:'64,130',profession:'Dental Hygienists'},
    {state:'Minnesota',amount:'74,240',profession:'Dental Hygienists'},
    {state:'Mississippi',amount:'57,860',profession:'Dental Hygienists'},
    {state:'Missouri',amount:'68,820',profession:'Dental Hygienists'},
    {state:'Montana',amount:'74,350',profession:'Dental Hygienists'},
    {state:'Nebraska',amount:'65,870',profession:'Dental Hygienists'},
    {state:'Nevada',amount:'81,270',profession:'Dental Hygienists'},
    {state:'New Hampshire',amount:'79,560',profession:'Dental Hygienists'},
    {state:'New Jersey',amount:'85,860',profession:'Dental Hygienists'},
    {state:'New Mexico',amount:'75,860',profession:'Dental Hygienists'},
    {state:'New York',amount:'76,280',profession:'Dental Hygienists'},
    {state:'North Carolina',amount:'69,500',profession:'Dental Hygienists'},
    {state:'North Dakota',amount:'72,580',profession:'Dental Hygienists'},
    {state:'Ohio',amount:'68,310',profession:'Dental Hygienists'},
    {state:'Oklahoma',amount:'73,990',profession:'Dental Hygienists'},
    {state:'Oregon',amount:'85,280',profession:'Dental Hygienists'},
    {state:'Pennsylvania',amount:'67,010',profession:'Dental Hygienists'},
    {state:'Rhode Island',amount:'74,650',profession:'Dental Hygienists'},
    {state:'South Carolina',amount:'61,440',profession:'Dental Hygienists'},
    {state:'South Dakota',amount:'64,580',profession:'Dental Hygienists'},
    {state:'Tennessee',amount:'66,290',profession:'Dental Hygienists'},
    {state:'Texas',amount:'75,300',profession:'Dental Hygienists'},
    {state:'Utah',amount:'69,490',profession:'Dental Hygienists'},
    {state:'Vermont',amount:'72,490',profession:'Dental Hygienists'},
    {state:'Virginia',amount:'79,640',profession:'Dental Hygienists'},
    {state:'Washington',amount:'90,690',profession:'Dental Hygienists'},
    {state:'West Virginia',amount:'57,740',profession:'Dental Hygienists'},
    {state:'Wisconsin',amount:'65,540',profession:'Dental Hygienists'},
    {state:'Wyoming',amount:'69,620',profession:'Dental Hygienists'},
    {state:'Guam',amount:'58,750',profession:'Dental Hygienists'},
    
    // Medical and Health Services Managers
    {state:'Alabama',amount:'101,560',profession:'Medical and Health Services Managers'},
    {state:'Alaska',amount:'114,670',profession:'Medical and Health Services Managers'},
    {state:'Arizona',amount:'115,770',profession:'Medical and Health Services Managers'},
    {state:'Arkansas',amount:'85,290',profession:'Medical and Health Services Managers'},
    {state:'California',amount:'125,770',profession:'Medical and Health Services Managers'},
    {state:'Colorado',amount:'118,540',profession:'Medical and Health Services Managers'},
    {state:'Connecticut',amount:'129,480',profession:'Medical and Health Services Managers'},
    {state:'Delaware',amount:'131,260',profession:'Medical and Health Services Managers'},
    {state:'District of Columbia',amount:'145,760',profession:'Medical and Health Services Managers'},
    {state:'Florida',amount:'110,750',profession:'Medical and Health Services Managers'},
    {state:'Georgia',amount:'111,850',profession:'Medical and Health Services Managers'},
    {state:'Hawaii',amount:'124,970',profession:'Medical and Health Services Managers'},
    {state:'Idaho',amount:'92,980',profession:'Medical and Health Services Managers'},
    {state:'Illinois',amount:'121,900',profession:'Medical and Health Services Managers'},
    {state:'Indiana',amount:'101,720',profession:'Medical and Health Services Managers'},
    {state:'Iowa',amount:'85,800',profession:'Medical and Health Services Managers'},
    {state:'Kansas',amount:'94,050',profession:'Medical and Health Services Managers'},
    {state:'Kentucky',amount:'91,820',profession:'Medical and Health Services Managers'},
    {state:'Louisiana',amount:'100,710',profession:'Medical and Health Services Managers'},
    {state:'Maine',amount:'93,100',profession:'Medical and Health Services Managers'},
    {state:'Maryland',amount:'127,080',profession:'Medical and Health Services Managers'},
    {state:'Massachusetts',amount:'133,900',profession:'Medical and Health Services Managers'},
    {state:'Michigan',amount:'111,780',profession:'Medical and Health Services Managers'},
    {state:'Minnesota',amount:'110,490',profession:'Medical and Health Services Managers'},
    {state:'Mississippi',amount:'94,800',profession:'Medical and Health Services Managers'},
    {state:'Missouri',amount:'113,120',profession:'Medical and Health Services Managers'},
    {state:'Montana',amount:'96,180',profession:'Medical and Health Services Managers'},
    {state:'Nebraska',amount:'107,250',profession:'Medical and Health Services Managers'},
    {state:'Nevada',amount:'121,120',profession:'Medical and Health Services Managers'},
    {state:'New Hampshire',amount:'113,210',profession:'Medical and Health Services Managers'},
    {state:'New Jersey',amount:'116,750',profession:'Medical and Health Services Managers'},
    {state:'New Mexico',amount:'122,650',profession:'Medical and Health Services Managers'},
    {state:'New York',amount:'143,030',profession:'Medical and Health Services Managers'},
    {state:'North Carolina',amount:'117,650',profession:'Medical and Health Services Managers'},
    {state:'North Dakota',amount:'111,430',profession:'Medical and Health Services Managers'},
    {state:'Ohio',amount:'101,390',profession:'Medical and Health Services Managers'},
    {state:'Oklahoma',amount:'90,680',profession:'Medical and Health Services Managers'},
    {state:'Oregon',amount:'118,730',profession:'Medical and Health Services Managers'},
    {state:'Pennsylvania',amount:'97,310',profession:'Medical and Health Services Managers'},
    {state:'Rhode Island',amount:'128,660',profession:'Medical and Health Services Managers'},
    {state:'South Carolina',amount:'98,780',profession:'Medical and Health Services Managers'},
    {state:'South Dakota',amount:'106,830',profession:'Medical and Health Services Managers'},
    {state:'Tennessee',amount:'101,550',profession:'Medical and Health Services Managers'},
    {state:'Texas',amount:'105,450',profession:'Medical and Health Services Managers'},
    {state:'Utah',amount:'104,770',profession:'Medical and Health Services Managers'},
    {state:'Vermont',amount:'103,030',profession:'Medical and Health Services Managers'},
    {state:'Virginia',amount:'116,770',profession:'Medical and Health Services Managers'},
    {state:'Washington',amount:'117,970',profession:'Medical and Health Services Managers'},
    {state:'West Virginia',amount:'110,130',profession:'Medical and Health Services Managers'},
    {state:'Wisconsin',amount:'107,920',profession:'Medical and Health Services Managers'},
    {state:'Wyoming',amount:'100,720',profession:'Medical and Health Services Managers'},
    {state:'Guam',amount:'87,340',profession:'Medical and Health Services Managers'},
    {state:'Puerto Rico',amount:'76,550',profession:'Medical and Health Services Managers'},
    {state:'Virgin Islands',amount:'97,190',profession:'Medical and Health Services Managers'},
    
    // Computer and Information Systems Managers
    {state:'Alabama',amount:'126,300',profession:'Computer and Information Systems Managers'},
    {state:'Alaska',amount:'107,610',profession:'Computer and Information Systems Managers'},
    {state:'Arizona',amount:'137,420',profession:'Computer and Information Systems Managers'},
    {state:'Arkansas',amount:'109,890',profession:'Computer and Information Systems Managers'},
    {state:'California',amount:'180,250',profession:'Computer and Information Systems Managers'},
    {state:'Colorado',amount:'164,220',profession:'Computer and Information Systems Managers'},
    {state:'Connecticut',amount:'147,440',profession:'Computer and Information Systems Managers'},
    {state:'Delaware',amount:'169,720',profession:'Computer and Information Systems Managers'},
    {state:'District of Columbia',amount:'168,500',profession:'Computer and Information Systems Managers'},
    {state:'Florida',amount:'129,540',profession:'Computer and Information Systems Managers'},
    {state:'Georgia',amount:'143,930',profession:'Computer and Information Systems Managers'},
    {state:'Hawaii',amount:'124,660',profession:'Computer and Information Systems Managers'},
    {state:'Idaho',amount:'102,910',profession:'Computer and Information Systems Managers'},
    {state:'Illinois',amount:'143,900',profession:'Computer and Information Systems Managers'},
    {state:'Indiana',amount:'124,490',profession:'Computer and Information Systems Managers'},
    {state:'Iowa',amount:'126,560',profession:'Computer and Information Systems Managers'},
    {state:'Kansas',amount:'119,050',profession:'Computer and Information Systems Managers'},
    {state:'Kentucky',amount:'119,470',profession:'Computer and Information Systems Managers'},
    {state:'Louisiana',amount:'112,860',profession:'Computer and Information Systems Managers'},
    {state:'Maine',amount:'124,130',profession:'Computer and Information Systems Managers'},
    {state:'Maryland',amount:'154,870',profession:'Computer and Information Systems Managers'},
    {state:'Massachusetts',amount:'156,620',profession:'Computer and Information Systems Managers'},
    {state:'Michigan',amount:'131,100',profession:'Computer and Information Systems Managers'},
    {state:'Minnesota',amount:'143,300',profession:'Computer and Information Systems Managers'},
    {state:'Mississippi',amount:'100,300',profession:'Computer and Information Systems Managers'},
    {state:'Missouri',amount:'130,610',profession:'Computer and Information Systems Managers'},
    {state:'Montana',amount:'104,630',profession:'Computer and Information Systems Managers'},
    {state:'Nebraska',amount:'122,450',profession:'Computer and Information Systems Managers'},
    {state:'Nevada',amount:'134,840',profession:'Computer and Information Systems Managers'},
    {state:'New Hampshire',amount:'147,440',profession:'Computer and Information Systems Managers'},
    {state:'New Jersey',amount:'176,690',profession:'Computer and Information Systems Managers'},
    {state:'New Mexico',amount:'114,120',profession:'Computer and Information Systems Managers'},
    {state:'New York',amount:'190,310',profession:'Computer and Information Systems Managers'},
    {state:'North Carolina',amount:'142,330',profession:'Computer and Information Systems Managers'},
    {state:'North Dakota',amount:'124,450',profession:'Computer and Information Systems Managers'},
    {state:'Ohio',amount:'135,510',profession:'Computer and Information Systems Managers'},
    {state:'Oklahoma',amount:'114,670',profession:'Computer and Information Systems Managers'},
    {state:'Oregon',amount:'129,680',profession:'Computer and Information Systems Managers'},
    {state:'Pennsylvania',amount:'146,860',profession:'Computer and Information Systems Managers'},
    {state:'Rhode Island',amount:'146,550',profession:'Computer and Information Systems Managers'},
    {state:'South Carolina',amount:'120,720',profession:'Computer and Information Systems Managers'},
    {state:'South Dakota',amount:'132,190',profession:'Computer and Information Systems Managers'},
    {state:'Tennessee',amount:'118,660',profession:'Computer and Information Systems Managers'},
    {state:'Texas',amount:'154,650',profession:'Computer and Information Systems Managers'},
    {state:'Utah',amount:'121,570',profession:'Computer and Information Systems Managers'},
    {state:'Vermont',amount:'122,960',profession:'Computer and Information Systems Managers'},
    {state:'Virginia',amount:'173,290',profession:'Computer and Information Systems Managers'},
    {state:'Washington',amount:'159,290',profession:'Computer and Information Systems Managers'},
    {state:'West Virginia',amount:'119,430',profession:'Computer and Information Systems Managers'},
    {state:'Wisconsin',amount:'124,770',profession:'Computer and Information Systems Managers'},
    {state:'Wyoming',amount:'102,120',profession:'Computer and Information Systems Managers'},
    {state:'Guam',amount:'83,520',profession:'Computer and Information Systems Managers'},
    {state:'Puerto Rico',amount:'79,710',profession:'Computer and Information Systems Managers'},
    
    // Computer Systems Analysts
    {state:'Alabama',amount:'84,950',profession:'Computer Systems Analysts'},
    {state:'Alaska',amount:'70,390',profession:'Computer Systems Analysts'},
    {state:'Arizona',amount:'88,970',profession:'Computer Systems Analysts'},
    {state:'Arkansas',amount:'71,990',profession:'Computer Systems Analysts'},
    {state:'California',amount:'103,930',profession:'Computer Systems Analysts'},
    {state:'Colorado',amount:'96,030',profession:'Computer Systems Analysts'},
    {state:'Connecticut',amount:'94,530',profession:'Computer Systems Analysts'},
    {state:'Delaware',amount:'96,460',profession:'Computer Systems Analysts'},
    {state:'District of Columbia',amount:'106,790',profession:'Computer Systems Analysts'},
    {state:'Florida',amount:'85,050',profession:'Computer Systems Analysts'},
    {state:'Georgia',amount:'91,060',profession:'Computer Systems Analysts'},
    {state:'Hawaii',amount:'80,100',profession:'Computer Systems Analysts'},
    {state:'Idaho',amount:'78,550',profession:'Computer Systems Analysts'},
    {state:'Illinois',amount:'89,370',profession:'Computer Systems Analysts'},
    {state:'Indiana',amount:'79,750',profession:'Computer Systems Analysts'},
    {state:'Iowa',amount:'84,300',profession:'Computer Systems Analysts'},
    {state:'Kansas',amount:'78,520',profession:'Computer Systems Analysts'},
    {state:'Kentucky',amount:'71,500',profession:'Computer Systems Analysts'},
    {state:'Louisiana',amount:'72,560',profession:'Computer Systems Analysts'},
    {state:'Maine',amount:'81,670',profession:'Computer Systems Analysts'},
    {state:'Maryland',amount:'97,720',profession:'Computer Systems Analysts'},
    {state:'Massachusetts',amount:'94,510',profession:'Computer Systems Analysts'},
    {state:'Michigan',amount:'83,900',profession:'Computer Systems Analysts'},
    {state:'Minnesota',amount:'92,920',profession:'Computer Systems Analysts'},
    {state:'Mississippi',amount:'66,790',profession:'Computer Systems Analysts'},
    {state:'Missouri',amount:'83,720',profession:'Computer Systems Analysts'},
    {state:'Montana',amount:'76,380',profession:'Computer Systems Analysts'},
    {state:'Nebraska',amount:'77,240',profession:'Computer Systems Analysts'},
    {state:'Nevada',amount:'80,580',profession:'Computer Systems Analysts'},
    {state:'New Hampshire',amount:'93,620',profession:'Computer Systems Analysts'},
    {state:'New Jersey',amount:'107,540',profession:'Computer Systems Analysts'},
    {state:'New Mexico',amount:'84,660',profession:'Computer Systems Analysts'},
    {state:'New York',amount:'106,320',profession:'Computer Systems Analysts'},
    {state:'North Carolina',amount:'93,480',profession:'Computer Systems Analysts'},
    {state:'North Dakota',amount:'76,110',profession:'Computer Systems Analysts'},
    {state:'Ohio',amount:'89,420',profession:'Computer Systems Analysts'},
    {state:'Oklahoma',amount:'79,950',profession:'Computer Systems Analysts'},
    {state:'Oregon',amount:'89,440',profession:'Computer Systems Analysts'},
    {state:'Pennsylvania',amount:'95,990',profession:'Computer Systems Analysts'},
    {state:'Rhode Island',amount:'99,470',profession:'Computer Systems Analysts'},
    {state:'South Carolina',amount:'80,200',profession:'Computer Systems Analysts'},
    {state:'South Dakota',amount:'75,810',profession:'Computer Systems Analysts'},
    {state:'Tennessee',amount:'77,330',profession:'Computer Systems Analysts'},
    {state:'Texas',amount:'97,900',profession:'Computer Systems Analysts'},
    {state:'Utah',amount:'84,840',profession:'Computer Systems Analysts'},
    {state:'Vermont',amount:'80,190',profession:'Computer Systems Analysts'},
    {state:'Virginia',amount:'102,290',profession:'Computer Systems Analysts'},
    {state:'Washington',amount:'96,860',profession:'Computer Systems Analysts'},
    {state:'West Virginia',amount:'74,010',profession:'Computer Systems Analysts'},
    {state:'Wisconsin',amount:'82,480',profession:'Computer Systems Analysts'},
    {state:'Wyoming',amount:'77,200',profession:'Computer Systems Analysts'},
    {state:'Guam',amount:'53,650',profession:'Computer Systems Analysts'},
    {state:'Puerto Rico',amount:'48,680',profession:'Computer Systems Analysts'},
    {state:'Virgin Islands',amount:'53,550',profession:'Computer Systems Analysts'},
    
    // Respiratory Therapists
    {state:'Alabama',amount:'50,770',profession:'Respiratory Therapists'},
    {state:'Alaska',amount:'76,610',profession:'Respiratory Therapists'},
    {state:'Arizona',amount:'58,420',profession:'Respiratory Therapists'},
    {state:'Arkansas',amount:'52,050',profession:'Respiratory Therapists'},
    {state:'California',amount:'79,640',profession:'Respiratory Therapists'},
    {state:'Colorado',amount:'63,070',profession:'Respiratory Therapists'},
    {state:'Connecticut',amount:'70,410',profession:'Respiratory Therapists'},
    {state:'Delaware',amount:'67,950',profession:'Respiratory Therapists'},
    {state:'District of Columbia',amount:'78,540',profession:'Respiratory Therapists'},
    {state:'Florida',amount:'57,960',profession:'Respiratory Therapists'},
    {state:'Georgia',amount:'57,520',profession:'Respiratory Therapists'},
    {state:'Hawaii',amount:'71,460',profession:'Respiratory Therapists'},
    {state:'Idaho',amount:'57,700',profession:'Respiratory Therapists'},
    {state:'Illinois',amount:'60,500',profession:'Respiratory Therapists'},
    {state:'Indiana',amount:'55,610',profession:'Respiratory Therapists'},
    {state:'Iowa',amount:'53,870',profession:'Respiratory Therapists'},
    {state:'Kansas',amount:'55,080',profession:'Respiratory Therapists'},
    {state:'Kentucky',amount:'49,890',profession:'Respiratory Therapists'},
    {state:'Louisiana',amount:'53,510',profession:'Respiratory Therapists'},
    {state:'Maine',amount:'59,410',profession:'Respiratory Therapists'},
    {state:'Maryland',amount:'67,660',profession:'Respiratory Therapists'},
    {state:'Massachusetts',amount:'73,660',profession:'Respiratory Therapists'},
    {state:'Michigan',amount:'57,040',profession:'Respiratory Therapists'},
    {state:'Minnesota',amount:'67,190',profession:'Respiratory Therapists'},
    {state:'Mississippi',amount:'49,220',profession:'Respiratory Therapists'},
    {state:'Missouri',amount:'56,320',profession:'Respiratory Therapists'},
    {state:'Montana',amount:'57,310',profession:'Respiratory Therapists'},
    {state:'Nebraska',amount:'55,560',profession:'Respiratory Therapists'},
    {state:'Nevada',amount:'73,530',profession:'Respiratory Therapists'},
    {state:'New Hampshire',amount:'66,570',profession:'Respiratory Therapists'},
    {state:'New Jersey',amount:'73,390',profession:'Respiratory Therapists'},
    {state:'New Mexico',amount:'58,200',profession:'Respiratory Therapists'},
    {state:'New York',amount:'74,890',profession:'Respiratory Therapists'},
    {state:'North Carolina',amount:'56,620',profession:'Respiratory Therapists'},
    {state:'North Dakota',amount:'57,720',profession:'Respiratory Therapists'},
    {state:'Ohio',amount:'56,830',profession:'Respiratory Therapists'},
    {state:'Oklahoma',amount:'54,540',profession:'Respiratory Therapists'},
    {state:'Oregon',amount:'69,000',profession:'Respiratory Therapists'},
    {state:'Pennsylvania',amount:'56,970',profession:'Respiratory Therapists'},
    {state:'Rhode Island',amount:'67,060',profession:'Respiratory Therapists'},
    {state:'South Carolina',amount:'55,990',profession:'Respiratory Therapists'},
    {state:'South Dakota',amount:'51,510',profession:'Respiratory Therapists'},
    {state:'Tennessee',amount:'51,400',profession:'Respiratory Therapists'},
    {state:'Texas',amount:'59,930',profession:'Respiratory Therapists'},
    {state:'Utah',amount:'61,480',profession:'Respiratory Therapists'},
    {state:'Vermont',amount:'66,260',profession:'Respiratory Therapists'},
    {state:'Virginia',amount:'60,200',profession:'Respiratory Therapists'},
    {state:'Washington',amount:'69,540',profession:'Respiratory Therapists'},
    {state:'West Virginia',amount:'50,420',profession:'Respiratory Therapists'},
    {state:'Wisconsin',amount:'62,150',profession:'Respiratory Therapists'},
    {state:'Wyoming',amount:'57,960',profession:'Respiratory Therapists'},
    {state:'Puerto Rico',amount:'23,750',profession:'Respiratory Therapists'},
    
    // Financial Managers
    {state:'Alabama',amount:'128,690',profession:'Financial Managers'},
    {state:'Alaska',amount:'110,010',profession:'Financial Managers'},
    {state:'Arizona',amount:'117,620',profession:'Financial Managers'},
    {state:'Arkansas',amount:'106,530',profession:'Financial Managers'},
    {state:'California',amount:'157,480',profession:'Financial Managers'},
    {state:'Colorado',amount:'163,740',profession:'Financial Managers'},
    {state:'Connecticut',amount:'167,160',profession:'Financial Managers'},
    {state:'Delaware',amount:'167,110',profession:'Financial Managers'},
    {state:'District of Columbia',amount:'166,710',profession:'Financial Managers'},
    {state:'Florida',amount:'132,850',profession:'Financial Managers'},
    {state:'Georgia',amount:'145,920',profession:'Financial Managers'},
    {state:'Hawaii',amount:'118,740',profession:'Financial Managers'},
    {state:'Idaho',amount:'95,690',profession:'Financial Managers'},
    {state:'Illinois',amount:'144,680',profession:'Financial Managers'},
    {state:'Indiana',amount:'119,820',profession:'Financial Managers'},
    {state:'Iowa',amount:'114,620',profession:'Financial Managers'},
    {state:'Kansas',amount:'129,660',profession:'Financial Managers'},
    {state:'Kentucky',amount:'114,420',profession:'Financial Managers'},
    {state:'Louisiana',amount:'106,950',profession:'Financial Managers'},
    {state:'Maine',amount:'119,080',profession:'Financial Managers'},
    {state:'Maryland',amount:'152,180',profession:'Financial Managers'},
    {state:'Massachusetts',amount:'148,300',profession:'Financial Managers'},
    {state:'Michigan',amount:'128,270',profession:'Financial Managers'},
    {state:'Minnesota',amount:'133,970',profession:'Financial Managers'},
    {state:'Mississippi',amount:'101,840',profession:'Financial Managers'},
    {state:'Missouri',amount:'136,520',profession:'Financial Managers'},
    {state:'Montana',amount:'109,940',profession:'Financial Managers'},
    {state:'Nebraska',amount:'113,910',profession:'Financial Managers'},
    {state:'Nevada',amount:'123,890',profession:'Financial Managers'},
    {state:'New Hampshire',amount:'124,700',profession:'Financial Managers'},
    {state:'New Jersey',amount:'175,880',profession:'Financial Managers'},
    {state:'New Mexico',amount:'104,790',profession:'Financial Managers'},
    {state:'New York',amount:'210,510',profession:'Financial Managers'},
    {state:'North Carolina',amount:'149,710',profession:'Financial Managers'},
    {state:'North Dakota',amount:'123,890',profession:'Financial Managers'},
    {state:'Ohio',amount:'135,610',profession:'Financial Managers'},
    {state:'Oklahoma',amount:'111,700',profession:'Financial Managers'},
    {state:'Oregon',amount:'118,680',profession:'Financial Managers'},
    {state:'Pennsylvania',amount:'156,730',profession:'Financial Managers'},
    {state:'Rhode Island',amount:'145,120',profession:'Financial Managers'},
    {state:'South Carolina',amount:'125,710',profession:'Financial Managers'},
    {state:'South Dakota',amount:'132,030',profession:'Financial Managers'},
    {state:'Tennessee',amount:'111,460',profession:'Financial Managers'},
    {state:'Texas',amount:'149,990',profession:'Financial Managers'},
    {state:'Utah',amount:'110,750',profession:'Financial Managers'},
    {state:'Vermont',amount:'113,610',profession:'Financial Managers'},
    {state:'Virginia',amount:'164,030',profession:'Financial Managers'},
    {state:'Washington',amount:'136,480',profession:'Financial Managers'},
    {state:'West Virginia',amount:'102,670',profession:'Financial Managers'},
    {state:'Wisconsin',amount:'134,850',profession:'Financial Managers'},
    {state:'Wyoming',amount:'116,920',profession:'Financial Managers'},
    {state:'Guam',amount:'74,130',profession:'Financial Managers'},
    {state:'Puerto Rico',amount:'81,750',profession:'Financial Managers'},
    {state:'Virgin Islands',amount:'89,180',profession:'Financial Managers'},
    
    // Accountants and Auditors
    {state:'Alabama',amount:'70,310',profession:'Accountants and Auditors'},
    {state:'Alaska',amount:'82,920',profession:'Accountants and Auditors'},
    {state:'Arizona',amount:'69,190',profession:'Accountants and Auditors'},
    {state:'Arkansas',amount:'67,700',profession:'Accountants and Auditors'},
    {state:'California',amount:'84,430',profession:'Accountants and Auditors'},
    {state:'Colorado',amount:'82,320',profession:'Accountants and Auditors'},
    {state:'Connecticut',amount:'84,890',profession:'Accountants and Auditors'},
    {state:'Delaware',amount:'78,120',profession:'Accountants and Auditors'},
    {state:'District of Columbia',amount:'98,130',profession:'Accountants and Auditors'},
    {state:'Florida',amount:'71,790',profession:'Accountants and Auditors'},
    {state:'Georgia',amount:'75,930',profession:'Accountants and Auditors'},
    {state:'Hawaii',amount:'65,580',profession:'Accountants and Auditors'},
    {state:'Idaho',amount:'66,110',profession:'Accountants and Auditors'},
    {state:'Illinois',amount:'81,060',profession:'Accountants and Auditors'},
    {state:'Indiana',amount:'70,780',profession:'Accountants and Auditors'},
    {state:'Iowa',amount:'67,030',profession:'Accountants and Auditors'},
    {state:'Kansas',amount:'66,530',profession:'Accountants and Auditors'},
    {state:'Kentucky',amount:'67,080',profession:'Accountants and Auditors'},
    {state:'Louisiana',amount:'66,860',profession:'Accountants and Auditors'},
    {state:'Maine',amount:'70,810',profession:'Accountants and Auditors'},
    {state:'Maryland',amount:'82,610',profession:'Accountants and Auditors'},
    {state:'Massachusetts',amount:'81,460',profession:'Accountants and Auditors'},
    {state:'Michigan',amount:'74,370',profession:'Accountants and Auditors'},
    {state:'Minnesota',amount:'72,480',profession:'Accountants and Auditors'},
    {state:'Mississippi',amount:'62,850',profession:'Accountants and Auditors'},
    {state:'Missouri',amount:'70,240',profession:'Accountants and Auditors'},
    {state:'Montana',amount:'66,410',profession:'Accountants and Auditors'},
    {state:'Nebraska',amount:'67,920',profession:'Accountants and Auditors'},
    {state:'Nevada',amount:'66,600',profession:'Accountants and Auditors'},
    {state:'New Hampshire',amount:'72,690',profession:'Accountants and Auditors'},
    {state:'New Jersey',amount:'90,400',profession:'Accountants and Auditors'},
    {state:'New Mexico',amount:'66,370',profession:'Accountants and Auditors'},
    {state:'New York',amount:'96,300',profession:'Accountants and Auditors'},
    {state:'North Carolina',amount:'76,880',profession:'Accountants and Auditors'},
    {state:'North Dakota',amount:'61,870',profession:'Accountants and Auditors'},
    {state:'Ohio',amount:'72,370',profession:'Accountants and Auditors'},
    {state:'Oklahoma',amount:'73,040',profession:'Accountants and Auditors'},
    {state:'Oregon',amount:'71,450',profession:'Accountants and Auditors'},
    {state:'Pennsylvania',amount:'75,250',profession:'Accountants and Auditors'},
    {state:'Rhode Island',amount:'81,090',profession:'Accountants and Auditors'},
    {state:'South Carolina',amount:'64,750',profession:'Accountants and Auditors'},
    {state:'South Dakota',amount:'65,800',profession:'Accountants and Auditors'},
    {state:'Tennessee',amount:'69,690',profession:'Accountants and Auditors'},
    {state:'Texas',amount:'80,200',profession:'Accountants and Auditors'},
    {state:'Utah',amount:'70,980',profession:'Accountants and Auditors'},
    {state:'Vermont',amount:'75,360',profession:'Accountants and Auditors'},
    {state:'Virginia',amount:'85,640',profession:'Accountants and Auditors'},
    {state:'Washington',amount:'78,970',profession:'Accountants and Auditors'},
    {state:'West Virginia',amount:'68,160',profession:'Accountants and Auditors'},
    {state:'Wisconsin',amount:'68,410',profession:'Accountants and Auditors'},
    {state:'Wyoming',amount:'66,180',profession:'Accountants and Auditors'},
    {state:'Guam',amount:'47,720',profession:'Accountants and Auditors'},
    {state:'Puerto Rico',amount:'36,650',profession:'Accountants and Auditors'},
    {state:'Virgin Islands',amount:'54,960',profession:'Accountants and Auditors'},
    
    // Speech-Language Pathologists
    {state:'Alabama',amount:'71,240',profession:'Speech-Language Pathologists'},
    {state:'Alaska',amount:'83,620',profession:'Speech-Language Pathologists'},
    {state:'Arizona',amount:'74,710',profession:'Speech-Language Pathologists'},
    {state:'Arkansas',amount:'73,660',profession:'Speech-Language Pathologists'},
    {state:'California',amount:'93,510',profession:'Speech-Language Pathologists'},
    {state:'Colorado',amount:'90,980',profession:'Speech-Language Pathologists'},
    {state:'Connecticut',amount:'92,280',profession:'Speech-Language Pathologists'},
    {state:'Delaware',amount:'81,440',profession:'Speech-Language Pathologists'},
    {state:'District of Columbia',amount:'93,570',profession:'Speech-Language Pathologists'},
    {state:'Florida',amount:'76,820',profession:'Speech-Language Pathologists'},
    {state:'Georgia',amount:'77,730',profession:'Speech-Language Pathologists'},
    {state:'Hawaii',amount:'76,330',profession:'Speech-Language Pathologists'},
    {state:'Idaho',amount:'74,740',profession:'Speech-Language Pathologists'},
    {state:'Illinois',amount:'77,120',profession:'Speech-Language Pathologists'},
    {state:'Indiana',amount:'73,780',profession:'Speech-Language Pathologists'},
    {state:'Iowa',amount:'76,020',profession:'Speech-Language Pathologists'},
    {state:'Kansas',amount:'70,280',profession:'Speech-Language Pathologists'},
    {state:'Kentucky',amount:'72,440',profession:'Speech-Language Pathologists'},
    {state:'Louisiana',amount:'71,270',profession:'Speech-Language Pathologists'},
    {state:'Maine',amount:'65,540',profession:'Speech-Language Pathologists'},
    {state:'Maryland',amount:'84,960',profession:'Speech-Language Pathologists'},
    {state:'Massachusetts',amount:'85,720',profession:'Speech-Language Pathologists'},
    {state:'Michigan',amount:'78,220',profession:'Speech-Language Pathologists'},
    {state:'Minnesota',amount:'75,590',profession:'Speech-Language Pathologists'},
    {state:'Mississippi',amount:'64,560',profession:'Speech-Language Pathologists'},
    {state:'Missouri',amount:'77,790',profession:'Speech-Language Pathologists'},
    {state:'Montana',amount:'64,580',profession:'Speech-Language Pathologists'},
    {state:'Nebraska',amount:'69,110',profession:'Speech-Language Pathologists'},
    {state:'Nevada',amount:'77,620',profession:'Speech-Language Pathologists'},
    {state:'New Hampshire',amount:'73,630',profession:'Speech-Language Pathologists'},
    {state:'New Jersey',amount:'95,000',profession:'Speech-Language Pathologists'},
    {state:'New Mexico',amount:'74,800',profession:'Speech-Language Pathologists'},
    {state:'New York',amount:'90,820',profession:'Speech-Language Pathologists'},
    {state:'North Carolina',amount:'75,310',profession:'Speech-Language Pathologists'},
    {state:'North Dakota',amount:'67,340',profession:'Speech-Language Pathologists'},
    {state:'Ohio',amount:'78,200',profession:'Speech-Language Pathologists'},
    {state:'Oklahoma',amount:'81,700',profession:'Speech-Language Pathologists'},
    {state:'Oregon',amount:'87,610',profession:'Speech-Language Pathologists'},
    {state:'Pennsylvania',amount:'79,530',profession:'Speech-Language Pathologists'},
    {state:'Rhode Island',amount:'80,450',profession:'Speech-Language Pathologists'},
    {state:'South Carolina',amount:'71,600',profession:'Speech-Language Pathologists'},
    {state:'South Dakota',amount:'58,860',profession:'Speech-Language Pathologists'},
    {state:'Tennessee',amount:'77,140',profession:'Speech-Language Pathologists'},
    {state:'Texas',amount:'75,800',profession:'Speech-Language Pathologists'},
    {state:'Utah',amount:'78,840',profession:'Speech-Language Pathologists'},
    {state:'Vermont',amount:'73,550',profession:'Speech-Language Pathologists'},
    {state:'Virginia',amount:'86,090',profession:'Speech-Language Pathologists'},
    {state:'Washington',amount:'73,220',profession:'Speech-Language Pathologists'},
    {state:'West Virginia',amount:'61,070',profession:'Speech-Language Pathologists'},
    {state:'Wisconsin',amount:'70,560',profession:'Speech-Language Pathologists'},
    {state:'Wyoming',amount:'80,470',profession:'Speech-Language Pathologists'},
    {state:'Puerto Rico',amount:'44,690',profession:'Speech-Language Pathologists'},

    // Podiatrists
    {state:'Alabama',amount:'148,010',profession:'Podiatrists'},
    {state:'Arizona',amount:'143,620',profession:'Podiatrists'},
    {state:'Arkansas',amount:'183,190',profession:'Podiatrists'},
    {state:'California',amount:'120,750',profession:'Podiatrists'},
    {state:'Colorado',amount:'119,190',profession:'Podiatrists'},
    {state:'Connecticut',amount:'95,610',profession:'Podiatrists'},
    {state:'Delaware',amount:'171,800',profession:'Podiatrists'},
    {state:'District of Columbia',amount:'152,520',profession:'Podiatrists'},
    {state:'Florida',amount:'136,170',profession:'Podiatrists'},
    {state:'Georgia',amount:'125,390',profession:'Podiatrists'},
    {state:'Illinois',amount:'180,270',profession:'Podiatrists'},
    {state:'Indiana',amount:'182,030',profession:'Podiatrists'},
    {state:'Iowa',amount:'173,370',profession:'Podiatrists'},
    {state:'Kansas',amount:'122,390',profession:'Podiatrists'},
    {state:'Kentucky',amount:'111,780',profession:'Podiatrists'},
    {state:'Louisiana',amount:'157,690',profession:'Podiatrists'},
    {state:'Maryland',amount:'159,950',profession:'Podiatrists'},
    {state:'Massachusetts',amount:'173,250',profession:'Podiatrists'},
    {state:'Michigan',amount:'131,780',profession:'Podiatrists'},
    {state:'Minnesota',amount:'184,280',profession:'Podiatrists'},
    {state:'Missouri',amount:'135,760',profession:'Podiatrists'},
    {state:'Montana',amount:'119,040',profession:'Podiatrists'},
    {state:'Nebraska',amount:'219,670',profession:'Podiatrists'},
    {state:'Nevada',amount:'109,560',profession:'Podiatrists'},
    {state:'New Jersey',amount:'132,320',profession:'Podiatrists'},
    {state:'New Mexico',amount:'124,660',profession:'Podiatrists'},
    {state:'New York',amount:'156,960',profession:'Podiatrists'},
    {state:'North Carolina',amount:'186,510',profession:'Podiatrists'},
    {state:'Ohio',amount:'155,870',profession:'Podiatrists'},
    {state:'Oklahoma',amount:'132,420',profession:'Podiatrists'},
    {state:'Oregon',amount:'93,930',profession:'Podiatrists'},
    {state:'Pennsylvania',amount:'136,780',profession:'Podiatrists'},
    {state:'Rhode Island',amount:'226,030',profession:'Podiatrists'},
    {state:'South Carolina',amount:'195,380',profession:'Podiatrists'},
    {state:'Tennessee',amount:'139,880',profession:'Podiatrists'},
    {state:'Texas',amount:'139,070',profession:'Podiatrists'},
    {state:'Utah',amount:'147,770',profession:'Podiatrists'},
    {state:'Virginia',amount:'144,330',profession:'Podiatrists'},
    {state:'Washington',amount:'136,330',profession:'Podiatrists'},
    {state:'West Virginia',amount:'175,530',profession:'Podiatrists'},
    {state:'Wisconsin',amount:'201,060',profession:'Podiatrists'},
    {state:'Wisconsin',amount:'140',profession:'Podiatrists'},
    
    // Clinical Laboratory Technologists and Technicians
    {state:'Alabama',amount:'47,720',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Alaska',amount:'67,280',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Arizona',amount:'53,460',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Arkansas',amount:'43,810',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'California',amount:'60,530',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Colorado',amount:'57,650',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Connecticut',amount:'65,830',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Delaware',amount:'60,610',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'District of Columbia',amount:'60,320',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Florida',amount:'50,980',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Georgia',amount:'50,340',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Hawaii',amount:'59,050',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Idaho',amount:'46,830',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Illinois',amount:'54,450',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Indiana',amount:'46,890',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Iowa',amount:'48,590',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Kansas',amount:'48,380',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Kentucky',amount:'48,970',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Louisiana',amount:'47,930',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Maine',amount:'53,190',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Maryland',amount:'54,130',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Massachusetts',amount:'60,700',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Michigan',amount:'48,390',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Minnesota',amount:'57,150',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Mississippi',amount:'45,790',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Missouri',amount:'48,850',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Montana',amount:'54,140',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Nebraska',amount:'51,140',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Nevada',amount:'60,930',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'New Hampshire',amount:'60,220',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'New Jersey',amount:'63,720',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'New Mexico',amount:'48,210',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'New York',amount:'62,940',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'North Carolina',amount:'51,240',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'North Dakota',amount:'52,720',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Ohio',amount:'54,590',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Oklahoma',amount:'47,770',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Oregon',amount:'63,650',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Pennsylvania',amount:'51,990',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Rhode Island',amount:'70,380',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'South Carolina',amount:'48,670',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'South Dakota',amount:'48,570',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Tennessee',amount:'51,240',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Texas',amount:'51,240',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Utah',amount:'49,430',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Vermont',amount:'56,290',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Virginia',amount:'52,530',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Washington',amount:'57,060',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'West Virginia',amount:'49,130',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Wisconsin',amount:'50,260',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Wyoming',amount:'53,570',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Guam',amount:'49,020',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Puerto Rico',amount:'32,160',profession:'Clinical Laboratory Technologists and Technicians'},
    {state:'Virgin Islands',amount:'54,040',profession:'Clinical Laboratory Technologists and Technicians'},

    // Physical Therapists
    {state:'Alabama',amount:'90,620',profession:'Physical Therapists'},
    {state:'Alaska',amount:'99,180',profession:'Physical Therapists'},
    {state:'Arizona',amount:'88,800',profession:'Physical Therapists'},
    {state:'Arkansas',amount:'81,430',profession:'Physical Therapists'},
    {state:'California',amount:'97,110',profession:'Physical Therapists'},
    {state:'Colorado',amount:'82,560',profession:'Physical Therapists'},
    {state:'Connecticut',amount:'96,010',profession:'Physical Therapists'},
    {state:'Delaware',amount:'93,880',profession:'Physical Therapists'},
    {state:'District of Columbia',amount:'89,750',profession:'Physical Therapists'},
    {state:'Florida',amount:'87,410',profession:'Physical Therapists'},
    {state:'Georgia',amount:'86,320',profession:'Physical Therapists'},
    {state:'Hawaii',amount:'90,540',profession:'Physical Therapists'},
    {state:'Idaho',amount:'77,700',profession:'Physical Therapists'},
    {state:'Illinois',amount:'90,690',profession:'Physical Therapists'},
    {state:'Indiana',amount:'83,680',profession:'Physical Therapists'},
    {state:'Iowa',amount:'82,960',profession:'Physical Therapists'},
    {state:'Kansas',amount:'85,250',profession:'Physical Therapists'},
    {state:'Kentucky',amount:'84,630',profession:'Physical Therapists'},
    {state:'Louisiana',amount:'89,860',profession:'Physical Therapists'},
    {state:'Maine',amount:'76,910',profession:'Physical Therapists'},
    {state:'Maryland',amount:'85,170',profession:'Physical Therapists'},
    {state:'Massachusetts',amount:'91,750',profession:'Physical Therapists'},
    {state:'Michigan',amount:'91,160',profession:'Physical Therapists'},
    {state:'Minnesota',amount:'83,750',profession:'Physical Therapists'},
    {state:'Mississippi',amount:'89,720',profession:'Physical Therapists'},
    {state:'Missouri',amount:'81,330',profession:'Physical Therapists'},
    {state:'Montana',amount:'79,050',profession:'Physical Therapists'},
    {state:'Nebraska',amount:'80,130',profession:'Physical Therapists'},
    {state:'Nevada',amount:'107,920',profession:'Physical Therapists'},
    {state:'New Hampshire',amount:'82,880',profession:'Physical Therapists'},
    {state:'New Jersey',amount:'97,770',profession:'Physical Therapists'},
    {state:'New Mexico',amount:'97,210',profession:'Physical Therapists'},
    {state:'New York',amount:'87,470',profession:'Physical Therapists'},
    {state:'North Carolina',amount:'87,560',profession:'Physical Therapists'},
    {state:'North Dakota',amount:'78,120',profession:'Physical Therapists'},
    {state:'Ohio',amount:'86,690',profession:'Physical Therapists'},
    {state:'Oklahoma',amount:'84,860',profession:'Physical Therapists'},
    {state:'Oregon',amount:'85,890',profession:'Physical Therapists'},
    {state:'Pennsylvania',amount:'87,050',profession:'Physical Therapists'},
    {state:'Rhode Island',amount:'83,850',profession:'Physical Therapists'},
    {state:'South Carolina',amount:'85,450',profession:'Physical Therapists'},
    {state:'South Dakota',amount:'76,200',profession:'Physical Therapists'},
    {state:'Tennessee',amount:'82,920',profession:'Physical Therapists'},
    {state:'Texas',amount:'92,940',profession:'Physical Therapists'},
    {state:'Utah',amount:'85,940',profession:'Physical Therapists'},
    {state:'Vermont',amount:'75,010',profession:'Physical Therapists'},
    {state:'Virginia',amount:'91,700',profession:'Physical Therapists'},
    {state:'Washington',amount:'85,930',profession:'Physical Therapists'},
    {state:'West Virginia',amount:'89,420',profession:'Physical Therapists'},
    {state:'Wisconsin',amount:'85,200',profession:'Physical Therapists'},
    {state:'Wyoming',amount:'87,510',profession:'Physical Therapists'},
    {state:'Guam',amount:'61,870',profession:'Physical Therapists'},
    {state:'Puerto Rico',amount:'48,260',profession:'Physical Therapists'},
    {state:'Virgin Islands',amount:'54,850',profession:'Physical Therapists'},
    
    // Registered Nurses
    {state:'Alabama',amount:'59,470',profession:'Registered Nurses'},
    {state:'Alaska',amount:'89,310',profession:'Registered Nurses'},
    {state:'Arizona',amount:'77,000',profession:'Registered Nurses'},
    {state:'Arkansas',amount:'60,780',profession:'Registered Nurses'},
    {state:'California',amount:'106,950',profession:'Registered Nurses'},
    {state:'Colorado',amount:'74,240',profession:'Registered Nurses'},
    {state:'Connecticut',amount:'81,220',profession:'Registered Nurses'},
    {state:'Delaware',amount:'74,800',profession:'Registered Nurses'},
    {state:'District of Columbia',amount:'92,350',profession:'Registered Nurses'},
    {state:'Florida',amount:'66,210',profession:'Registered Nurses'},
    {state:'Georgia',amount:'68,950',profession:'Registered Nurses'},
    {state:'Hawaii',amount:'98,080',profession:'Registered Nurses'},
    {state:'Idaho',amount:'67,110',profession:'Registered Nurses'},
    {state:'Illinois',amount:'73,890',profession:'Registered Nurses'},
    {state:'Indiana',amount:'64,860',profession:'Registered Nurses'},
    {state:'Iowa',amount:'59,130',profession:'Registered Nurses'},
    {state:'Kansas',amount:'61,030',profession:'Registered Nurses'},
    {state:'Kentucky',amount:'63,100',profession:'Registered Nurses'},
    {state:'Louisiana',amount:'63,970',profession:'Registered Nurses'},
    {state:'Maine',amount:'67,610',profession:'Registered Nurses'},
    {state:'Maryland',amount:'76,820',profession:'Registered Nurses'},
    {state:'Massachusetts',amount:'92,140',profession:'Registered Nurses'},
    {state:'Michigan',amount:'71,330',profession:'Registered Nurses'},
    {state:'Minnesota',amount:'78,920',profession:'Registered Nurses'},
    {state:'Mississippi',amount:'58,490',profession:'Registered Nurses'},
    {state:'Missouri',amount:'65,130',profession:'Registered Nurses'},
    {state:'Montana',amount:'67,450',profession:'Registered Nurses'},
    {state:'Nebraska',amount:'64,470',profession:'Registered Nurses'},
    {state:'Nevada',amount:'85,620',profession:'Registered Nurses'},
    {state:'New Hampshire',amount:'72,760',profession:'Registered Nurses'},
    {state:'New Jersey',amount:'82,750',profession:'Registered Nurses'},
    {state:'New Mexico',amount:'71,730',profession:'Registered Nurses'},
    {state:'New York',amount:'85,610',profession:'Registered Nurses'},
    {state:'North Carolina',amount:'64,850',profession:'Registered Nurses'},
    {state:'North Dakota',amount:'65,740',profession:'Registered Nurses'},
    {state:'Ohio',amount:'66,820',profession:'Registered Nurses'},
    {state:'Oklahoma',amount:'63,080',profession:'Registered Nurses'},
    {state:'Oregon',amount:'91,080',profession:'Registered Nurses'},
    {state:'Pennsylvania',amount:'70,390',profession:'Registered Nurses'},
    {state:'Rhode Island',amount:'78,420',profession:'Registered Nurses'},
    {state:'South Carolina',amount:'64,940',profession:'Registered Nurses'},
    {state:'South Dakota',amount:'58,340',profession:'Registered Nurses'},
    {state:'Tennessee',amount:'61,320',profession:'Registered Nurses'},
    {state:'Texas',amount:'72,890',profession:'Registered Nurses'},
    {state:'Utah',amount:'65,670',profession:'Registered Nurses'},
    {state:'Vermont',amount:'69,160',profession:'Registered Nurses'},
    {state:'Virginia',amount:'69,790',profession:'Registered Nurses'},
    {state:'Washington',amount:'82,670',profession:'Registered Nurses'},
    {state:'West Virginia',amount:'61,780',profession:'Registered Nurses'},
    {state:'Wisconsin',amount:'71,470',profession:'Registered Nurses'},
    {state:'Wyoming',amount:'67,360',profession:'Registered Nurses'},
    {state:'Guam',amount:'59,030',profession:'Registered Nurses'},
    {state:'Puerto Rico',amount:'34,940',profession:'Registered Nurses'},
    {state:'Virgin Islands',amount:'61,550',profession:'Registered Nurses'},
    
    // Cartographers and Photogrammetrists
    {state:'Alabama',amount:'65,660',profession:'Cartographers and Photogrammetrists'},
    {state:'Alaska',amount:'67,920',profession:'Cartographers and Photogrammetrists'},
    {state:'Arizona',amount:'66,830',profession:'Cartographers and Photogrammetrists'},
    {state:'Arkansas',amount:'52,480',profession:'Cartographers and Photogrammetrists'},
    {state:'California',amount:'84,540',profession:'Cartographers and Photogrammetrists'},
    {state:'Colorado',amount:'73,150',profession:'Cartographers and Photogrammetrists'},
    {state:'Connecticut',amount:'72,270',profession:'Cartographers and Photogrammetrists'},
    {state:'Florida',amount:'62,160',profession:'Cartographers and Photogrammetrists'},
    {state:'Georgia',amount:'54,620',profession:'Cartographers and Photogrammetrists'},
    {state:'Hawaii',amount:'67,670',profession:'Cartographers and Photogrammetrists'},
    {state:'Idaho',amount:'56,350',profession:'Cartographers and Photogrammetrists'},
    {state:'Illinois',amount:'77,070',profession:'Cartographers and Photogrammetrists'},
    {state:'Indiana',amount:'57,420',profession:'Cartographers and Photogrammetrists'},
    {state:'Kansas',amount:'58,710',profession:'Cartographers and Photogrammetrists'},
    {state:'Kentucky',amount:'70,060',profession:'Cartographers and Photogrammetrists'},
    {state:'Louisiana',amount:'71,480',profession:'Cartographers and Photogrammetrists'},
    {state:'Maine',amount:'67,460',profession:'Cartographers and Photogrammetrists'},
    {state:'Maryland',amount:'79,440',profession:'Cartographers and Photogrammetrists'},
    {state:'Massachusetts',amount:'73,290',profession:'Cartographers and Photogrammetrists'},
    {state:'Michigan',amount:'65,610',profession:'Cartographers and Photogrammetrists'},
    {state:'Minnesota',amount:'71,070',profession:'Cartographers and Photogrammetrists'},
    {state:'Mississippi',amount:'58,840',profession:'Cartographers and Photogrammetrists'},
    {state:'Missouri',amount:'64,270',profession:'Cartographers and Photogrammetrists'},
    {state:'Montana',amount:'52,130',profession:'Cartographers and Photogrammetrists'},
    {state:'Nebraska',amount:'68,150',profession:'Cartographers and Photogrammetrists'},
    {state:'Nevada',amount:'75,300',profession:'Cartographers and Photogrammetrists'},
    {state:'New Hampshire',amount:'53,990',profession:'Cartographers and Photogrammetrists'},
    {state:'New Jersey',amount:'84,120',profession:'Cartographers and Photogrammetrists'},
    {state:'New Mexico',amount:'69,250',profession:'Cartographers and Photogrammetrists'},
    {state:'New York',amount:'78,780',profession:'Cartographers and Photogrammetrists'},
    {state:'North Carolina',amount:'56,530',profession:'Cartographers and Photogrammetrists'},
    {state:'Ohio',amount:'70,550',profession:'Cartographers and Photogrammetrists'},
    {state:'Oklahoma',amount:'56,250',profession:'Cartographers and Photogrammetrists'},
    {state:'Oregon',amount:'64,290',profession:'Cartographers and Photogrammetrists'},
    {state:'Pennsylvania',amount:'63,360',profession:'Cartographers and Photogrammetrists'},
    {state:'South Carolina',amount:'53,020',profession:'Cartographers and Photogrammetrists'},
    {state:'South Dakota',amount:'55,310',profession:'Cartographers and Photogrammetrists'},
    {state:'Tennessee',amount:'58,380',profession:'Cartographers and Photogrammetrists'},
    {state:'Texas',amount:'64,620',profession:'Cartographers and Photogrammetrists'},
    {state:'Utah',amount:'57,310',profession:'Cartographers and Photogrammetrists'},
    {state:'Vermont',amount:'62,940',profession:'Cartographers and Photogrammetrists'},
    {state:'Virginia',amount:'81,750',profession:'Cartographers and Photogrammetrists'},
    {state:'Washington',amount:'81,620',profession:'Cartographers and Photogrammetrists'},
    {state:'West Virginia',amount:'55,030',profession:'Cartographers and Photogrammetrists'},
    {state:'Wisconsin',amount:'64,490',profession:'Cartographers and Photogrammetrists'},
    {state:'Wyoming',amount:'57,110',profession:'Cartographers and Photogrammetrists'},

    // Mathematicians
    {state:'California',amount:'100,000',profession:'Mathematicians'},
    {state:'Colorado',amount:'122,840',profession:'Mathematicians'},
    {state:'District of Columbia',amount:'133,870',profession:'Mathematicians'},
    {state:'Florida',amount:'87,820',profession:'Mathematicians'},
    {state:'Illinois',amount:'103,220',profession:'Mathematicians'},
    {state:'Maryland',amount:'115,940',profession:'Mathematicians'},
    {state:'Nevada',amount:'79,980',profession:'Mathematicians'},
    {state:'New Jersey',amount:'117,060',profession:'Mathematicians'},
    {state:'New Mexico',amount:'106,790',profession:'Mathematicians'},
    {state:'New York',amount:'84,670',profession:'Mathematicians'},
    {state:'Ohio',amount:'86,280',profession:'Mathematicians'},
    {state:'Pennsylvania',amount:'76,250',profession:'Mathematicians'},
    {state:'Rhode Island',amount:'90,640',profession:'Mathematicians'},
    {state:'Virginia',amount:'121,240',profession:'Mathematicians'},
    {state:'Washington',amount:'123,380',profession:'Mathematicians'},
    
    // Nurse Midwives
    {state:'Alaska',amount:'85,210',profession:'Nurse Midwives'},
    {state:'Arizona',amount:'114,900',profession:'Nurse Midwives'},
    {state:'California',amount:'139,990',profession:'Nurse Midwives'},
    {state:'Colorado',amount:'107,100',profession:'Nurse Midwives'},
    {state:'Connecticut',amount:'111,340',profession:'Nurse Midwives'},
    {state:'Delaware',amount:'96,340',profession:'Nurse Midwives'},
    {state:'District of Columbia',amount:'95,730',profession:'Nurse Midwives'},
    {state:'Florida',amount:'88,060',profession:'Nurse Midwives'},
    {state:'Georgia',amount:'109,640',profession:'Nurse Midwives'},
    {state:'Idaho',amount:'67,950',profession:'Nurse Midwives'},
    {state:'Illinois',amount:'105,640',profession:'Nurse Midwives'},
    {state:'Indiana',amount:'110,040',profession:'Nurse Midwives'},
    {state:'Kentucky',amount:'101,990',profession:'Nurse Midwives'},
    {state:'Maryland',amount:'115,440',profession:'Nurse Midwives'},
    {state:'Massachusetts',amount:'119,380',profession:'Nurse Midwives'},
    {state:'Michigan',amount:'92,030',profession:'Nurse Midwives'},
    {state:'Minnesota',amount:'113,440',profession:'Nurse Midwives'},
    {state:'New Hampshire',amount:'105,120',profession:'Nurse Midwives'},
    {state:'New Jersey',amount:'113,980',profession:'Nurse Midwives'},
    {state:'New Mexico',amount:'97,930',profession:'Nurse Midwives'},
    {state:'New York',amount:'110,150',profession:'Nurse Midwives'},
    {state:'North Carolina',amount:'106,570',profession:'Nurse Midwives'},
    {state:'Ohio',amount:'106,830',profession:'Nurse Midwives'},
    {state:'Oregon',amount:'108,950',profession:'Nurse Midwives'},
    {state:'Pennsylvania',amount:'96,710',profession:'Nurse Midwives'},
    {state:'Rhode Island',amount:'107,700',profession:'Nurse Midwives'},
    {state:'South Carolina',amount:'89,150',profession:'Nurse Midwives'},
    {state:'Tennessee',amount:'85,040',profession:'Nurse Midwives'},
    {state:'Texas',amount:'85,900',profession:'Nurse Midwives'},
    {state:'Utah',amount:'106,590',profession:'Nurse Midwives'},
    {state:'Vermont',amount:'89,700',profession:'Nurse Midwives'},
    {state:'Virginia',amount:'89,870',profession:'Nurse Midwives'},
    {state:'Washington',amount:'102,670',profession:'Nurse Midwives'},
    {state:'West Virginia',amount:'113,720',profession:'Nurse Midwives'},
    {state:'Wisconsin',amount:'108,690',profession:'Nurse Midwives'},
    
    // Surgeons
    {state:'Alabama',amount:'278,810',profession:'Surgeons'},
    {state:'Arkansas',amount:'266,630',profession:'Surgeons'},
    {state:'California',amount:'221,490',profession:'Surgeons'},
    {state:'Colorado',amount:'244,940',profession:'Surgeons'},
    {state:'Connecticut',amount:'224,570',profession:'Surgeons'},
    {state:'Delaware',amount:'277,280',profession:'Surgeons'},
    {state:'District of Columbia',amount:'244,230',profession:'Surgeons'},
    {state:'Florida',amount:'211,640',profession:'Surgeons'},
    {state:'Georgia',amount:'273,450',profession:'Surgeons'},
    {state:'Idaho',amount:'241,030',profession:'Surgeons'},
    {state:'Illinois',amount:'243,350',profession:'Surgeons'},
    {state:'Indiana',amount:'259,850',profession:'Surgeons'},
    {state:'Iowa',amount:'231,450',profession:'Surgeons'},
    {state:'Kansas',amount:'282,940',profession:'Surgeons'},
    {state:'Kentucky',amount:'268,550',profession:'Surgeons'},
    {state:'Louisiana',amount:'253,630',profession:'Surgeons'},
    {state:'Maine',amount:'286,810',profession:'Surgeons'},
    {state:'Maryland',amount:'284,120',profession:'Surgeons'},
    {state:'Massachusetts',amount:'242,790',profession:'Surgeons'},
    {state:'Michigan',amount:'244,710',profession:'Surgeons'},
    {state:'Mississippi',amount:'280,350',profession:'Surgeons'},
    {state:'Missouri',amount:'248,250',profession:'Surgeons'},
    {state:'Montana',amount:'266,470',profession:'Surgeons'},
    {state:'Nebraska',amount:'287,890',profession:'Surgeons'},
    {state:'New Jersey',amount:'285,850',profession:'Surgeons'},
    {state:'New Mexico',amount:'280,430',profession:'Surgeons'},
    {state:'New York',amount:'250,620',profession:'Surgeons'},
    {state:'North Carolina',amount:'278,260',profession:'Surgeons'},
    {state:'North Dakota',amount:'219,390',profession:'Surgeons'},
    {state:'Ohio',amount:'267,680',profession:'Surgeons'},
    {state:'Oklahoma',amount:'279,020',profession:'Surgeons'},
    {state:'Pennsylvania',amount:'252,140',profession:'Surgeons'},
    {state:'Rhode Island',amount:'257,000',profession:'Surgeons'},
    {state:'Tennessee',amount:'271,680',profession:'Surgeons'},
    {state:'Texas',amount:'238,080',profession:'Surgeons'},
    {state:'Vermont',amount:'272,550',profession:'Surgeons'},
    {state:'Virginia',amount:'264,160',profession:'Surgeons'},
    {state:'Washington',amount:'240,910',profession:'Surgeons'},
    
    // Anesthesiologists
    {state:'Arizona',amount:'279,160',profession:'Anesthesiologists'},
    {state:'Arkansas',amount:'229,760',profession:'Anesthesiologists'},
    {state:'California',amount:'288,420',profession:'Anesthesiologists'},
    {state:'Colorado',amount:'270,180',profession:'Anesthesiologists'},
    {state:'Connecticut',amount:'270,210',profession:'Anesthesiologists'},
    {state:'Florida',amount:'280,390',profession:'Anesthesiologists'},
    {state:'Georgia',amount:'224,300',profession:'Anesthesiologists'},
    {state:'Idaho',amount:'256,450',profession:'Anesthesiologists'},
    {state:'Illinois',amount:'261,300',profession:'Anesthesiologists'},
    {state:'Indiana',amount:'277,000',profession:'Anesthesiologists'},
    {state:'Kentucky',amount:'278,590',profession:'Anesthesiologists'},
    {state:'Massachusetts',amount:'205,960',profession:'Anesthesiologists'},
    {state:'Michigan',amount:'261,310',profession:'Anesthesiologists'},
    {state:'Missouri',amount:'250,180',profession:'Anesthesiologists'},
    {state:'Nebraska',amount:'290,470',profession:'Anesthesiologists'},
    {state:'Nevada',amount:'256,120',profession:'Anesthesiologists'},
    {state:'New York',amount:'255,500',profession:'Anesthesiologists'},
    {state:'North Carolina',amount:'285,730',profession:'Anesthesiologists'},
    {state:'North Dakota',amount:'273,120',profession:'Anesthesiologists'},
    {state:'Ohio',amount:'285,000',profession:'Anesthesiologists'},
    {state:'Oklahoma',amount:'278,690',profession:'Anesthesiologists'},
    {state:'Pennsylvania',amount:'278,010',profession:'Anesthesiologists'},
    {state:'South Carolina',amount:'254,420',profession:'Anesthesiologists'},
    {state:'South Dakota',amount:'293,110',profession:'Anesthesiologists'},
    {state:'Tennessee',amount:'262,070',profession:'Anesthesiologists'},
    {state:'Texas',amount:'260,690',profession:'Anesthesiologists'},
    {state:'Utah',amount:'214,730',profession:'Anesthesiologists'},
    {state:'Vermont',amount:'257,240',profession:'Anesthesiologists'},
    {state:'Washington',amount:'268,580',profession:'Anesthesiologists'},
    {state:'West Virginia',amount:'281,000',profession:'Anesthesiologists'},
    {state:'Wisconsin',amount:'257,450',profession:'Anesthesiologists'},
    {state:'Wyoming',amount:'215,910',profession:'Anesthesiologists'},
    {state:'Guam',amount:'68,070',profession:'Anesthesiologists'},
    {state:'Puerto Rico',amount:'75,280',profession:'Anesthesiologists'},
    
    // Nurse Anesthetists
    {state:'Alabama',amount:'161,780',profession:'Nurse Anesthetists'},
    {state:'Alaska',amount:'187,690',profession:'Nurse Anesthetists'},
    {state:'Arizona',amount:'144,670',profession:'Nurse Anesthetists'},
    {state:'Arkansas',amount:'186,970',profession:'Nurse Anesthetists'},
    {state:'California',amount:'212,210',profession:'Nurse Anesthetists'},
    {state:'Colorado',amount:'172,700',profession:'Nurse Anesthetists'},
    {state:'Connecticut',amount:'190,480',profession:'Nurse Anesthetists'},
    {state:'Delaware',amount:'187,860',profession:'Nurse Anesthetists'},
    {state:'Florida',amount:'177,390',profession:'Nurse Anesthetists'},
    {state:'Georgia',amount:'151,070',profession:'Nurse Anesthetists'},
    {state:'Hawaii',amount:'192,580',profession:'Nurse Anesthetists'},
    {state:'Idaho',amount:'143,270',profession:'Nurse Anesthetists'},
    {state:'Illinois',amount:'190,500',profession:'Nurse Anesthetists'},
    {state:'Indiana',amount:'156,580',profession:'Nurse Anesthetists'},
    {state:'Iowa',amount:'209,130',profession:'Nurse Anesthetists'},
    {state:'Kansas',amount:'159,600',profession:'Nurse Anesthetists'},
    {state:'Kentucky',amount:'172,780',profession:'Nurse Anesthetists'},
    {state:'Louisiana',amount:'159,370',profession:'Nurse Anesthetists'},
    {state:'Maine',amount:'170,300',profession:'Nurse Anesthetists'},
    {state:'Maryland',amount:'191,160',profession:'Nurse Anesthetists'},
    {state:'Massachusetts',amount:'191,320',profession:'Nurse Anesthetists'},
    {state:'Michigan',amount:'180,560',profession:'Nurse Anesthetists'},
    {state:'Minnesota',amount:'188,130',profession:'Nurse Anesthetists'},
    {state:'Mississippi',amount:'163,320',profession:'Nurse Anesthetists'},
    {state:'Missouri',amount:'159,080',profession:'Nurse Anesthetists'},
    {state:'Montana',amount:'246,370',profession:'Nurse Anesthetists'},
    {state:'Nebraska',amount:'189,030',profession:'Nurse Anesthetists'},
    {state:'Nevada',amount:'163,220',profession:'Nurse Anesthetists'},
    {state:'New Hampshire',amount:'171,800',profession:'Nurse Anesthetists'},
    {state:'New Jersey',amount:'189,150',profession:'Nurse Anesthetists'},
    {state:'New York',amount:'191,130',profession:'Nurse Anesthetists'},
    {state:'North Carolina',amount:'178,250',profession:'Nurse Anesthetists'},
    {state:'North Dakota',amount:'197,860',profession:'Nurse Anesthetists'},
    {state:'Ohio',amount:'174,380',profession:'Nurse Anesthetists'},
    {state:'Oklahoma',amount:'176,780',profession:'Nurse Anesthetists'},
    {state:'Oregon',amount:'205,730',profession:'Nurse Anesthetists'},
    {state:'Pennsylvania',amount:'171,250',profession:'Nurse Anesthetists'},
    {state:'South Carolina',amount:'164,480',profession:'Nurse Anesthetists'},
    {state:'South Dakota',amount:'188,360',profession:'Nurse Anesthetists'},
    {state:'Tennessee',amount:'150,880',profession:'Nurse Anesthetists'},
    {state:'Texas',amount:'158,510',profession:'Nurse Anesthetists'},
    {state:'Utah',amount:'161,300',profession:'Nurse Anesthetists'},
    {state:'Virginia',amount:'187,320',profession:'Nurse Anesthetists'},
    {state:'Washington',amount:'195,610',profession:'Nurse Anesthetists'},
    {state:'West Virginia',amount:'183,080',profession:'Nurse Anesthetists'},
    {state:'Wisconsin',amount:'204,820',profession:'Nurse Anesthetists'},
    {state:'Puerto Rico',amount:'57,810',profession:'Nurse Anesthetists'},
    {state:'Wyoming',amount:'40',profession:'Nurse Anesthetists'},
    {state:'Puerto Rico',amount:'370',profession:'Nurse Anesthetists'},
    
    // Software Developers, Applications
    {state:'Alabama',amount:'96,400',profession:'Software Developers, Applications'},
    {state:'Alaska',amount:'104,970',profession:'Software Developers, Applications'},
    {state:'Arizona',amount:'98,670',profession:'Software Developers, Applications'},
    {state:'Arkansas',amount:'87,960',profession:'Software Developers, Applications'},
    {state:'California',amount:'127,950',profession:'Software Developers, Applications'},
    {state:'Colorado',amount:'106,730',profession:'Software Developers, Applications'},
    {state:'Connecticut',amount:'105,500',profession:'Software Developers, Applications'},
    {state:'Delaware',amount:'106,730',profession:'Software Developers, Applications'},
    {state:'District of Columbia',amount:'112,510',profession:'Software Developers, Applications'},
    {state:'Florida',amount:'95,610',profession:'Software Developers, Applications'},
    {state:'Georgia',amount:'105,240',profession:'Software Developers, Applications'},
    {state:'Hawaii',amount:'84,340',profession:'Software Developers, Applications'},
    {state:'Idaho',amount:'86,680',profession:'Software Developers, Applications'},
    {state:'Illinois',amount:'96,610',profession:'Software Developers, Applications'},
    {state:'Indiana',amount:'88,570',profession:'Software Developers, Applications'},
    {state:'Iowa',amount:'88,570',profession:'Software Developers, Applications'},
    {state:'Kansas',amount:'85,380',profession:'Software Developers, Applications'},
    {state:'Kentucky',amount:'86,300',profession:'Software Developers, Applications'},
    {state:'Louisiana',amount:'81,640',profession:'Software Developers, Applications'},
    {state:'Maine',amount:'90,190',profession:'Software Developers, Applications'},
    {state:'Maryland',amount:'108,850',profession:'Software Developers, Applications'},
    {state:'Massachusetts',amount:'109,130',profession:'Software Developers, Applications'},
    {state:'Michigan',amount:'92,260',profession:'Software Developers, Applications'},
    {state:'Minnesota',amount:'96,750',profession:'Software Developers, Applications'},
    {state:'Mississippi',amount:'85,470',profession:'Software Developers, Applications'},
    {state:'Missouri',amount:'93,880',profession:'Software Developers, Applications'},
    {state:'Montana',amount:'87,120',profession:'Software Developers, Applications'},
    {state:'Nebraska',amount:'87,800',profession:'Software Developers, Applications'},
    {state:'Nevada',amount:'105,640',profession:'Software Developers, Applications'},
    {state:'New Hampshire',amount:'110,740',profession:'Software Developers, Applications'},
    {state:'New Jersey',amount:'107,640',profession:'Software Developers, Applications'},
    {state:'New York',amount:'116,830',profession:'Software Developers, Applications'},
    {state:'North Carolina',amount:'103,280',profession:'Software Developers, Applications'},
    {state:'North Dakota',amount:'80,620',profession:'Software Developers, Applications'},
    {state:'Ohio',amount:'95,090',profession:'Software Developers, Applications'},
    {state:'Oklahoma',amount:'86,360',profession:'Software Developers, Applications'},
    {state:'Oregon',amount:'101,940',profession:'Software Developers, Applications'},
    {state:'Pennsylvania',amount:'96,370',profession:'Software Developers, Applications'},
    {state:'Puerto Rico',amount:'52,760',profession:'Software Developers, Applications'},
    {state:'Rhode Island',amount:'96,850',profession:'Software Developers, Applications'},
    {state:'South Carolina',amount:'90,830',profession:'Software Developers, Applications'},
    {state:'South Dakota',amount:'75,000',profession:'Software Developers, Applications'},
    {state:'Tennessee',amount:'87,630',profession:'Software Developers, Applications'},
    {state:'Texas',amount:'108,760',profession:'Software Developers, Applications'},
    {state:'Utah',amount:'99,070',profession:'Software Developers, Applications'},
    {state:'Vermont',amount:'97,720',profession:'Software Developers, Applications'},
    {state:'Virginia',amount:'113,690',profession:'Software Developers, Applications'},
    {state:'Washington',amount:'131,790',profession:'Software Developers, Applications'},
    {state:'West Virginia',amount:'87,490',profession:'Software Developers, Applications'},
    {state:'Wisconsin',amount:'87,700',profession:'Software Developers, Applications'},
    {state:'Wyoming',amount:'72,210',profession:'Software Developers, Applications'},
    
    // Software Developers, Systems Software
    {state:'Alabama',amount:'105,890',profession:'Software Developers, Systems Software'},
    {state:'Alaska',amount:'110,080',profession:'Software Developers, Systems Software'},
    {state:'Arizona',amount:'103,860',profession:'Software Developers, Systems Software'},
    {state:'Arkansas',amount:'85,830',profession:'Software Developers, Systems Software'},
    {state:'California',amount:'131,700',profession:'Software Developers, Systems Software'},
    {state:'Colorado',amount:'124,410',profession:'Software Developers, Systems Software'},
    {state:'Connecticut',amount:'102,440',profession:'Software Developers, Systems Software'},
    {state:'District of Columbia',amount:'115,610',profession:'Software Developers, Systems Software'},
    {state:'Florida',amount:'102,590',profession:'Software Developers, Systems Software'},
    {state:'Georgia',amount:'105,100',profession:'Software Developers, Systems Software'},
    {state:'Hawaii',amount:'97,510',profession:'Software Developers, Systems Software'},
    {state:'Idaho',amount:'97,310',profession:'Software Developers, Systems Software'},
    {state:'Illinois',amount:'108,570',profession:'Software Developers, Systems Software'},
    {state:'Indiana',amount:'90,850',profession:'Software Developers, Systems Software'},
    {state:'Iowa',amount:'91,920',profession:'Software Developers, Systems Software'},
    {state:'Kansas',amount:'94,240',profession:'Software Developers, Systems Software'},
    {state:'Kentucky',amount:'84,300',profession:'Software Developers, Systems Software'},
    {state:'Louisiana',amount:'76,200',profession:'Software Developers, Systems Software'},
    {state:'Maine',amount:'98,580',profession:'Software Developers, Systems Software'},
    {state:'Maryland',amount:'119,860',profession:'Software Developers, Systems Software'},
    {state:'Massachusetts',amount:'117,760',profession:'Software Developers, Systems Software'},
    {state:'Michigan',amount:'88,560',profession:'Software Developers, Systems Software'},
    {state:'Minnesota',amount:'110,460',profession:'Software Developers, Systems Software'},
    {state:'Mississippi',amount:'86,360',profession:'Software Developers, Systems Software'},
    {state:'Missouri',amount:'94,140',profession:'Software Developers, Systems Software'},
    {state:'Montana',amount:'77,560',profession:'Software Developers, Systems Software'},
    {state:'Nebraska',amount:'94,620',profession:'Software Developers, Systems Software'},
    {state:'Nevada',amount:'100,510',profession:'Software Developers, Systems Software'},
    {state:'New Hampshire',amount:'126,790',profession:'Software Developers, Systems Software'},
    {state:'New Jersey',amount:'123,370',profession:'Software Developers, Systems Software'},
    {state:'New Mexico',amount:'94,690',profession:'Software Developers, Systems Software'},
    {state:'New York',amount:'115,120',profession:'Software Developers, Systems Software'},
    {state:'North Carolina',amount:'105,760',profession:'Software Developers, Systems Software'},
    {state:'North Dakota',amount:'75,030',profession:'Software Developers, Systems Software'},
    {state:'Ohio',amount:'101,570',profession:'Software Developers, Systems Software'},
    {state:'Oklahoma',amount:'90,200',profession:'Software Developers, Systems Software'},
    {state:'Oregon',amount:'104,760',profession:'Software Developers, Systems Software'},
    {state:'Pennsylvania',amount:'103,520',profession:'Software Developers, Systems Software'},
    {state:'Puerto Rico',amount:'60,750',profession:'Software Developers, Systems Software'},
    {state:'Rhode Island',amount:'103,930',profession:'Software Developers, Systems Software'},
    {state:'South Carolina',amount:'80,250',profession:'Software Developers, Systems Software'},
    {state:'South Dakota',amount:'90,430',profession:'Software Developers, Systems Software'},
    {state:'Tennessee',amount:'92,700',profession:'Software Developers, Systems Software'},
    {state:'Texas',amount:'110,740',profession:'Software Developers, Systems Software'},
    {state:'Utah',amount:'106,040',profession:'Software Developers, Systems Software'},
    {state:'Vermont',amount:'99,370',profession:'Software Developers, Systems Software'},
    {state:'Virginia',amount:'119,860',profession:'Software Developers, Systems Software'},
    {state:'Washington',amount:'121,250',profession:'Software Developers, Systems Software'},
    {state:'West Virginia',amount:'100,170',profession:'Software Developers, Systems Software'},
    {state:'Wisconsin',amount:'90,660',profession:'Software Developers, Systems Software'},
    {state:'Wyoming',amount:'88,310',profession:'Software Developers, Systems Software'},
    
    // Statisticians
    {state:'Alabama',amount:'61,860',profession:'Statisticians'},
    {state:'Alaska',amount:'87,020',profession:'Statisticians'},
    {state:'Arizona',amount:'80,330',profession:'Statisticians'},
    {state:'Arkansas',amount:'76,630',profession:'Statisticians'},
    {state:'California',amount:'99,860',profession:'Statisticians'},
    {state:'Colorado',amount:'84,380',profession:'Statisticians'},
    {state:'Connecticut',amount:'101,820',profession:'Statisticians'},
    {state:'Delaware',amount:'100,710',profession:'Statisticians'},
    {state:'District of Columbia',amount:'104,310',profession:'Statisticians'},
    {state:'Florida',amount:'81,960',profession:'Statisticians'},
    {state:'Georgia',amount:'92,800',profession:'Statisticians'},
    {state:'Hawaii',amount:'71,040',profession:'Statisticians'},
    {state:'Idaho',amount:'113,780',profession:'Statisticians'},
    {state:'Illinois',amount:'89,040',profession:'Statisticians'},
    {state:'Indiana',amount:'74,870',profession:'Statisticians'},
    {state:'Iowa',amount:'74,430',profession:'Statisticians'},
    {state:'Kansas',amount:'89,250',profession:'Statisticians'},
    {state:'Kentucky',amount:'79,640',profession:'Statisticians'},
    {state:'Louisiana',amount:'76,120',profession:'Statisticians'},
    {state:'Maine',amount:'73,560',profession:'Statisticians'},
    {state:'Maryland',amount:'107,400',profession:'Statisticians'},
    {state:'Massachusetts',amount:'108,670',profession:'Statisticians'},
    {state:'Michigan',amount:'80,920',profession:'Statisticians'},
    {state:'Minnesota',amount:'95,930',profession:'Statisticians'},
    {state:'Mississippi',amount:'65,510',profession:'Statisticians'},
    {state:'Missouri',amount:'71,150',profession:'Statisticians'},
    {state:'Nebraska',amount:'67,080',profession:'Statisticians'},
    {state:'Nevada',amount:'71,210',profession:'Statisticians'},
    {state:'New Hampshire',amount:'75,880',profession:'Statisticians'},
    {state:'New Jersey',amount:'116,090',profession:'Statisticians'},
    {state:'New Mexico',amount:'81,100',profession:'Statisticians'},
    {state:'New York',amount:'95,870',profession:'Statisticians'},
    {state:'North Carolina',amount:'101,010',profession:'Statisticians'},
    {state:'North Dakota',amount:'75,230',profession:'Statisticians'},
    {state:'Ohio',amount:'82,180',profession:'Statisticians'},
    {state:'Oklahoma',amount:'63,120',profession:'Statisticians'},
    {state:'Oregon',amount:'80,920',profession:'Statisticians'},
    {state:'Pennsylvania',amount:'85,180',profession:'Statisticians'},
    {state:'South Carolina',amount:'68,320',profession:'Statisticians'},
    {state:'Tennessee',amount:'74,450',profession:'Statisticians'},
    {state:'Texas',amount:'84,940',profession:'Statisticians'},
    {state:'Utah',amount:'75,000',profession:'Statisticians'},
    {state:'Vermont',amount:'69,750',profession:'Statisticians'},
    {state:'Virginia',amount:'87,700',profession:'Statisticians'},
    {state:'Washington',amount:'100,670',profession:'Statisticians'},
    {state:'West Virginia',amount:'76,070',profession:'Statisticians'},
    {state:'Wisconsin',amount:'82,330',profession:'Statisticians'},
    {state:'Wyoming',amount:'*',profession:'Statisticians'},
    {state:'Puerto Rico',amount:'38,460',profession:'Statisticians'},
    
    // Physician Assistants
    {state:'Alabama',amount:'92,880',profession:'Physician Assistants'},
    {state:'Alaska',amount:'122,260',profession:'Physician Assistants'},
    {state:'Arizona',amount:'101,590',profession:'Physician Assistants'},
    {state:'Arkansas',amount:'99,280',profession:'Physician Assistants'},
    {state:'California',amount:'117,230',profession:'Physician Assistants'},
    {state:'Colorado',amount:'102,770',profession:'Physician Assistants'},
    {state:'Connecticut',amount:'125,610',profession:'Physician Assistants'},
    {state:'Delaware',amount:'105,300',profession:'Physician Assistants'},
    {state:'District of Columbia',amount:'114,740',profession:'Physician Assistants'},
    {state:'Florida',amount:'105,930',profession:'Physician Assistants'},
    {state:'Georgia',amount:'103,190',profession:'Physician Assistants'},
    {state:'Hawaii',amount:'121,120',profession:'Physician Assistants'},
    {state:'Idaho',amount:'109,090',profession:'Physician Assistants'},
    {state:'Illinois',amount:'108,260',profession:'Physician Assistants'},
    {state:'Indiana',amount:'96,090',profession:'Physician Assistants'},
    {state:'Iowa',amount:'110,550',profession:'Physician Assistants'},
    {state:'Kansas',amount:'104,720',profession:'Physician Assistants'},
    {state:'Kentucky',amount:'91,010',profession:'Physician Assistants'},
    {state:'Louisiana',amount:'85,990',profession:'Physician Assistants'},
    {state:'Maine',amount:'110,030',profession:'Physician Assistants'},
    {state:'Maryland',amount:'108,180',profession:'Physician Assistants'},
    {state:'Massachusetts',amount:'108,700',profession:'Physician Assistants'},
    {state:'Michigan',amount:'110,240',profession:'Physician Assistants'},
    {state:'Minnesota',amount:'116,200',profession:'Physician Assistants'},
    {state:'Mississippi',amount:'81,130',profession:'Physician Assistants'},
    {state:'Missouri',amount:'94,480',profession:'Physician Assistants'},
    {state:'Montana',amount:'106,130',profession:'Physician Assistants'},
    {state:'Nebraska',amount:'106,700',profession:'Physician Assistants'},
    {state:'Nevada',amount:'116,850',profession:'Physician Assistants'},
    {state:'New Hampshire',amount:'111,080',profession:'Physician Assistants'},
    {state:'New Jersey',amount:'116,270',profession:'Physician Assistants'},
    {state:'New Mexico',amount:'108,610',profession:'Physician Assistants'},
    {state:'New York',amount:'117,000',profession:'Physician Assistants'},
    {state:'North Carolina',amount:'104,680',profession:'Physician Assistants'},
    {state:'North Dakota',amount:'107,340',profession:'Physician Assistants'},
    {state:'Ohio',amount:'105,410',profession:'Physician Assistants'},
    {state:'Oklahoma',amount:'104,200',profession:'Physician Assistants'},
    {state:'Oregon',amount:'113,570',profession:'Physician Assistants'},
    {state:'Pennsylvania',amount:'98,510',profession:'Physician Assistants'},
    {state:'Rhode Island',amount:'103,710',profession:'Physician Assistants'},
    {state:'South Carolina',amount:'103,710',profession:'Physician Assistants'},
    {state:'South Dakota',amount:'102,830',profession:'Physician Assistants'},
    {state:'Tennessee',amount:'87,700',profession:'Physician Assistants'},
    {state:'Texas',amount:'109,590',profession:'Physician Assistants'},
    {state:'Utah',amount:'102,710',profession:'Physician Assistants'},
    {state:'Vermont',amount:'106,520',profession:'Physician Assistants'},
    {state:'Virginia',amount:'99,340',profession:'Physician Assistants'},
    {state:'Washington',amount:'123,980',profession:'Physician Assistants'},
    {state:'West Virginia',amount:'104,180',profession:'Physician Assistants'},
    {state:'Wisconsin',amount:'107,920',profession:'Physician Assistants'},
    {state:'Wyoming',amount:'116,890',profession:'Physician Assistants'},
    {state:'Puerto Rico',amount:'30,200',profession:'Physician Assistants'},
    
    // Dentists, General
    {state:'Alabama',amount:'171,900',profession:'Dentists, General'},
    {state:'Alaska',amount:'259,350',profession:'Dentists, General'},
    {state:'Arizona',amount:'186,870',profession:'Dentists, General'},
    {state:'Arkansas',amount:'165,480',profession:'Dentists, General'},
    {state:'California',amount:'151,490',profession:'Dentists, General'},
    {state:'Colorado',amount:'174,930',profession:'Dentists, General'},
    {state:'Connecticut',amount:'213,390',profession:'Dentists, General'},
    {state:'Delaware',amount:'264,440',profession:'Dentists, General'},
    {state:'District of Columbia',amount:'183,630',profession:'Dentists, General'},
    {state:'Florida',amount:'167,270',profession:'Dentists, General'},
    {state:'Georgia',amount:'176,600',profession:'Dentists, General'},
    {state:'Hawaii',amount:'196,690',profession:'Dentists, General'},
    {state:'Idaho',amount:'172,020',profession:'Dentists, General'},
    {state:'Illinois',amount:'171,590',profession:'Dentists, General'},
    {state:'Indiana',amount:'183,800',profession:'Dentists, General'},
    {state:'Iowa',amount:'187,570',profession:'Dentists, General'},
    {state:'Kansas',amount:'179,100',profession:'Dentists, General'},
    {state:'Kentucky',amount:'154,230',profession:'Dentists, General'},
    {state:'Louisiana',amount:'124,020',profession:'Dentists, General'},
    {state:'Maine',amount:'203,920',profession:'Dentists, General'},
    {state:'Maryland',amount:'151,950',profession:'Dentists, General'},
    {state:'Massachusetts',amount:'177,410',profession:'Dentists, General'},
    {state:'Michigan',amount:'197,490',profession:'Dentists, General'},
    {state:'Minnesota',amount:'227,280',profession:'Dentists, General'},
    {state:'Mississippi',amount:'153,810',profession:'Dentists, General'},
    {state:'Missouri',amount:'191,240',profession:'Dentists, General'},
    {state:'Montana',amount:'170,260',profession:'Dentists, General'},
    {state:'Nebraska',amount:'135,080',profession:'Dentists, General'},
    {state:'Nevada',amount:'210,710',profession:'Dentists, General'},
    {state:'New Hampshire',amount:'226,300',profession:'Dentists, General'},
    {state:'New Jersey',amount:'169,990',profession:'Dentists, General'},
    {state:'New Mexico',amount:'173,610',profession:'Dentists, General'},
    {state:'New York',amount:'164,520',profession:'Dentists, General'},
    {state:'North Carolina',amount:'212,160',profession:'Dentists, General'},
    {state:'North Dakota',amount:'212,380',profession:'Dentists, General'},
    {state:'Ohio',amount:'197,150',profession:'Dentists, General'},
    {state:'Oklahoma',amount:'156,060',profession:'Dentists, General'},
    {state:'Oregon',amount:'190,690',profession:'Dentists, General'},
    {state:'Pennsylvania',amount:'153,950',profession:'Dentists, General'},
    {state:'Rhode Island',amount:'254,190',profession:'Dentists, General'},
    {state:'South Carolina',amount:'172,780',profession:'Dentists, General'},
    {state:'South Dakota',amount:'198,170',profession:'Dentists, General'},
    {state:'Tennessee',amount:'186,670',profession:'Dentists, General'},
    {state:'Texas',amount:'185,680',profession:'Dentists, General'},
    {state:'Utah',amount:'138,970',profession:'Dentists, General'},
    {state:'Virginia',amount:'199,870',profession:'Dentists, General'},
    {state:'Washington',amount:'184,780',profession:'Dentists, General'},
    {state:'West Virginia',amount:'139,170',profession:'Dentists, General'},
    {state:'Wisconsin',amount:'213,210',profession:'Dentists, General'},
    {state:'Wyoming',amount:'125,120',profession:'Dentists, General'},
    {state:'Puerto Rico',amount:'54,670',profession:'Dentists, General'},
    
    // Orthodontists
    {state:'California',amount:'197,390',profession:'Orthodontists'},
    {state:'Colorado',amount:'230,400',profession:'Orthodontists'},
    {state:'Connecticut',amount:'211,240',profession:'Orthodontists'},
    {state:'Florida',amount:'204,750',profession:'Orthodontists'},
    {state:'Idaho',amount:'202,030',profession:'Orthodontists'},
    {state:'Illinois',amount:'199,050',profession:'Orthodontists'},
    {state:'Indiana',amount:'232,900',profession:'Orthodontists'},
    {state:'Iowa',amount:'267,870',profession:'Orthodontists'},
    {state:'Kentucky',amount:'139,450',profession:'Orthodontists'},
    {state:'Louisiana',amount:'129,830',profession:'Orthodontists'},
    {state:'Maryland',amount:'199,210',profession:'Orthodontists'},
    {state:'Massachusetts',amount:'282,740',profession:'Orthodontists'},
    {state:'Michigan',amount:'217,730',profession:'Orthodontists'},
    {state:'Montana',amount:'187,130',profession:'Orthodontists'},
    {state:'New Jersey',amount:'274,400',profession:'Orthodontists'},
    {state:'New Mexico',amount:'193,750',profession:'Orthodontists'},
    {state:'New York',amount:'250,890',profession:'Orthodontists'},
    {state:'North Carolina',amount:'276,550',profession:'Orthodontists'},
    {state:'Ohio',amount:'228,420',profession:'Orthodontists'},
    {state:'Oklahoma',amount:'261,650',profession:'Orthodontists'},
    {state:'Pennsylvania',amount:'258,940',profession:'Orthodontists'},
    {state:'South Carolina',amount:'279,610',profession:'Orthodontists'},
    {state:'Tennessee',amount:'219,860',profession:'Orthodontists'},
    {state:'Texas',amount:'188,190',profession:'Orthodontists'},
    {state:'Utah',amount:'113,710',profession:'Orthodontists'},
    {state:'Wisconsin',amount:'209,880',profession:'Orthodontists'},
    
    // Nurse Practitioners
    {state:'Alabama',amount:'95,970',profession:'Nurse Practitioners'},
    {state:'Alaska',amount:'122,880',profession:'Nurse Practitioners'},
    {state:'Arizona',amount:'110,750',profession:'Nurse Practitioners'},
    {state:'Arkansas',amount:'104,300',profession:'Nurse Practitioners'},
    {state:'California',amount:'133,780',profession:'Nurse Practitioners'},
    {state:'Colorado',amount:'111,210',profession:'Nurse Practitioners'},
    {state:'Connecticut',amount:'118,020',profession:'Nurse Practitioners'},
    {state:'Delaware',amount:'108,340',profession:'Nurse Practitioners'},
    {state:'District of Columbia',amount:'109,800',profession:'Nurse Practitioners'},
    {state:'Florida',amount:'101,100',profession:'Nurse Practitioners'},
    {state:'Georgia',amount:'106,750',profession:'Nurse Practitioners'},
    {state:'Hawaii',amount:'120,570',profession:'Nurse Practitioners'},
    {state:'Idaho',amount:'102,600',profession:'Nurse Practitioners'},
    {state:'Illinois',amount:'105,800',profession:'Nurse Practitioners'},
    {state:'Indiana',amount:'103,200',profession:'Nurse Practitioners'},
    {state:'Iowa',amount:'106,290',profession:'Nurse Practitioners'},
    {state:'Kansas',amount:'99,430',profession:'Nurse Practitioners'},
    {state:'Kentucky',amount:'99,790',profession:'Nurse Practitioners'},
    {state:'Louisiana',amount:'105,340',profession:'Nurse Practitioners'},
    {state:'Maine',amount:'103,220',profession:'Nurse Practitioners'},
    {state:'Maryland',amount:'115,060',profession:'Nurse Practitioners'},
    {state:'Massachusetts',amount:'122,740',profession:'Nurse Practitioners'},
    {state:'Michigan',amount:'106,880',profession:'Nurse Practitioners'},
    {state:'Minnesota',amount:'119,160',profession:'Nurse Practitioners'},
    {state:'Mississippi',amount:'109,700',profession:'Nurse Practitioners'},
    {state:'Missouri',amount:'102,470',profession:'Nurse Practitioners'},
    {state:'Montana',amount:'103,510',profession:'Nurse Practitioners'},
    {state:'Nebraska',amount:'103,800',profession:'Nurse Practitioners'},
    {state:'Nevada',amount:'112,540',profession:'Nurse Practitioners'},
    {state:'New Hampshire',amount:'109,460',profession:'Nurse Practitioners'},
    {state:'New Jersey',amount:'122,100',profession:'Nurse Practitioners'},
    {state:'New Mexico',amount:'109,810',profession:'Nurse Practitioners'},
    {state:'New York',amount:'120,970',profession:'Nurse Practitioners'},
    {state:'North Carolina',amount:'104,100',profession:'Nurse Practitioners'},
    {state:'North Dakota',amount:'106,200',profession:'Nurse Practitioners'},
    {state:'Ohio',amount:'101,970',profession:'Nurse Practitioners'},
    {state:'Oklahoma',amount:'103,280',profession:'Nurse Practitioners'},
    {state:'Oregon',amount:'110,010',profession:'Nurse Practitioners'},
    {state:'Pennsylvania',amount:'98,250',profession:'Nurse Practitioners'},
    {state:'Rhode Island',amount:'109,290',profession:'Nurse Practitioners'},
    {state:'South Carolina',amount:'99,910',profession:'Nurse Practitioners'},
    {state:'South Dakota',amount:'100,690',profession:'Nurse Practitioners'},
    {state:'Tennessee',amount:'95,990',profession:'Nurse Practitioners'},
    {state:'Texas',amount:'111,060',profession:'Nurse Practitioners'},
    {state:'Utah',amount:'105,840',profession:'Nurse Practitioners'},
    {state:'Vermont',amount:'106,000',profession:'Nurse Practitioners'},
    {state:'Virginia',amount:'105,170',profession:'Nurse Practitioners'},
    {state:'Washington',amount:'117,650',profession:'Nurse Practitioners'},
    {state:'West Virginia',amount:'100,690',profession:'Nurse Practitioners'},
    {state:'Wisconsin',amount:'106,790',profession:'Nurse Practitioners'},
    {state:'Wyoming',amount:'116,030',profession:'Nurse Practitioners'},
    {state:'Puerto Rico',amount:'20,910',profession:'Nurse Practitioners'},
    
    // Pediatricians, General
    {state:'Alabama',amount:'220,910',profession:'Pediatricians, General'},
    {state:'Alaska',amount:'268,010',profession:'Pediatricians, General'},
    {state:'Arizona',amount:'151,420',profession:'Pediatricians, General'},
    {state:'Arkansas',amount:'198,660',profession:'Pediatricians, General'},
    {state:'California',amount:'185,910',profession:'Pediatricians, General'},
    {state:'Colorado',amount:'185,770',profession:'Pediatricians, General'},
    {state:'Connecticut',amount:'205,420',profession:'Pediatricians, General'},
    {state:'Delaware',amount:'211,370',profession:'Pediatricians, General'},
    {state:'District of Columbia',amount:'123,020',profession:'Pediatricians, General'},
    {state:'Florida',amount:'153,630',profession:'Pediatricians, General'},
    {state:'Georgia',amount:'181,000',profession:'Pediatricians, General'},
    {state:'Hawaii',amount:'174,390',profession:'Pediatricians, General'},
    {state:'Idaho',amount:'172,080',profession:'Pediatricians, General'},
    {state:'Illinois',amount:'147,250',profession:'Pediatricians, General'},
    {state:'Indiana',amount:'198,100',profession:'Pediatricians, General'},
    {state:'Iowa',amount:'237,030',profession:'Pediatricians, General'},
    {state:'Kansas',amount:'126,740',profession:'Pediatricians, General'},
    {state:'Kentucky',amount:'183,140',profession:'Pediatricians, General'},
    {state:'Louisiana',amount:'156,960',profession:'Pediatricians, General'},
    {state:'Maine',amount:'191,060',profession:'Pediatricians, General'},
    {state:'Maryland',amount:'168,580',profession:'Pediatricians, General'},
    {state:'Massachusetts',amount:'198,340',profession:'Pediatricians, General'},
    {state:'Michigan',amount:'132,310',profession:'Pediatricians, General'},
    {state:'Minnesota',amount:'216,450',profession:'Pediatricians, General'},
    {state:'Mississippi',amount:'258,910',profession:'Pediatricians, General'},
    {state:'Missouri',amount:'209,920',profession:'Pediatricians, General'},
    {state:'Montana',amount:'248,370',profession:'Pediatricians, General'},
    {state:'Nebraska',amount:'156,520',profession:'Pediatricians, General'},
    {state:'Nevada',amount:'258,750',profession:'Pediatricians, General'},
    {state:'New Hampshire',amount:'217,810',profession:'Pediatricians, General'},
    {state:'New Jersey',amount:'188,880',profession:'Pediatricians, General'},
    {state:'New Mexico',amount:'187,980',profession:'Pediatricians, General'},
    {state:'New York',amount:'178,680',profession:'Pediatricians, General'},
    {state:'North Carolina',amount:'175,050',profession:'Pediatricians, General'},
    {state:'Ohio',amount:'162,870',profession:'Pediatricians, General'},
    {state:'Oregon',amount:'198,300',profession:'Pediatricians, General'},
    {state:'Pennsylvania',amount:'162,990',profession:'Pediatricians, General'},
    {state:'Rhode Island',amount:'199,170',profession:'Pediatricians, General'},
    {state:'South Carolina',amount:'155,780',profession:'Pediatricians, General'},
    {state:'South Dakota',amount:'211,230',profession:'Pediatricians, General'},
    {state:'Tennessee',amount:'190,040',profession:'Pediatricians, General'},
    {state:'Texas',amount:'187,350',profession:'Pediatricians, General'},
    {state:'Utah',amount:'240,060',profession:'Pediatricians, General'},
    {state:'Vermont',amount:'163,930',profession:'Pediatricians, General'},
    {state:'Virginia',amount:'198,770',profession:'Pediatricians, General'},
    {state:'Washington',amount:'183,730',profession:'Pediatricians, General'},
    {state:'Wisconsin',amount:'266,160',profession:'Pediatricians, General'},
    {state:'Wyoming',amount:'212,070',profession:'Pediatricians, General'},
    {state:'Puerto Rico',amount:'79,500',profession:'Pediatricians, General'},
    
    // Obstetricians and Gynecologists
    {state:'Alabama',amount:'284,380',profession:'Obstetricians and Gynecologists'},
    {state:'Alaska',amount:'281,170',profession:'Obstetricians and Gynecologists'},
    {state:'Arizona',amount:'221,820',profession:'Obstetricians and Gynecologists'},
    {state:'Arkansas',amount:'205,650',profession:'Obstetricians and Gynecologists'},
    {state:'California',amount:'216,800',profession:'Obstetricians and Gynecologists'},
    {state:'Colorado',amount:'286,560',profession:'Obstetricians and Gynecologists'},
    {state:'Connecticut',amount:'272,080',profession:'Obstetricians and Gynecologists'},
    {state:'Delaware',amount:'268,530',profession:'Obstetricians and Gynecologists'},
    {state:'District of Columbia',amount:'225,260',profession:'Obstetricians and Gynecologists'},
    {state:'Florida',amount:'255,530',profession:'Obstetricians and Gynecologists'},
    {state:'Georgia',amount:'242,220',profession:'Obstetricians and Gynecologists'},
    {state:'Hawaii',amount:'237,050',profession:'Obstetricians and Gynecologists'},
    {state:'Illinois',amount:'201,940',profession:'Obstetricians and Gynecologists'},
    {state:'Indiana',amount:'285,180',profession:'Obstetricians and Gynecologists'},
    {state:'Iowa',amount:'254,100',profession:'Obstetricians and Gynecologists'},
    {state:'Kansas',amount:'190,050',profession:'Obstetricians and Gynecologists'},
    {state:'Kentucky',amount:'263,820',profession:'Obstetricians and Gynecologists'},
    {state:'Maine',amount:'206,150',profession:'Obstetricians and Gynecologists'},
    {state:'Maryland',amount:'205,060',profession:'Obstetricians and Gynecologists'},
    {state:'Massachusetts',amount:'254,530',profession:'Obstetricians and Gynecologists'},
    {state:'Michigan',amount:'175,330',profession:'Obstetricians and Gynecologists'},
    {state:'Minnesota',amount:'247,360',profession:'Obstetricians and Gynecologists'},
    {state:'Mississippi',amount:'234,160',profession:'Obstetricians and Gynecologists'},
    {state:'Missouri',amount:'203,480',profession:'Obstetricians and Gynecologists'},
    {state:'Montana',amount:'265,440',profession:'Obstetricians and Gynecologists'},
    {state:'Nebraska',amount:'241,350',profession:'Obstetricians and Gynecologists'},
    {state:'New Hampshire',amount:'252,860',profession:'Obstetricians and Gynecologists'},
    {state:'New Jersey',amount:'267,990',profession:'Obstetricians and Gynecologists'},
    {state:'New Mexico',amount:'287,680',profession:'Obstetricians and Gynecologists'},
    {state:'New York',amount:'230,250',profession:'Obstetricians and Gynecologists'},
    {state:'North Carolina',amount:'255,100',profession:'Obstetricians and Gynecologists'},
    {state:'Ohio',amount:'255,560',profession:'Obstetricians and Gynecologists'},
    {state:'Oklahoma',amount:'214,640',profession:'Obstetricians and Gynecologists'},
    {state:'Oregon',amount:'232,430',profession:'Obstetricians and Gynecologists'},
    {state:'Pennsylvania',amount:'251,640',profession:'Obstetricians and Gynecologists'},
    {state:'Rhode Island',amount:'266,280',profession:'Obstetricians and Gynecologists'},
    {state:'South Carolina',amount:'283,910',profession:'Obstetricians and Gynecologists'},
    {state:'South Dakota',amount:'274,250',profession:'Obstetricians and Gynecologists'},
    {state:'Tennessee',amount:'201,690',profession:'Obstetricians and Gynecologists'},
    {state:'Texas',amount:'215,300',profession:'Obstetricians and Gynecologists'},
    {state:'Utah',amount:'256,950',profession:'Obstetricians and Gynecologists'},
    {state:'Vermont',amount:'230,380',profession:'Obstetricians and Gynecologists'},
    {state:'Virginia',amount:'225,630',profession:'Obstetricians and Gynecologists'},
    {state:'Washington',amount:'259,620',profession:'Obstetricians and Gynecologists'},
    {state:'Wisconsin',amount:'278,730',profession:'Obstetricians and Gynecologists'},
    {state:'Wyoming',amount:'265,190',profession:'Obstetricians and Gynecologists'},
    {state:'Wyoming',amount:'60',profession:'Obstetricians and Gynecologists'},
    
    // Oral and Maxillofacial Surgeons
    {state:'California',amount:'264,380',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Indiana',amount:'272,360',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Iowa',amount:'263,270',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Kentucky',amount:'188,750',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Maryland',amount:'276,280',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Michigan',amount:'220,660',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Nebraska',amount:'266,810',profession:'Oral and Maxillofacial Surgeons'},
    {state:'New Mexico',amount:'54,120',profession:'Oral and Maxillofacial Surgeons'},
    {state:'New York',amount:'249,460',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Oklahoma',amount:'229,300',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Pennsylvania',amount:'225,660',profession:'Oral and Maxillofacial Surgeons'},
    {state:'South Carolina',amount:'256,650',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Tennessee',amount:'163,220',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Texas',amount:'181,260',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Virginia',amount:'260,810',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Wisconsin',amount:'187,400',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Virginia',amount:'180',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Washington',amount:'40',profession:'Oral and Maxillofacial Surgeons'},
    {state:'Wisconsin',amount:'80',profession:'Oral and Maxillofacial Surgeons'},
    
    // Physicians and Surgeons, All Other
    {state:'Alabama',amount:'183,510',profession:'Physicians and Surgeons, All Other'},
    {state:'Alaska',amount:'244,220',profession:'Physicians and Surgeons, All Other'},
    {state:'Arizona',amount:'229,090',profession:'Physicians and Surgeons, All Other'},
    {state:'Arkansas',amount:'165,290',profession:'Physicians and Surgeons, All Other'},
    {state:'California',amount:'208,740',profession:'Physicians and Surgeons, All Other'},
    {state:'Colorado',amount:'219,310',profession:'Physicians and Surgeons, All Other'},
    {state:'Connecticut',amount:'221,870',profession:'Physicians and Surgeons, All Other'},
    {state:'Delaware',amount:'216,600',profession:'Physicians and Surgeons, All Other'},
    {state:'District of Columbia',amount:'182,910',profession:'Physicians and Surgeons, All Other'},
    {state:'Florida',amount:'205,020',profession:'Physicians and Surgeons, All Other'},
    {state:'Georgia',amount:'235,060',profession:'Physicians and Surgeons, All Other'},
    {state:'Hawaii',amount:'228,470',profession:'Physicians and Surgeons, All Other'},
    {state:'Idaho',amount:'241,670',profession:'Physicians and Surgeons, All Other'},
    {state:'Illinois',amount:'183,780',profession:'Physicians and Surgeons, All Other'},
    {state:'Indiana',amount:'237,470',profession:'Physicians and Surgeons, All Other'},
    {state:'Iowa',amount:'219,300',profession:'Physicians and Surgeons, All Other'},
    {state:'Kansas',amount:'191,430',profession:'Physicians and Surgeons, All Other'},
    {state:'Kentucky',amount:'223,770',profession:'Physicians and Surgeons, All Other'},
    {state:'Louisiana',amount:'183,920',profession:'Physicians and Surgeons, All Other'},
    {state:'Maine',amount:'257,550',profession:'Physicians and Surgeons, All Other'},
    {state:'Maryland',amount:'196,210',profession:'Physicians and Surgeons, All Other'},
    {state:'Massachusetts',amount:'207,990',profession:'Physicians and Surgeons, All Other'},
    {state:'Michigan',amount:'181,760',profession:'Physicians and Surgeons, All Other'},
    {state:'Minnesota',amount:'245,040',profession:'Physicians and Surgeons, All Other'},
    {state:'Mississippi',amount:'174,340',profession:'Physicians and Surgeons, All Other'},
    {state:'Missouri',amount:'203,440',profession:'Physicians and Surgeons, All Other'},
    {state:'Montana',amount:'247,260',profession:'Physicians and Surgeons, All Other'},
    {state:'Nebraska',amount:'161,880',profession:'Physicians and Surgeons, All Other'},
    {state:'Nevada',amount:'227,500',profession:'Physicians and Surgeons, All Other'},
    {state:'New Hampshire',amount:'275,840',profession:'Physicians and Surgeons, All Other'},
    {state:'New Jersey',amount:'208,820',profession:'Physicians and Surgeons, All Other'},
    {state:'New Mexico',amount:'229,100',profession:'Physicians and Surgeons, All Other'},
    {state:'New York',amount:'171,060',profession:'Physicians and Surgeons, All Other'},
    {state:'North Carolina',amount:'198,040',profession:'Physicians and Surgeons, All Other'},
    {state:'North Dakota',amount:'266,510',profession:'Physicians and Surgeons, All Other'},
    {state:'Ohio',amount:'212,160',profession:'Physicians and Surgeons, All Other'},
    {state:'Oklahoma',amount:'155,130',profession:'Physicians and Surgeons, All Other'},
    {state:'Oregon',amount:'202,750',profession:'Physicians and Surgeons, All Other'},
    {state:'Pennsylvania',amount:'195,810',profession:'Physicians and Surgeons, All Other'},
    {state:'Rhode Island',amount:'209,580',profession:'Physicians and Surgeons, All Other'},
    {state:'South Carolina',amount:'185,210',profession:'Physicians and Surgeons, All Other'},
    {state:'South Dakota',amount:'227,710',profession:'Physicians and Surgeons, All Other'},
    {state:'Tennessee',amount:'231,960',profession:'Physicians and Surgeons, All Other'},
    {state:'Texas',amount:'199,370',profession:'Physicians and Surgeons, All Other'},
    {state:'Utah',amount:'218,210',profession:'Physicians and Surgeons, All Other'},
    {state:'Vermont',amount:'176,520',profession:'Physicians and Surgeons, All Other'},
    {state:'Virginia',amount:'199,080',profession:'Physicians and Surgeons, All Other'},
    {state:'Washington',amount:'239,080',profession:'Physicians and Surgeons, All Other'},
    {state:'West Virginia',amount:'222,270',profession:'Physicians and Surgeons, All Other'},
    {state:'Wisconsin',amount:'239,610',profession:'Physicians and Surgeons, All Other'},
    {state:'Wyoming',amount:'234,610',profession:'Physicians and Surgeons, All Other'},
    {state:'Puerto Rico',amount:'94,060',profession:'Physicians and Surgeons, All Other'},
    {state:'Virgin Islands',amount:'137,000',profession:'Physicians and Surgeons, All Other'},

    // Prosthodontists
    {state:'Florida',amount:'217,410',profession:'Prosthodontists'},
    {state:'Virginia',amount:'190,340',profession:'Prosthodontists'},
    
    // Occupational Therapists
    {state:'Alabama',amount:'83,810',profession:'Occupational Therapists'},
    {state:'Alaska',amount:'86,860',profession:'Occupational Therapists'},
    {state:'Arizona',amount:'94,800',profession:'Occupational Therapists'},
    {state:'Arkansas',amount:'81,810',profession:'Occupational Therapists'},
    {state:'California',amount:'95,160',profession:'Occupational Therapists'},
    {state:'Colorado',amount:'89,770',profession:'Occupational Therapists'},
    {state:'Connecticut',amount:'90,780',profession:'Occupational Therapists'},
    {state:'Delaware',amount:'86,020',profession:'Occupational Therapists'},
    {state:'District of Columbia',amount:'94,360',profession:'Occupational Therapists'},
    {state:'Florida',amount:'81,520',profession:'Occupational Therapists'},
    {state:'Georgia',amount:'82,060',profession:'Occupational Therapists'},
    {state:'Hawaii',amount:'83,010',profession:'Occupational Therapists'},
    {state:'Idaho',amount:'81,230',profession:'Occupational Therapists'},
    {state:'Illinois',amount:'83,940',profession:'Occupational Therapists'},
    {state:'Indiana',amount:'79,870',profession:'Occupational Therapists'},
    {state:'Iowa',amount:'80,740',profession:'Occupational Therapists'},
    {state:'Kansas',amount:'78,720',profession:'Occupational Therapists'},
    {state:'Kentucky',amount:'79,460',profession:'Occupational Therapists'},
    {state:'Louisiana',amount:'85,490',profession:'Occupational Therapists'},
    {state:'Maine',amount:'72,160',profession:'Occupational Therapists'},
    {state:'Maryland',amount:'89,230',profession:'Occupational Therapists'},
    {state:'Massachusetts',amount:'87,160',profession:'Occupational Therapists'},
    {state:'Michigan',amount:'77,940',profession:'Occupational Therapists'},
    {state:'Minnesota',amount:'74,050',profession:'Occupational Therapists'},
    {state:'Mississippi',amount:'81,590',profession:'Occupational Therapists'},
    {state:'Missouri',amount:'75,120',profession:'Occupational Therapists'},
    {state:'Montana',amount:'74,940',profession:'Occupational Therapists'},
    {state:'Nebraska',amount:'76,850',profession:'Occupational Therapists'},
    {state:'Nevada',amount:'100,970',profession:'Occupational Therapists'},
    {state:'New Hampshire',amount:'79,850',profession:'Occupational Therapists'},
    {state:'New Jersey',amount:'96,600',profession:'Occupational Therapists'},
    {state:'New Mexico',amount:'81,660',profession:'Occupational Therapists'},
    {state:'New York',amount:'88,370',profession:'Occupational Therapists'},
    {state:'North Carolina',amount:'84,390',profession:'Occupational Therapists'},
    {state:'North Dakota',amount:'67,420',profession:'Occupational Therapists'},
    {state:'Ohio',amount:'85,720',profession:'Occupational Therapists'},
    {state:'Oklahoma',amount:'82,240',profession:'Occupational Therapists'},
    {state:'Oregon',amount:'90,720',profession:'Occupational Therapists'},
    {state:'Pennsylvania',amount:'81,030',profession:'Occupational Therapists'},
    {state:'Rhode Island',amount:'83,600',profession:'Occupational Therapists'},
    {state:'South Carolina',amount:'78,470',profession:'Occupational Therapists'},
    {state:'South Dakota',amount:'69,390',profession:'Occupational Therapists'},
    {state:'Tennessee',amount:'84,870',profession:'Occupational Therapists'},
    {state:'Texas',amount:'89,360',profession:'Occupational Therapists'},
    {state:'Utah',amount:'85,300',profession:'Occupational Therapists'},
    {state:'Vermont',amount:'76,840',profession:'Occupational Therapists'},
    {state:'Virginia',amount:'93,010',profession:'Occupational Therapists'},
    {state:'Washington',amount:'81,250',profession:'Occupational Therapists'},
    {state:'West Virginia',amount:'81,080',profession:'Occupational Therapists'},
    {state:'Wisconsin',amount:'73,390',profession:'Occupational Therapists'},
    {state:'Wyoming',amount:'82,010',profession:'Occupational Therapists'},
    {state:'Puerto Rico',amount:'39,720',profession:'Occupational Therapists'},
]

export default { info };